export const States =  [
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Badakhshan",
      "state_code": "BDS",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Badghis",
      "state_code": "BDG",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Baghlan",
      "state_code": "BGL",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Balkh",
      "state_code": "BAL",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Bamyan",
      "state_code": "BAM",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Daykundi",
      "state_code": "DAY",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Farah",
      "state_code": "FRA",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Faryab",
      "state_code": "FYB",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Ghazni",
      "state_code": "GHA",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Ghōr",
      "state_code": "GHO",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Helmand",
      "state_code": "HEL",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Herat",
      "state_code": "HER",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Jowzjan",
      "state_code": "JOW",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Kabul",
      "state_code": "KAB",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Kandahar",
      "state_code": "KAN",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Kapisa",
      "state_code": "KAP",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Khost",
      "state_code": "KHO",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Kunar",
      "state_code": "KNR",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Kunduz Province",
      "state_code": "KDZ",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Laghman",
      "state_code": "LAG",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Logar",
      "state_code": "LOG",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Nangarhar",
      "state_code": "NAN",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Nimruz",
      "state_code": "NIM",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Nuristan",
      "state_code": "NUR",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Paktia",
      "state_code": "PIA",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Paktika",
      "state_code": "PKA",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Panjshir",
      "state_code": "PAN",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Parwan",
      "state_code": "PAR",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Samangan",
      "state_code": "SAM",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Sar-e Pol",
      "state_code": "SAR",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Takhar",
      "state_code": "TAK",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Urozgan",
      "state_code": "URU",
      "country_id": 1
    },
    {
      "country_code": "AF",
      "country_name": "Afghanistan",
      "name": "Zabul",
      "state_code": "ZAB",
      "country_id": 1
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Berat County",
      "state_code": "01",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Berat District",
      "state_code": "BR",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Bulqizë District",
      "state_code": "BU",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Delvinë District",
      "state_code": "DL",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Devoll District",
      "state_code": "DV",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Dibër County",
      "state_code": "09",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Dibër District",
      "state_code": "DI",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Durrës County",
      "state_code": "02",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Durrës District",
      "state_code": "DR",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Elbasan County",
      "state_code": "03",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Fier County",
      "state_code": "04",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Fier District",
      "state_code": "FR",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Gjirokastër County",
      "state_code": "05",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Gjirokastër District",
      "state_code": "GJ",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Gramsh District",
      "state_code": "GR",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Has District",
      "state_code": "HA",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Kavajë District",
      "state_code": "KA",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Kolonjë District",
      "state_code": "ER",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Korçë County",
      "state_code": "06",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Korçë District",
      "state_code": "KO",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Krujë District",
      "state_code": "KR",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Kuçovë District",
      "state_code": "KC",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Kukës County",
      "state_code": "07",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Kukës District",
      "state_code": "KU",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Kurbin District",
      "state_code": "KB",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Lezhë County",
      "state_code": "08",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Lezhë District",
      "state_code": "LE",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Librazhd District",
      "state_code": "LB",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Lushnjë District",
      "state_code": "LU",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Malësi e Madhe District",
      "state_code": "MM",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Mallakastër District",
      "state_code": "MK",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Mat District",
      "state_code": "MT",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Mirditë District",
      "state_code": "MR",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Peqin District",
      "state_code": "PQ",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Përmet District",
      "state_code": "PR",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Pogradec District",
      "state_code": "PG",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Pukë District",
      "state_code": "PU",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Sarandë District",
      "state_code": "SR",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Shkodër County",
      "state_code": "10",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Shkodër District",
      "state_code": "SH",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Skrapar District",
      "state_code": "SK",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Tepelenë District",
      "state_code": "TE",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Tirana County",
      "state_code": "11",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Tirana District",
      "state_code": "TR",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Tropojë District",
      "state_code": "TP",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Vlorë County",
      "state_code": "12",
      "country_id": 3
    },
    {
      "country_code": "AL",
      "country_name": "Albania",
      "name": "Vlorë District",
      "state_code": "VL",
      "country_id": 3
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Adrar",
      "state_code": "01",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Aïn Defla",
      "state_code": "44",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Aïn Témouchent",
      "state_code": "46",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Algiers",
      "state_code": "16",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Annaba",
      "state_code": "23",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Batna",
      "state_code": "05",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Béchar",
      "state_code": "08",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Béjaïa",
      "state_code": "06",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Béni Abbès",
      "state_code": "53",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Biskra",
      "state_code": "07",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Blida",
      "state_code": "09",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Bordj Baji Mokhtar",
      "state_code": "52",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Bordj Bou Arréridj",
      "state_code": "34",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Bouïra",
      "state_code": "10",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Boumerdès",
      "state_code": "35",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Chlef",
      "state_code": "02",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Constantine",
      "state_code": "25",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Djanet",
      "state_code": "56",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Djelfa",
      "state_code": "17",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "El Bayadh",
      "state_code": "32",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "El M'ghair",
      "state_code": "49",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "El Menia",
      "state_code": "50",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "El Oued",
      "state_code": "39",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "El Tarf",
      "state_code": "36",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Ghardaïa",
      "state_code": "47",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Guelma",
      "state_code": "24",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Illizi",
      "state_code": "33",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "In Guezzam",
      "state_code": "58",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "In Salah",
      "state_code": "57",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Jijel",
      "state_code": "18",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Khenchela",
      "state_code": "40",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Laghouat",
      "state_code": "03",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "M'Sila",
      "state_code": "28",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Mascara",
      "state_code": "29",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Médéa",
      "state_code": "26",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Mila",
      "state_code": "43",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Mostaganem",
      "state_code": "27",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Naama",
      "state_code": "45",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Oran",
      "state_code": "31",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Ouargla",
      "state_code": "30",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Ouled Djellal",
      "state_code": "51",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Oum El Bouaghi",
      "state_code": "04",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Relizane",
      "state_code": "48",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Saïda",
      "state_code": "20",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Sétif",
      "state_code": "19",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Sidi Bel Abbès",
      "state_code": "22",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Skikda",
      "state_code": "21",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Souk Ahras",
      "state_code": "41",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Tamanghasset",
      "state_code": "11",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Tébessa",
      "state_code": "12",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Tiaret",
      "state_code": "14",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Timimoun",
      "state_code": "54",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Tindouf",
      "state_code": "37",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Tipasa",
      "state_code": "42",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Tissemsilt",
      "state_code": "38",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Tizi Ouzou",
      "state_code": "15",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Tlemcen",
      "state_code": "13",
      "country_id": 4
    },
    {
      "country_code": "DZ",
      "country_name": "Algeria",
      "name": "Touggourt",
      "state_code": "55",
      "country_id": 4
    },
    {
      "country_code": "AD",
      "country_name": "Andorra",
      "name": "Andorra la Vella",
      "state_code": "07",
      "country_id": 6
    },
    {
      "country_code": "AD",
      "country_name": "Andorra",
      "name": "Canillo",
      "state_code": "02",
      "country_id": 6
    },
    {
      "country_code": "AD",
      "country_name": "Andorra",
      "name": "Encamp",
      "state_code": "03",
      "country_id": 6
    },
    {
      "country_code": "AD",
      "country_name": "Andorra",
      "name": "Escaldes-Engordany",
      "state_code": "08",
      "country_id": 6
    },
    {
      "country_code": "AD",
      "country_name": "Andorra",
      "name": "La Massana",
      "state_code": "04",
      "country_id": 6
    },
    {
      "country_code": "AD",
      "country_name": "Andorra",
      "name": "Ordino",
      "state_code": "05",
      "country_id": 6
    },
    {
      "country_code": "AD",
      "country_name": "Andorra",
      "name": "Sant Julià de Lòria",
      "state_code": "06",
      "country_id": 6
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Bengo Province",
      "state_code": "BGO",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Benguela Province",
      "state_code": "BGU",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Bié Province",
      "state_code": "BIE",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Cabinda Province",
      "state_code": "CAB",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Cuando Cubango Province",
      "state_code": "CCU",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Cuanza Norte Province",
      "state_code": "CNO",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Cuanza Sul",
      "state_code": "CUS",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Cunene Province",
      "state_code": "CNN",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Huambo Province",
      "state_code": "HUA",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Huíla Province",
      "state_code": "HUI",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Luanda Province",
      "state_code": "LUA",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Lunda Norte Province",
      "state_code": "LNO",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Lunda Sul Province",
      "state_code": "LSU",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Malanje Province",
      "state_code": "MAL",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Moxico Province",
      "state_code": "MOX",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Uíge Province",
      "state_code": "UIG",
      "country_id": 7
    },
    {
      "country_code": "AO",
      "country_name": "Angola",
      "name": "Zaire Province",
      "state_code": "ZAI",
      "country_id": 7
    },
    {
      "country_code": "AG",
      "country_name": "Antigua And Barbuda",
      "name": "Barbuda",
      "state_code": "10",
      "country_id": 10
    },
    {
      "country_code": "AG",
      "country_name": "Antigua And Barbuda",
      "name": "Redonda",
      "state_code": "11",
      "country_id": 10
    },
    {
      "country_code": "AG",
      "country_name": "Antigua And Barbuda",
      "name": "Saint George Parish",
      "state_code": "03",
      "country_id": 10
    },
    {
      "country_code": "AG",
      "country_name": "Antigua And Barbuda",
      "name": "Saint John Parish",
      "state_code": "04",
      "country_id": 10
    },
    {
      "country_code": "AG",
      "country_name": "Antigua And Barbuda",
      "name": "Saint Mary Parish",
      "state_code": "05",
      "country_id": 10
    },
    {
      "country_code": "AG",
      "country_name": "Antigua And Barbuda",
      "name": "Saint Paul Parish",
      "state_code": "06",
      "country_id": 10
    },
    {
      "country_code": "AG",
      "country_name": "Antigua And Barbuda",
      "name": "Saint Peter Parish",
      "state_code": "07",
      "country_id": 10
    },
    {
      "country_code": "AG",
      "country_name": "Antigua And Barbuda",
      "name": "Saint Philip Parish",
      "state_code": "08",
      "country_id": 10
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Buenos Aires",
      "state_code": "B",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Catamarca",
      "state_code": "K",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Chaco",
      "state_code": "H",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Chubut",
      "state_code": "U",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Ciudad Autónoma de Buenos Aires",
      "state_code": "C",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Córdoba",
      "state_code": "X",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Corrientes",
      "state_code": "W",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Entre Ríos",
      "state_code": "E",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Formosa",
      "state_code": "P",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Jujuy",
      "state_code": "Y",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "La Pampa",
      "state_code": "L",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "La Rioja",
      "state_code": "F",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Mendoza",
      "state_code": "M",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Misiones",
      "state_code": "N",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Neuquén",
      "state_code": "Q",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Río Negro",
      "state_code": "R",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Salta",
      "state_code": "A",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "San Juan",
      "state_code": "J",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "San Luis",
      "state_code": "D",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Santa Cruz",
      "state_code": "Z",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Santa Fe",
      "state_code": "S",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Santiago del Estero",
      "state_code": "G",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Tierra del Fuego",
      "state_code": "V",
      "country_id": 11
    },
    {
      "country_code": "AR",
      "country_name": "Argentina",
      "name": "Tucumán",
      "state_code": "T",
      "country_id": 11
    },
    {
      "country_code": "AM",
      "country_name": "Armenia",
      "name": "Aragatsotn Region",
      "state_code": "AG",
      "country_id": 12
    },
    {
      "country_code": "AM",
      "country_name": "Armenia",
      "name": "Ararat Province",
      "state_code": "AR",
      "country_id": 12
    },
    {
      "country_code": "AM",
      "country_name": "Armenia",
      "name": "Armavir Region",
      "state_code": "AV",
      "country_id": 12
    },
    {
      "country_code": "AM",
      "country_name": "Armenia",
      "name": "Gegharkunik Province",
      "state_code": "GR",
      "country_id": 12
    },
    {
      "country_code": "AM",
      "country_name": "Armenia",
      "name": "Kotayk Region",
      "state_code": "KT",
      "country_id": 12
    },
    {
      "country_code": "AM",
      "country_name": "Armenia",
      "name": "Lori Region",
      "state_code": "LO",
      "country_id": 12
    },
    {
      "country_code": "AM",
      "country_name": "Armenia",
      "name": "Shirak Region",
      "state_code": "SH",
      "country_id": 12
    },
    {
      "country_code": "AM",
      "country_name": "Armenia",
      "name": "Syunik Province",
      "state_code": "SU",
      "country_id": 12
    },
    {
      "country_code": "AM",
      "country_name": "Armenia",
      "name": "Tavush Region",
      "state_code": "TV",
      "country_id": 12
    },
    {
      "country_code": "AM",
      "country_name": "Armenia",
      "name": "Vayots Dzor Region",
      "state_code": "VD",
      "country_id": 12
    },
    {
      "country_code": "AM",
      "country_name": "Armenia",
      "name": "Yerevan",
      "state_code": "ER",
      "country_id": 12
    },
    {
      "country_code": "AU",
      "country_name": "Australia",
      "name": "Australian Capital Territory",
      "state_code": "ACT",
      "country_id": 14
    },
    {
      "country_code": "AU",
      "country_name": "Australia",
      "name": "New South Wales",
      "state_code": "NSW",
      "country_id": 14
    },
    {
      "country_code": "AU",
      "country_name": "Australia",
      "name": "Northern Territory",
      "state_code": "NT",
      "country_id": 14
    },
    {
      "country_code": "AU",
      "country_name": "Australia",
      "name": "Queensland",
      "state_code": "QLD",
      "country_id": 14
    },
    {
      "country_code": "AU",
      "country_name": "Australia",
      "name": "South Australia",
      "state_code": "SA",
      "country_id": 14
    },
    {
      "country_code": "AU",
      "country_name": "Australia",
      "name": "Tasmania",
      "state_code": "TAS",
      "country_id": 14
    },
    {
      "country_code": "AU",
      "country_name": "Australia",
      "name": "Victoria",
      "state_code": "VIC",
      "country_id": 14
    },
    {
      "country_code": "AU",
      "country_name": "Australia",
      "name": "Western Australia",
      "state_code": "WA",
      "country_id": 14
    },
    {
      "country_code": "AT",
      "country_name": "Austria",
      "name": "Burgenland",
      "state_code": "1",
      "country_id": 15
    },
    {
      "country_code": "AT",
      "country_name": "Austria",
      "name": "Carinthia",
      "state_code": "2",
      "country_id": 15
    },
    {
      "country_code": "AT",
      "country_name": "Austria",
      "name": "Lower Austria",
      "state_code": "3",
      "country_id": 15
    },
    {
      "country_code": "AT",
      "country_name": "Austria",
      "name": "Salzburg",
      "state_code": "5",
      "country_id": 15
    },
    {
      "country_code": "AT",
      "country_name": "Austria",
      "name": "Styria",
      "state_code": "6",
      "country_id": 15
    },
    {
      "country_code": "AT",
      "country_name": "Austria",
      "name": "Tyrol",
      "state_code": "7",
      "country_id": 15
    },
    {
      "country_code": "AT",
      "country_name": "Austria",
      "name": "Upper Austria",
      "state_code": "4",
      "country_id": 15
    },
    {
      "country_code": "AT",
      "country_name": "Austria",
      "name": "Vienna",
      "state_code": "9",
      "country_id": 15
    },
    {
      "country_code": "AT",
      "country_name": "Austria",
      "name": "Vorarlberg",
      "state_code": "8",
      "country_id": 15
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Absheron District",
      "state_code": "ABS",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Agdam District",
      "state_code": "AGM",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Agdash District",
      "state_code": "AGS",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Aghjabadi District",
      "state_code": "AGC",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Agstafa District",
      "state_code": "AGA",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Agsu District",
      "state_code": "AGU",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Astara District",
      "state_code": "AST",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Babek District",
      "state_code": "BAB",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Baku",
      "state_code": "BA",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Balakan District",
      "state_code": "BAL",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Barda District",
      "state_code": "BAR",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Beylagan District",
      "state_code": "BEY",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Bilasuvar District",
      "state_code": "BIL",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Dashkasan District",
      "state_code": "DAS",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Fizuli District",
      "state_code": "FUZ",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Ganja",
      "state_code": "GA",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Gədəbəy",
      "state_code": "GAD",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Gobustan District",
      "state_code": "QOB",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Goranboy District",
      "state_code": "GOR",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Goychay",
      "state_code": "GOY",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Goygol District",
      "state_code": "GYG",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Hajigabul District",
      "state_code": "HAC",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Imishli District",
      "state_code": "IMI",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Ismailli District",
      "state_code": "ISM",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Jabrayil District",
      "state_code": "CAB",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Jalilabad District",
      "state_code": "CAL",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Julfa District",
      "state_code": "CUL",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Kalbajar District",
      "state_code": "KAL",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Kangarli District",
      "state_code": "KAN",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Khachmaz District",
      "state_code": "XAC",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Khizi District",
      "state_code": "XIZ",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Khojali District",
      "state_code": "XCI",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Kurdamir District",
      "state_code": "KUR",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Lachin District",
      "state_code": "LAC",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Lankaran",
      "state_code": "LAN",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Lankaran District",
      "state_code": "LA",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Lerik District",
      "state_code": "LER",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Martuni",
      "state_code": "XVD",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Masally District",
      "state_code": "MAS",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Mingachevir",
      "state_code": "MI",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Nakhchivan Autonomous Republic",
      "state_code": "NX",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Neftchala District",
      "state_code": "NEF",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Oghuz District",
      "state_code": "OGU",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Ordubad District",
      "state_code": "ORD",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Qabala District",
      "state_code": "QAB",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Qakh District",
      "state_code": "QAX",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Qazakh District",
      "state_code": "QAZ",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Quba District",
      "state_code": "QBA",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Qubadli District",
      "state_code": "QBI",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Qusar District",
      "state_code": "QUS",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Saatly District",
      "state_code": "SAT",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Sabirabad District",
      "state_code": "SAB",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Sadarak District",
      "state_code": "SAD",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Salyan District",
      "state_code": "SAL",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Samukh District",
      "state_code": "SMX",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Shabran District",
      "state_code": "SBN",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Shahbuz District",
      "state_code": "SAH",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Shaki",
      "state_code": "SA",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Shaki District",
      "state_code": "SAK",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Shamakhi District",
      "state_code": "SMI",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Shamkir District",
      "state_code": "SKR",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Sharur District",
      "state_code": "SAR",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Shirvan",
      "state_code": "SR",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Shusha District",
      "state_code": "SUS",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Siazan District",
      "state_code": "SIY",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Sumqayit",
      "state_code": "SM",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Tartar District",
      "state_code": "TAR",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Tovuz District",
      "state_code": "TOV",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Ujar District",
      "state_code": "UCA",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Yardymli District",
      "state_code": "YAR",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Yevlakh",
      "state_code": "YE",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Yevlakh District",
      "state_code": "YEV",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Zangilan District",
      "state_code": "ZAN",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Zaqatala District",
      "state_code": "ZAQ",
      "country_id": 16
    },
    {
      "country_code": "AZ",
      "country_name": "Azerbaijan",
      "name": "Zardab District",
      "state_code": "ZAR",
      "country_id": 16
    },
    {
      "country_code": "BH",
      "country_name": "Bahrain",
      "name": "Capital",
      "state_code": "13",
      "country_id": 18
    },
    {
      "country_code": "BH",
      "country_name": "Bahrain",
      "name": "Central",
      "state_code": "16",
      "country_id": 18
    },
    {
      "country_code": "BH",
      "country_name": "Bahrain",
      "name": "Muharraq",
      "state_code": "15",
      "country_id": 18
    },
    {
      "country_code": "BH",
      "country_name": "Bahrain",
      "name": "Northern",
      "state_code": "17",
      "country_id": 18
    },
    {
      "country_code": "BH",
      "country_name": "Bahrain",
      "name": "Southern",
      "state_code": "14",
      "country_id": 18
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Bagerhat District",
      "state_code": "05",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Bahadia",
      "state_code": "33",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Bandarban District",
      "state_code": "01",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Barguna District",
      "state_code": "02",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Barisal District",
      "state_code": "06",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Barisal Division",
      "state_code": "A",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Bhola District",
      "state_code": "07",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Bogra District",
      "state_code": "03",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Brahmanbaria District",
      "state_code": "04",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Chandpur District",
      "state_code": "09",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Chapai Nawabganj District",
      "state_code": "45",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Chittagong District",
      "state_code": "10",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Chittagong Division",
      "state_code": "B",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Chuadanga District",
      "state_code": "12",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Comilla District",
      "state_code": "08",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Cox's Bazar District",
      "state_code": "11",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Dhaka District",
      "state_code": "13",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Dhaka Division",
      "state_code": "C",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Dinajpur District",
      "state_code": "14",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Faridpur District",
      "state_code": "15",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Feni District",
      "state_code": "16",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Gaibandha District",
      "state_code": "19",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Gazipur District",
      "state_code": "18",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Gopalganj District",
      "state_code": "17",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Habiganj District",
      "state_code": "20",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Jamalpur District",
      "state_code": "21",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Jessore District",
      "state_code": "22",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Jhalokati District",
      "state_code": "25",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Jhenaidah District",
      "state_code": "23",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Joypurhat District",
      "state_code": "24",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Khagrachari District",
      "state_code": "29",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Khulna District",
      "state_code": "27",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Khulna Division",
      "state_code": "D",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Kishoreganj District",
      "state_code": "26",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Kurigram District",
      "state_code": "28",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Kushtia District",
      "state_code": "30",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Lakshmipur District",
      "state_code": "31",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Lalmonirhat District",
      "state_code": "32",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Madaripur District",
      "state_code": "36",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Meherpur District",
      "state_code": "39",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Moulvibazar District",
      "state_code": "38",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Munshiganj District",
      "state_code": "35",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Mymensingh District",
      "state_code": "34",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Mymensingh Division",
      "state_code": "H",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Naogaon District",
      "state_code": "48",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Narail District",
      "state_code": "43",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Narayanganj District",
      "state_code": "40",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Natore District",
      "state_code": "44",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Netrokona District",
      "state_code": "41",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Nilphamari District",
      "state_code": "46",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Noakhali District",
      "state_code": "47",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Pabna District",
      "state_code": "49",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Panchagarh District",
      "state_code": "52",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Patuakhali District",
      "state_code": "51",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Pirojpur District",
      "state_code": "50",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Rajbari District",
      "state_code": "53",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Rajshahi District",
      "state_code": "54",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Rajshahi Division",
      "state_code": "E",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Rangamati Hill District",
      "state_code": "56",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Rangpur District",
      "state_code": "55",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Rangpur Division",
      "state_code": "F",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Satkhira District",
      "state_code": "58",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Shariatpur District",
      "state_code": "62",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Sherpur District",
      "state_code": "57",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Sirajganj District",
      "state_code": "59",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Sunamganj District",
      "state_code": "61",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Sylhet District",
      "state_code": "60",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Sylhet Division",
      "state_code": "G",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Tangail District",
      "state_code": "63",
      "country_id": 19
    },
    {
      "country_code": "BD",
      "country_name": "Bangladesh",
      "name": "Thakurgaon District",
      "state_code": "64",
      "country_id": 19
    },
    {
      "country_code": "BB",
      "country_name": "Barbados",
      "name": "Christ Church",
      "state_code": "01",
      "country_id": 20
    },
    {
      "country_code": "BB",
      "country_name": "Barbados",
      "name": "Saint Andrew",
      "state_code": "02",
      "country_id": 20
    },
    {
      "country_code": "BB",
      "country_name": "Barbados",
      "name": "Saint George",
      "state_code": "03",
      "country_id": 20
    },
    {
      "country_code": "BB",
      "country_name": "Barbados",
      "name": "Saint James",
      "state_code": "04",
      "country_id": 20
    },
    {
      "country_code": "BB",
      "country_name": "Barbados",
      "name": "Saint John",
      "state_code": "05",
      "country_id": 20
    },
    {
      "country_code": "BB",
      "country_name": "Barbados",
      "name": "Saint Joseph",
      "state_code": "06",
      "country_id": 20
    },
    {
      "country_code": "BB",
      "country_name": "Barbados",
      "name": "Saint Lucy",
      "state_code": "07",
      "country_id": 20
    },
    {
      "country_code": "BB",
      "country_name": "Barbados",
      "name": "Saint Michael",
      "state_code": "08",
      "country_id": 20
    },
    {
      "country_code": "BB",
      "country_name": "Barbados",
      "name": "Saint Peter",
      "state_code": "09",
      "country_id": 20
    },
    {
      "country_code": "BB",
      "country_name": "Barbados",
      "name": "Saint Philip",
      "state_code": "10",
      "country_id": 20
    },
    {
      "country_code": "BB",
      "country_name": "Barbados",
      "name": "Saint Thomas",
      "state_code": "11",
      "country_id": 20
    },
    {
      "country_code": "BY",
      "country_name": "Belarus",
      "name": "Brest Region",
      "state_code": "BR",
      "country_id": 21
    },
    {
      "country_code": "BY",
      "country_name": "Belarus",
      "name": "Gomel Region",
      "state_code": "HO",
      "country_id": 21
    },
    {
      "country_code": "BY",
      "country_name": "Belarus",
      "name": "Grodno Region",
      "state_code": "HR",
      "country_id": 21
    },
    {
      "country_code": "BY",
      "country_name": "Belarus",
      "name": "Minsk",
      "state_code": "HM",
      "country_id": 21
    },
    {
      "country_code": "BY",
      "country_name": "Belarus",
      "name": "Minsk Region",
      "state_code": "MI",
      "country_id": 21
    },
    {
      "country_code": "BY",
      "country_name": "Belarus",
      "name": "Mogilev Region",
      "state_code": "MA",
      "country_id": 21
    },
    {
      "country_code": "BY",
      "country_name": "Belarus",
      "name": "Vitebsk Region",
      "state_code": "VI",
      "country_id": 21
    },
    {
      "country_code": "BE",
      "country_name": "Belgium",
      "name": "Antwerp",
      "state_code": "VAN",
      "country_id": 22
    },
    {
      "country_code": "BE",
      "country_name": "Belgium",
      "name": "Brussels-Capital Region",
      "state_code": "BRU",
      "country_id": 22
    },
    {
      "country_code": "BE",
      "country_name": "Belgium",
      "name": "East Flanders",
      "state_code": "VOV",
      "country_id": 22
    },
    {
      "country_code": "BE",
      "country_name": "Belgium",
      "name": "Flanders",
      "state_code": "VLG",
      "country_id": 22
    },
    {
      "country_code": "BE",
      "country_name": "Belgium",
      "name": "Flemish Brabant",
      "state_code": "VBR",
      "country_id": 22
    },
    {
      "country_code": "BE",
      "country_name": "Belgium",
      "name": "Hainaut",
      "state_code": "WHT",
      "country_id": 22
    },
    {
      "country_code": "BE",
      "country_name": "Belgium",
      "name": "Liège",
      "state_code": "WLG",
      "country_id": 22
    },
    {
      "country_code": "BE",
      "country_name": "Belgium",
      "name": "Limburg",
      "state_code": "VLI",
      "country_id": 22
    },
    {
      "country_code": "BE",
      "country_name": "Belgium",
      "name": "Luxembourg",
      "state_code": "WLX",
      "country_id": 22
    },
    {
      "country_code": "BE",
      "country_name": "Belgium",
      "name": "Namur",
      "state_code": "WNA",
      "country_id": 22
    },
    {
      "country_code": "BE",
      "country_name": "Belgium",
      "name": "Wallonia",
      "state_code": "WAL",
      "country_id": 22
    },
    {
      "country_code": "BE",
      "country_name": "Belgium",
      "name": "Walloon Brabant",
      "state_code": "WBR",
      "country_id": 22
    },
    {
      "country_code": "BE",
      "country_name": "Belgium",
      "name": "West Flanders",
      "state_code": "VWV",
      "country_id": 22
    },
    {
      "country_code": "BZ",
      "country_name": "Belize",
      "name": "Belize District",
      "state_code": "BZ",
      "country_id": 23
    },
    {
      "country_code": "BZ",
      "country_name": "Belize",
      "name": "Cayo District",
      "state_code": "CY",
      "country_id": 23
    },
    {
      "country_code": "BZ",
      "country_name": "Belize",
      "name": "Corozal District",
      "state_code": "CZL",
      "country_id": 23
    },
    {
      "country_code": "BZ",
      "country_name": "Belize",
      "name": "Orange Walk District",
      "state_code": "OW",
      "country_id": 23
    },
    {
      "country_code": "BZ",
      "country_name": "Belize",
      "name": "Stann Creek District",
      "state_code": "SC",
      "country_id": 23
    },
    {
      "country_code": "BZ",
      "country_name": "Belize",
      "name": "Toledo District",
      "state_code": "TOL",
      "country_id": 23
    },
    {
      "country_code": "BJ",
      "country_name": "Benin",
      "name": "Alibori Department",
      "state_code": "AL",
      "country_id": 24
    },
    {
      "country_code": "BJ",
      "country_name": "Benin",
      "name": "Atakora Department",
      "state_code": "AK",
      "country_id": 24
    },
    {
      "country_code": "BJ",
      "country_name": "Benin",
      "name": "Atlantique Department",
      "state_code": "AQ",
      "country_id": 24
    },
    {
      "country_code": "BJ",
      "country_name": "Benin",
      "name": "Borgou Department",
      "state_code": "BO",
      "country_id": 24
    },
    {
      "country_code": "BJ",
      "country_name": "Benin",
      "name": "Collines Department",
      "state_code": "CO",
      "country_id": 24
    },
    {
      "country_code": "BJ",
      "country_name": "Benin",
      "name": "Donga Department",
      "state_code": "DO",
      "country_id": 24
    },
    {
      "country_code": "BJ",
      "country_name": "Benin",
      "name": "Kouffo Department",
      "state_code": "KO",
      "country_id": 24
    },
    {
      "country_code": "BJ",
      "country_name": "Benin",
      "name": "Littoral Department",
      "state_code": "LI",
      "country_id": 24
    },
    {
      "country_code": "BJ",
      "country_name": "Benin",
      "name": "Mono Department",
      "state_code": "MO",
      "country_id": 24
    },
    {
      "country_code": "BJ",
      "country_name": "Benin",
      "name": "Ouémé Department",
      "state_code": "OU",
      "country_id": 24
    },
    {
      "country_code": "BJ",
      "country_name": "Benin",
      "name": "Plateau Department",
      "state_code": "PL",
      "country_id": 24
    },
    {
      "country_code": "BJ",
      "country_name": "Benin",
      "name": "Zou Department",
      "state_code": "ZO",
      "country_id": 24
    },
    {
      "country_code": "BM",
      "country_name": "Bermuda",
      "name": "Devonshire Parish",
      "state_code": "DEV",
      "country_id": 25
    },
    {
      "country_code": "BM",
      "country_name": "Bermuda",
      "name": "Hamilton Parish",
      "state_code": "HA",
      "country_id": 25
    },
    {
      "country_code": "BM",
      "country_name": "Bermuda",
      "name": "Paget Parish",
      "state_code": "PAG",
      "country_id": 25
    },
    {
      "country_code": "BM",
      "country_name": "Bermuda",
      "name": "Pembroke Parish",
      "state_code": "PEM",
      "country_id": 25
    },
    {
      "country_code": "BM",
      "country_name": "Bermuda",
      "name": "Saint George's Parish",
      "state_code": "SGE",
      "country_id": 25
    },
    {
      "country_code": "BM",
      "country_name": "Bermuda",
      "name": "Sandys Parish",
      "state_code": "SAN",
      "country_id": 25
    },
    {
      "country_code": "BM",
      "country_name": "Bermuda",
      "name": "Smith's Parish,",
      "state_code": "SMI",
      "country_id": 25
    },
    {
      "country_code": "BM",
      "country_name": "Bermuda",
      "name": "Southampton Parish",
      "state_code": "SOU",
      "country_id": 25
    },
    {
      "country_code": "BM",
      "country_name": "Bermuda",
      "name": "Warwick Parish",
      "state_code": "WAR",
      "country_id": 25
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Bumthang District",
      "state_code": "33",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Chukha District",
      "state_code": "12",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Dagana District",
      "state_code": "22",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Gasa District",
      "state_code": "GA",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Haa District",
      "state_code": "13",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Lhuntse District",
      "state_code": "44",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Mongar District",
      "state_code": "42",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Paro District",
      "state_code": "11",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Pemagatshel District",
      "state_code": "43",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Punakha District",
      "state_code": "23",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Samdrup Jongkhar District",
      "state_code": "45",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Samtse District",
      "state_code": "14",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Sarpang District",
      "state_code": "31",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Thimphu District",
      "state_code": "15",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Trashigang District",
      "state_code": "41",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Trongsa District",
      "state_code": "32",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Tsirang District",
      "state_code": "21",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Wangdue Phodrang District",
      "state_code": "24",
      "country_id": 26
    },
    {
      "country_code": "BT",
      "country_name": "Bhutan",
      "name": "Zhemgang District",
      "state_code": "34",
      "country_id": 26
    },
    {
      "country_code": "BO",
      "country_name": "Bolivia",
      "name": "Beni Department",
      "state_code": "B",
      "country_id": 27
    },
    {
      "country_code": "BO",
      "country_name": "Bolivia",
      "name": "Chuquisaca Department",
      "state_code": "H",
      "country_id": 27
    },
    {
      "country_code": "BO",
      "country_name": "Bolivia",
      "name": "Cochabamba Department",
      "state_code": "C",
      "country_id": 27
    },
    {
      "country_code": "BO",
      "country_name": "Bolivia",
      "name": "La Paz Department",
      "state_code": "L",
      "country_id": 27
    },
    {
      "country_code": "BO",
      "country_name": "Bolivia",
      "name": "Oruro Department",
      "state_code": "O",
      "country_id": 27
    },
    {
      "country_code": "BO",
      "country_name": "Bolivia",
      "name": "Pando Department",
      "state_code": "N",
      "country_id": 27
    },
    {
      "country_code": "BO",
      "country_name": "Bolivia",
      "name": "Potosí Department",
      "state_code": "P",
      "country_id": 27
    },
    {
      "country_code": "BO",
      "country_name": "Bolivia",
      "name": "Santa Cruz Department",
      "state_code": "S",
      "country_id": 27
    },
    {
      "country_code": "BO",
      "country_name": "Bolivia",
      "name": "Tarija Department",
      "state_code": "T",
      "country_id": 27
    },
    {
      "country_code": "BQ",
      "country_name": "Bonaire, Sint Eustatius and Saba",
      "name": "Bonaire",
      "state_code": "BQ1",
      "country_id": 155
    },
    {
      "country_code": "BQ",
      "country_name": "Bonaire, Sint Eustatius and Saba",
      "name": "Saba",
      "state_code": "BQ2",
      "country_id": 155
    },
    {
      "country_code": "BQ",
      "country_name": "Bonaire, Sint Eustatius and Saba",
      "name": "Sint Eustatius",
      "state_code": "BQ3",
      "country_id": 155
    },
    {
      "country_code": "BA",
      "country_name": "Bosnia and Herzegovina",
      "name": "Bosnian Podrinje Canton",
      "state_code": "05",
      "country_id": 28
    },
    {
      "country_code": "BA",
      "country_name": "Bosnia and Herzegovina",
      "name": "Brčko District",
      "state_code": "BRC",
      "country_id": 28
    },
    {
      "country_code": "BA",
      "country_name": "Bosnia and Herzegovina",
      "name": "Canton 10",
      "state_code": "10",
      "country_id": 28
    },
    {
      "country_code": "BA",
      "country_name": "Bosnia and Herzegovina",
      "name": "Central Bosnia Canton",
      "state_code": "06",
      "country_id": 28
    },
    {
      "country_code": "BA",
      "country_name": "Bosnia and Herzegovina",
      "name": "Federation of Bosnia and Herzegovina",
      "state_code": "BIH",
      "country_id": 28
    },
    {
      "country_code": "BA",
      "country_name": "Bosnia and Herzegovina",
      "name": "Herzegovina-Neretva Canton",
      "state_code": "07",
      "country_id": 28
    },
    {
      "country_code": "BA",
      "country_name": "Bosnia and Herzegovina",
      "name": "Posavina Canton",
      "state_code": "02",
      "country_id": 28
    },
    {
      "country_code": "BA",
      "country_name": "Bosnia and Herzegovina",
      "name": "Republika Srpska",
      "state_code": "SRP",
      "country_id": 28
    },
    {
      "country_code": "BA",
      "country_name": "Bosnia and Herzegovina",
      "name": "Sarajevo Canton",
      "state_code": "09",
      "country_id": 28
    },
    {
      "country_code": "BA",
      "country_name": "Bosnia and Herzegovina",
      "name": "Tuzla Canton",
      "state_code": "03",
      "country_id": 28
    },
    {
      "country_code": "BA",
      "country_name": "Bosnia and Herzegovina",
      "name": "Una-Sana Canton",
      "state_code": "01",
      "country_id": 28
    },
    {
      "country_code": "BA",
      "country_name": "Bosnia and Herzegovina",
      "name": "West Herzegovina Canton",
      "state_code": "08",
      "country_id": 28
    },
    {
      "country_code": "BA",
      "country_name": "Bosnia and Herzegovina",
      "name": "Zenica-Doboj Canton",
      "state_code": "04",
      "country_id": 28
    },
    {
      "country_code": "BW",
      "country_name": "Botswana",
      "name": "Central District",
      "state_code": "CE",
      "country_id": 29
    },
    {
      "country_code": "BW",
      "country_name": "Botswana",
      "name": "Ghanzi District",
      "state_code": "GH",
      "country_id": 29
    },
    {
      "country_code": "BW",
      "country_name": "Botswana",
      "name": "Kgalagadi District",
      "state_code": "KG",
      "country_id": 29
    },
    {
      "country_code": "BW",
      "country_name": "Botswana",
      "name": "Kgatleng District",
      "state_code": "KL",
      "country_id": 29
    },
    {
      "country_code": "BW",
      "country_name": "Botswana",
      "name": "Kweneng District",
      "state_code": "KW",
      "country_id": 29
    },
    {
      "country_code": "BW",
      "country_name": "Botswana",
      "name": "Ngamiland",
      "state_code": "NG",
      "country_id": 29
    },
    {
      "country_code": "BW",
      "country_name": "Botswana",
      "name": "North-East District",
      "state_code": "NE",
      "country_id": 29
    },
    {
      "country_code": "BW",
      "country_name": "Botswana",
      "name": "North-West District",
      "state_code": "NW",
      "country_id": 29
    },
    {
      "country_code": "BW",
      "country_name": "Botswana",
      "name": "South-East District",
      "state_code": "SE",
      "country_id": 29
    },
    {
      "country_code": "BW",
      "country_name": "Botswana",
      "name": "Southern District",
      "state_code": "SO",
      "country_id": 29
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Acre",
      "state_code": "AC",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Alagoas",
      "state_code": "AL",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Amapá",
      "state_code": "AP",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Amazonas",
      "state_code": "AM",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Bahia",
      "state_code": "BA",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Ceará",
      "state_code": "CE",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Distrito Federal",
      "state_code": "DF",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Espírito Santo",
      "state_code": "ES",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Goiás",
      "state_code": "GO",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Maranhão",
      "state_code": "MA",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Mato Grosso",
      "state_code": "MT",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Mato Grosso do Sul",
      "state_code": "MS",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Minas Gerais",
      "state_code": "MG",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Pará",
      "state_code": "PA",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Paraíba",
      "state_code": "PB",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Paraná",
      "state_code": "PR",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Pernambuco",
      "state_code": "PE",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Piauí",
      "state_code": "PI",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Rio de Janeiro",
      "state_code": "RJ",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Rio Grande do Norte",
      "state_code": "RN",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Rio Grande do Sul",
      "state_code": "RS",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Rondônia",
      "state_code": "RO",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Roraima",
      "state_code": "RR",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Santa Catarina",
      "state_code": "SC",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "São Paulo",
      "state_code": "SP",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Sergipe",
      "state_code": "SE",
      "country_id": 31
    },
    {
      "country_code": "BR",
      "country_name": "Brazil",
      "name": "Tocantins",
      "state_code": "TO",
      "country_id": 31
    },
    {
      "country_code": "BN",
      "country_name": "Brunei",
      "name": "Belait District",
      "state_code": "BE",
      "country_id": 33
    },
    {
      "country_code": "BN",
      "country_name": "Brunei",
      "name": "Brunei-Muara District",
      "state_code": "BM",
      "country_id": 33
    },
    {
      "country_code": "BN",
      "country_name": "Brunei",
      "name": "Temburong District",
      "state_code": "TE",
      "country_id": 33
    },
    {
      "country_code": "BN",
      "country_name": "Brunei",
      "name": "Tutong District",
      "state_code": "TU",
      "country_id": 33
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Blagoevgrad Province",
      "state_code": "01",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Burgas Province",
      "state_code": "02",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Dobrich Province",
      "state_code": "08",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Gabrovo Province",
      "state_code": "07",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Haskovo Province",
      "state_code": "26",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Kardzhali Province",
      "state_code": "09",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Kyustendil Province",
      "state_code": "10",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Lovech Province",
      "state_code": "11",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Montana Province",
      "state_code": "12",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Pazardzhik Province",
      "state_code": "13",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Pernik Province",
      "state_code": "14",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Pleven Province",
      "state_code": "15",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Plovdiv Province",
      "state_code": "16",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Razgrad Province",
      "state_code": "17",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Ruse Province",
      "state_code": "18",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Shumen",
      "state_code": "27",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Silistra Province",
      "state_code": "19",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Sliven Province",
      "state_code": "20",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Smolyan Province",
      "state_code": "21",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Sofia City Province",
      "state_code": "22",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Sofia Province",
      "state_code": "23",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Stara Zagora Province",
      "state_code": "24",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Targovishte Province",
      "state_code": "25",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Varna Province",
      "state_code": "03",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Veliko Tarnovo Province",
      "state_code": "04",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Vidin Province",
      "state_code": "05",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Vratsa Province",
      "state_code": "06",
      "country_id": 34
    },
    {
      "country_code": "BG",
      "country_name": "Bulgaria",
      "name": "Yambol Province",
      "state_code": "28",
      "country_id": 34
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Balé Province",
      "state_code": "BAL",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Bam Province",
      "state_code": "BAM",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Banwa Province",
      "state_code": "BAN",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Bazèga Province",
      "state_code": "BAZ",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Boucle du Mouhoun Region",
      "state_code": "01",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Bougouriba Province",
      "state_code": "BGR",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Boulgou",
      "state_code": "BLG",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Cascades Region",
      "state_code": "02",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Centre",
      "state_code": "03",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Centre-Est Region",
      "state_code": "04",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Centre-Nord Region",
      "state_code": "05",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Centre-Ouest Region",
      "state_code": "06",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Centre-Sud Region",
      "state_code": "07",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Comoé Province",
      "state_code": "COM",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Est Region",
      "state_code": "08",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Ganzourgou Province",
      "state_code": "GAN",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Gnagna Province",
      "state_code": "GNA",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Gourma Province",
      "state_code": "GOU",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Hauts-Bassins Region",
      "state_code": "09",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Houet Province",
      "state_code": "HOU",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Ioba Province",
      "state_code": "IOB",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Kadiogo Province",
      "state_code": "KAD",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Kénédougou Province",
      "state_code": "KEN",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Komondjari Province",
      "state_code": "KMD",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Kompienga Province",
      "state_code": "KMP",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Kossi Province",
      "state_code": "KOS",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Koulpélogo Province",
      "state_code": "KOP",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Kouritenga Province",
      "state_code": "KOT",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Kourwéogo Province",
      "state_code": "KOW",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Léraba Province",
      "state_code": "LER",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Loroum Province",
      "state_code": "LOR",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Mouhoun",
      "state_code": "MOU",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Nahouri Province",
      "state_code": "NAO",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Namentenga Province",
      "state_code": "NAM",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Nayala Province",
      "state_code": "NAY",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Nord Region, Burkina Faso",
      "state_code": "10",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Noumbiel Province",
      "state_code": "NOU",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Oubritenga Province",
      "state_code": "OUB",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Oudalan Province",
      "state_code": "OUD",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Passoré Province",
      "state_code": "PAS",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Plateau-Central Region",
      "state_code": "11",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Poni Province",
      "state_code": "PON",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Sahel Region",
      "state_code": "12",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Sanguié Province",
      "state_code": "SNG",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Sanmatenga Province",
      "state_code": "SMT",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Séno Province",
      "state_code": "SEN",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Sissili Province",
      "state_code": "SIS",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Soum Province",
      "state_code": "SOM",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Sourou Province",
      "state_code": "SOR",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Sud-Ouest Region",
      "state_code": "13",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Tapoa Province",
      "state_code": "TAP",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Tuy Province",
      "state_code": "TUI",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Yagha Province",
      "state_code": "YAG",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Yatenga Province",
      "state_code": "YAT",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Ziro Province",
      "state_code": "ZIR",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Zondoma Province",
      "state_code": "ZON",
      "country_id": 35
    },
    {
      "country_code": "BF",
      "country_name": "Burkina Faso",
      "name": "Zoundwéogo Province",
      "state_code": "ZOU",
      "country_id": 35
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Bubanza Province",
      "state_code": "BB",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Bujumbura Mairie Province",
      "state_code": "BM",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Bujumbura Rural Province",
      "state_code": "BL",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Bururi Province",
      "state_code": "BR",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Cankuzo Province",
      "state_code": "CA",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Cibitoke Province",
      "state_code": "CI",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Gitega Province",
      "state_code": "GI",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Karuzi Province",
      "state_code": "KR",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Kayanza Province",
      "state_code": "KY",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Kirundo Province",
      "state_code": "KI",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Makamba Province",
      "state_code": "MA",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Muramvya Province",
      "state_code": "MU",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Muyinga Province",
      "state_code": "MY",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Mwaro Province",
      "state_code": "MW",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Ngozi Province",
      "state_code": "NG",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Rumonge Province",
      "state_code": "RM",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Rutana Province",
      "state_code": "RT",
      "country_id": 36
    },
    {
      "country_code": "BI",
      "country_name": "Burundi",
      "name": "Ruyigi Province",
      "state_code": "RY",
      "country_id": 36
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Banteay Meanchey",
      "state_code": "1",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Battambang",
      "state_code": "2",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Kampong Cham",
      "state_code": "3",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Kampong Chhnang",
      "state_code": "4",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Kampong Speu",
      "state_code": "5",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Kampong Thom",
      "state_code": "6",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Kampot",
      "state_code": "7",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Kandal",
      "state_code": "8",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Kep",
      "state_code": "23",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Koh Kong",
      "state_code": "9",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Kratie",
      "state_code": "10",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Mondulkiri",
      "state_code": "11",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Oddar Meanchey",
      "state_code": "22",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Pailin",
      "state_code": "24",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Phnom Penh",
      "state_code": "12",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Preah Vihear",
      "state_code": "13",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Prey Veng",
      "state_code": "14",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Pursat",
      "state_code": "15",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Ratanakiri",
      "state_code": "16",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Siem Reap",
      "state_code": "17",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Sihanoukville",
      "state_code": "18",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Stung Treng",
      "state_code": "19",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Svay Rieng",
      "state_code": "20",
      "country_id": 37
    },
    {
      "country_code": "KH",
      "country_name": "Cambodia",
      "name": "Takeo",
      "state_code": "21",
      "country_id": 37
    },
    {
      "country_code": "CM",
      "country_name": "Cameroon",
      "name": "Adamawa",
      "state_code": "AD",
      "country_id": 38
    },
    {
      "country_code": "CM",
      "country_name": "Cameroon",
      "name": "Centre",
      "state_code": "CE",
      "country_id": 38
    },
    {
      "country_code": "CM",
      "country_name": "Cameroon",
      "name": "East",
      "state_code": "ES",
      "country_id": 38
    },
    {
      "country_code": "CM",
      "country_name": "Cameroon",
      "name": "Far North",
      "state_code": "EN",
      "country_id": 38
    },
    {
      "country_code": "CM",
      "country_name": "Cameroon",
      "name": "Littoral",
      "state_code": "LT",
      "country_id": 38
    },
    {
      "country_code": "CM",
      "country_name": "Cameroon",
      "name": "North",
      "state_code": "NO",
      "country_id": 38
    },
    {
      "country_code": "CM",
      "country_name": "Cameroon",
      "name": "Northwest",
      "state_code": "NW",
      "country_id": 38
    },
    {
      "country_code": "CM",
      "country_name": "Cameroon",
      "name": "South",
      "state_code": "SU",
      "country_id": 38
    },
    {
      "country_code": "CM",
      "country_name": "Cameroon",
      "name": "Southwest",
      "state_code": "SW",
      "country_id": 38
    },
    {
      "country_code": "CM",
      "country_name": "Cameroon",
      "name": "West",
      "state_code": "OU",
      "country_id": 38
    },
    {
      "country_code": "CA",
      "country_name": "Canada",
      "name": "Alberta",
      "state_code": "AB",
      "country_id": 39
    },
    {
      "country_code": "CA",
      "country_name": "Canada",
      "name": "British Columbia",
      "state_code": "BC",
      "country_id": 39
    },
    {
      "country_code": "CA",
      "country_name": "Canada",
      "name": "Manitoba",
      "state_code": "MB",
      "country_id": 39
    },
    {
      "country_code": "CA",
      "country_name": "Canada",
      "name": "New Brunswick",
      "state_code": "NB",
      "country_id": 39
    },
    {
      "country_code": "CA",
      "country_name": "Canada",
      "name": "Newfoundland and Labrador",
      "state_code": "NL",
      "country_id": 39
    },
    {
      "country_code": "CA",
      "country_name": "Canada",
      "name": "Northwest Territories",
      "state_code": "NT",
      "country_id": 39
    },
    {
      "country_code": "CA",
      "country_name": "Canada",
      "name": "Nova Scotia",
      "state_code": "NS",
      "country_id": 39
    },
    {
      "country_code": "CA",
      "country_name": "Canada",
      "name": "Nunavut",
      "state_code": "NU",
      "country_id": 39
    },
    {
      "country_code": "CA",
      "country_name": "Canada",
      "name": "Ontario",
      "state_code": "ON",
      "country_id": 39
    },
    {
      "country_code": "CA",
      "country_name": "Canada",
      "name": "Prince Edward Island",
      "state_code": "PE",
      "country_id": 39
    },
    {
      "country_code": "CA",
      "country_name": "Canada",
      "name": "Quebec",
      "state_code": "QC",
      "country_id": 39
    },
    {
      "country_code": "CA",
      "country_name": "Canada",
      "name": "Saskatchewan",
      "state_code": "SK",
      "country_id": 39
    },
    {
      "country_code": "CA",
      "country_name": "Canada",
      "name": "Yukon",
      "state_code": "YT",
      "country_id": 39
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Barlavento Islands",
      "state_code": "B",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Boa Vista",
      "state_code": "BV",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Brava",
      "state_code": "BR",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Maio Municipality",
      "state_code": "MA",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Mosteiros",
      "state_code": "MO",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Paul",
      "state_code": "PA",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Porto Novo",
      "state_code": "PN",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Praia",
      "state_code": "PR",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Ribeira Brava Municipality",
      "state_code": "RB",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Ribeira Grande",
      "state_code": "RG",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Ribeira Grande de Santiago",
      "state_code": "RS",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Sal",
      "state_code": "SL",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Santa Catarina",
      "state_code": "CA",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Santa Catarina do Fogo",
      "state_code": "CF",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Santa Cruz",
      "state_code": "CR",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "São Domingos",
      "state_code": "SD",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "São Filipe",
      "state_code": "SF",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "São Lourenço dos Órgãos",
      "state_code": "SO",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "São Miguel",
      "state_code": "SM",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "São Vicente",
      "state_code": "SV",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Sotavento Islands",
      "state_code": "S",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Tarrafal",
      "state_code": "TA",
      "country_id": 40
    },
    {
      "country_code": "CV",
      "country_name": "Cape Verde",
      "name": "Tarrafal de São Nicolau",
      "state_code": "TS",
      "country_id": 40
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Bamingui-Bangoran Prefecture",
      "state_code": "BB",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Bangui",
      "state_code": "BGF",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Basse-Kotto Prefecture",
      "state_code": "BK",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Haut-Mbomou Prefecture",
      "state_code": "HM",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Haute-Kotto Prefecture",
      "state_code": "HK",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Kémo Prefecture",
      "state_code": "KG",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Lobaye Prefecture",
      "state_code": "LB",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Mambéré-Kadéï",
      "state_code": "HS",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Mbomou Prefecture",
      "state_code": "MB",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Nana-Grébizi Economic Prefecture",
      "state_code": "KB",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Nana-Mambéré Prefecture",
      "state_code": "NM",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Ombella-M'Poko Prefecture",
      "state_code": "MP",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Ouaka Prefecture",
      "state_code": "UK",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Ouham Prefecture",
      "state_code": "AC",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Ouham-Pendé Prefecture",
      "state_code": "OP",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Sangha-Mbaéré",
      "state_code": "SE",
      "country_id": 42
    },
    {
      "country_code": "CF",
      "country_name": "Central African Republic",
      "name": "Vakaga Prefecture",
      "state_code": "VK",
      "country_id": 42
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Bahr el Gazel",
      "state_code": "BG",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Batha",
      "state_code": "BA",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Borkou",
      "state_code": "BO",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Chari-Baguirmi",
      "state_code": "CB",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Ennedi-Est",
      "state_code": "EE",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Ennedi-Ouest",
      "state_code": "EO",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Guéra",
      "state_code": "GR",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Hadjer-Lamis",
      "state_code": "HL",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Kanem",
      "state_code": "KA",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Lac",
      "state_code": "LC",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Logone Occidental",
      "state_code": "LO",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Logone Oriental",
      "state_code": "LR",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Mandoul",
      "state_code": "MA",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Mayo-Kebbi Est",
      "state_code": "ME",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Mayo-Kebbi Ouest",
      "state_code": "MO",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Moyen-Chari",
      "state_code": "MC",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "N'Djamena",
      "state_code": "ND",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Ouaddaï",
      "state_code": "OD",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Salamat",
      "state_code": "SA",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Sila",
      "state_code": "SI",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Tandjilé",
      "state_code": "TA",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Tibesti",
      "state_code": "TI",
      "country_id": 43
    },
    {
      "country_code": "TD",
      "country_name": "Chad",
      "name": "Wadi Fira",
      "state_code": "WF",
      "country_id": 43
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Aisén del General Carlos Ibañez del Campo",
      "state_code": "AI",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Antofagasta",
      "state_code": "AN",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Arica y Parinacota",
      "state_code": "AP",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Atacama",
      "state_code": "AT",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Biobío",
      "state_code": "BI",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Coquimbo",
      "state_code": "CO",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "La Araucanía",
      "state_code": "AR",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Libertador General Bernardo O'Higgins",
      "state_code": "LI",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Los Lagos",
      "state_code": "LL",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Los Ríos",
      "state_code": "LR",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Magallanes y de la Antártica Chilena",
      "state_code": "MA",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Maule",
      "state_code": "ML",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Ñuble",
      "state_code": "NB",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Región Metropolitana de Santiago",
      "state_code": "RM",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Tarapacá",
      "state_code": "TA",
      "country_id": 44
    },
    {
      "country_code": "CL",
      "country_name": "Chile",
      "name": "Valparaíso",
      "state_code": "VS",
      "country_id": 44
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Anhui",
      "state_code": "AH",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Beijing",
      "state_code": "BJ",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Chongqing",
      "state_code": "CQ",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Fujian",
      "state_code": "FJ",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Gansu",
      "state_code": "GS",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Guangdong",
      "state_code": "GD",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Guangxi Zhuang",
      "state_code": "GX",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Guizhou",
      "state_code": "GZ",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Hainan",
      "state_code": "HI",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Hebei",
      "state_code": "HE",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Heilongjiang",
      "state_code": "HL",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Henan",
      "state_code": "HA",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Hong Kong SAR",
      "state_code": "HK",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Hubei",
      "state_code": "HB",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Hunan",
      "state_code": "HN",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Inner Mongolia",
      "state_code": "NM",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Jiangsu",
      "state_code": "JS",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Jiangxi",
      "state_code": "JX",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Jilin",
      "state_code": "JL",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Liaoning",
      "state_code": "LN",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Macau SAR",
      "state_code": "MO",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Ningxia Huizu",
      "state_code": "NX",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Qinghai",
      "state_code": "QH",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Shaanxi",
      "state_code": "SN",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Shandong",
      "state_code": "SD",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Shanghai",
      "state_code": "SH",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Shanxi",
      "state_code": "SX",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Sichuan",
      "state_code": "SC",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Taiwan",
      "state_code": "TW",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Tianjin",
      "state_code": "TJ",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Xinjiang",
      "state_code": "XJ",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Xizang",
      "state_code": "XZ",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Yunnan",
      "state_code": "YN",
      "country_id": 45
    },
    {
      "country_code": "CN",
      "country_name": "China",
      "name": "Zhejiang",
      "state_code": "ZJ",
      "country_id": 45
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Amazonas",
      "state_code": "AMA",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Antioquia",
      "state_code": "ANT",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Arauca",
      "state_code": "ARA",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Archipiélago de San Andrés, Providencia y Santa Catalina",
      "state_code": "SAP",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Atlántico",
      "state_code": "ATL",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Bogotá D.C.",
      "state_code": "DC",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Bolívar",
      "state_code": "BOL",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Boyacá",
      "state_code": "BOY",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Caldas",
      "state_code": "CAL",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Caquetá",
      "state_code": "CAQ",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Casanare",
      "state_code": "CAS",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Cauca",
      "state_code": "CAU",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Cesar",
      "state_code": "CES",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Chocó",
      "state_code": "CHO",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Córdoba",
      "state_code": "COR",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Cundinamarca",
      "state_code": "CUN",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Guainía",
      "state_code": "GUA",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Guaviare",
      "state_code": "GUV",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Huila",
      "state_code": "HUI",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "La Guajira",
      "state_code": "LAG",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Magdalena",
      "state_code": "MAG",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Meta",
      "state_code": "MET",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Nariño",
      "state_code": "NAR",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Norte de Santander",
      "state_code": "NSA",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Putumayo",
      "state_code": "PUT",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Quindío",
      "state_code": "QUI",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Risaralda",
      "state_code": "RIS",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Santander",
      "state_code": "SAN",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Sucre",
      "state_code": "SUC",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Tolima",
      "state_code": "TOL",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Valle del Cauca",
      "state_code": "VAC",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Vaupés",
      "state_code": "VAU",
      "country_id": 48
    },
    {
      "country_code": "CO",
      "country_name": "Colombia",
      "name": "Vichada",
      "state_code": "VID",
      "country_id": 48
    },
    {
      "country_code": "KM",
      "country_name": "Comoros",
      "name": "Anjouan",
      "state_code": "A",
      "country_id": 49
    },
    {
      "country_code": "KM",
      "country_name": "Comoros",
      "name": "Grande Comore",
      "state_code": "G",
      "country_id": 49
    },
    {
      "country_code": "KM",
      "country_name": "Comoros",
      "name": "Mohéli",
      "state_code": "M",
      "country_id": 49
    },
    {
      "country_code": "CG",
      "country_name": "Congo",
      "name": "Bouenza Department",
      "state_code": "11",
      "country_id": 50
    },
    {
      "country_code": "CG",
      "country_name": "Congo",
      "name": "Brazzaville",
      "state_code": "BZV",
      "country_id": 50
    },
    {
      "country_code": "CG",
      "country_name": "Congo",
      "name": "Cuvette Department",
      "state_code": "8",
      "country_id": 50
    },
    {
      "country_code": "CG",
      "country_name": "Congo",
      "name": "Cuvette-Ouest Department",
      "state_code": "15",
      "country_id": 50
    },
    {
      "country_code": "CG",
      "country_name": "Congo",
      "name": "Kouilou Department",
      "state_code": "5",
      "country_id": 50
    },
    {
      "country_code": "CG",
      "country_name": "Congo",
      "name": "Lékoumou Department",
      "state_code": "2",
      "country_id": 50
    },
    {
      "country_code": "CG",
      "country_name": "Congo",
      "name": "Likouala Department",
      "state_code": "7",
      "country_id": 50
    },
    {
      "country_code": "CG",
      "country_name": "Congo",
      "name": "Niari Department",
      "state_code": "9",
      "country_id": 50
    },
    {
      "country_code": "CG",
      "country_name": "Congo",
      "name": "Plateaux Department",
      "state_code": "14",
      "country_id": 50
    },
    {
      "country_code": "CG",
      "country_name": "Congo",
      "name": "Pointe-Noire",
      "state_code": "16",
      "country_id": 50
    },
    {
      "country_code": "CG",
      "country_name": "Congo",
      "name": "Pool Department",
      "state_code": "12",
      "country_id": 50
    },
    {
      "country_code": "CG",
      "country_name": "Congo",
      "name": "Sangha Department",
      "state_code": "13",
      "country_id": 50
    },
    {
      "country_code": "CR",
      "country_name": "Costa Rica",
      "name": "Alajuela Province",
      "state_code": "A",
      "country_id": 53
    },
    {
      "country_code": "CR",
      "country_name": "Costa Rica",
      "name": "Guanacaste Province",
      "state_code": "G",
      "country_id": 53
    },
    {
      "country_code": "CR",
      "country_name": "Costa Rica",
      "name": "Heredia Province",
      "state_code": "H",
      "country_id": 53
    },
    {
      "country_code": "CR",
      "country_name": "Costa Rica",
      "name": "Limón Province",
      "state_code": "L",
      "country_id": 53
    },
    {
      "country_code": "CR",
      "country_name": "Costa Rica",
      "name": "Provincia de Cartago",
      "state_code": "C",
      "country_id": 53
    },
    {
      "country_code": "CR",
      "country_name": "Costa Rica",
      "name": "Puntarenas Province",
      "state_code": "P",
      "country_id": 53
    },
    {
      "country_code": "CR",
      "country_name": "Costa Rica",
      "name": "San José Province",
      "state_code": "SJ",
      "country_id": 53
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Abidjan",
      "state_code": "AB",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Agnéby",
      "state_code": "16",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Bafing Region",
      "state_code": "17",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Bas-Sassandra District",
      "state_code": "BS",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Bas-Sassandra Region",
      "state_code": "09",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Comoé District",
      "state_code": "CM",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Denguélé District",
      "state_code": "DN",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Denguélé Region",
      "state_code": "10",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Dix-Huit Montagnes",
      "state_code": "06",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Fromager",
      "state_code": "18",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Gôh-Djiboua District",
      "state_code": "GD",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Haut-Sassandra",
      "state_code": "02",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Lacs District",
      "state_code": "LC",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Lacs Region",
      "state_code": "07",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Lagunes District",
      "state_code": "LG",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Lagunes region",
      "state_code": "01",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Marahoué Region",
      "state_code": "12",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Montagnes District",
      "state_code": "MG",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Moyen-Cavally",
      "state_code": "19",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Moyen-Comoé",
      "state_code": "05",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "N'zi-Comoé",
      "state_code": "11",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Sassandra-Marahoué District",
      "state_code": "SM",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Savanes Region",
      "state_code": "03",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Sud-Bandama",
      "state_code": "15",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Sud-Comoé",
      "state_code": "13",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Vallée du Bandama District",
      "state_code": "VB",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Vallée du Bandama Region",
      "state_code": "04",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Woroba District",
      "state_code": "WR",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Worodougou",
      "state_code": "14",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Yamoussoukro",
      "state_code": "YM",
      "country_id": 54
    },
    {
      "country_code": "CI",
      "country_name": "Cote D'Ivoire (Ivory Coast)",
      "name": "Zanzan Region",
      "state_code": "ZZ",
      "country_id": 54
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Bjelovar-Bilogora",
      "state_code": "07",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Brod-Posavina",
      "state_code": "12",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Dubrovnik-Neretva",
      "state_code": "19",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Istria",
      "state_code": "18",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Karlovac",
      "state_code": "04",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Koprivnica-Križevci",
      "state_code": "06",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Krapina-Zagorje",
      "state_code": "02",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Lika-Senj",
      "state_code": "09",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Međimurje",
      "state_code": "20",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Osijek-Baranja",
      "state_code": "14",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Požega-Slavonia",
      "state_code": "11",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Primorje-Gorski Kotar",
      "state_code": "08",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Šibenik-Knin",
      "state_code": "15",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Sisak-Moslavina",
      "state_code": "03",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Split-Dalmatia",
      "state_code": "17",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Varaždin",
      "state_code": "05",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Virovitica-Podravina",
      "state_code": "10",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Vukovar-Syrmia",
      "state_code": "16",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Zadar",
      "state_code": "13",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Zagreb",
      "state_code": "01",
      "country_id": 55
    },
    {
      "country_code": "HR",
      "country_name": "Croatia",
      "name": "Zagreb",
      "state_code": "21",
      "country_id": 55
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Artemisa Province",
      "state_code": "15",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Camagüey Province",
      "state_code": "09",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Ciego de Ávila Province",
      "state_code": "08",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Cienfuegos Province",
      "state_code": "06",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Granma Province",
      "state_code": "12",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Guantánamo Province",
      "state_code": "14",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Havana Province",
      "state_code": "03",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Holguín Province",
      "state_code": "11",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Isla de la Juventud",
      "state_code": "99",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Las Tunas Province",
      "state_code": "10",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Matanzas Province",
      "state_code": "04",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Mayabeque Province",
      "state_code": "16",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Pinar del Río Province",
      "state_code": "01",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Sancti Spíritus Province",
      "state_code": "07",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Santiago de Cuba Province",
      "state_code": "13",
      "country_id": 56
    },
    {
      "country_code": "CU",
      "country_name": "Cuba",
      "name": "Villa Clara Province",
      "state_code": "05",
      "country_id": 56
    },
    {
      "country_code": "CY",
      "country_name": "Cyprus",
      "name": "Famagusta District (Mağusa)",
      "state_code": "04",
      "country_id": 57
    },
    {
      "country_code": "CY",
      "country_name": "Cyprus",
      "name": "Kyrenia District (Keryneia)",
      "state_code": "06",
      "country_id": 57
    },
    {
      "country_code": "CY",
      "country_name": "Cyprus",
      "name": "Larnaca District (Larnaka)",
      "state_code": "03",
      "country_id": 57
    },
    {
      "country_code": "CY",
      "country_name": "Cyprus",
      "name": "Limassol District (Leymasun)",
      "state_code": "02",
      "country_id": 57
    },
    {
      "country_code": "CY",
      "country_name": "Cyprus",
      "name": "Nicosia District (Lefkoşa)",
      "state_code": "01",
      "country_id": 57
    },
    {
      "country_code": "CY",
      "country_name": "Cyprus",
      "name": "Paphos District (Pafos)",
      "state_code": "05",
      "country_id": 57
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Benešov",
      "state_code": "201",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Beroun",
      "state_code": "202",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Blansko",
      "state_code": "641",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Břeclav",
      "state_code": "644",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Brno-město",
      "state_code": "642",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Brno-venkov",
      "state_code": "643",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Bruntál",
      "state_code": "801",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Česká Lípa",
      "state_code": "511",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "České Budějovice",
      "state_code": "311",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Český Krumlov",
      "state_code": "312",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Cheb",
      "state_code": "411",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Chomutov",
      "state_code": "422",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Chrudim",
      "state_code": "531",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Děčín",
      "state_code": "421",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Domažlice",
      "state_code": "321",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Frýdek-Místek",
      "state_code": "802",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Havlíčkův Brod",
      "state_code": "631",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Hodonín",
      "state_code": "645",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Hradec Králové",
      "state_code": "521",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Jablonec nad Nisou",
      "state_code": "512",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Jeseník",
      "state_code": "711",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Jičín",
      "state_code": "522",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Jihlava",
      "state_code": "632",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Jihočeský kraj",
      "state_code": "31",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Jihomoravský kraj",
      "state_code": "64",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Jindřichův Hradec",
      "state_code": "313",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Karlovarský kraj",
      "state_code": "41",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Karlovy Vary",
      "state_code": "412",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Karviná",
      "state_code": "803",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Kladno",
      "state_code": "203",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Klatovy",
      "state_code": "322",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Kolín",
      "state_code": "204",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Kraj Vysočina",
      "state_code": "63",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Královéhradecký kraj",
      "state_code": "52",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Kroměříž",
      "state_code": "721",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Kutná Hora",
      "state_code": "205",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Liberec",
      "state_code": "513",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Liberecký kraj",
      "state_code": "51",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Litoměřice",
      "state_code": "423",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Louny",
      "state_code": "424",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Mělník",
      "state_code": "206",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Mladá Boleslav",
      "state_code": "207",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Moravskoslezský kraj",
      "state_code": "80",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Most",
      "state_code": "425",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Náchod",
      "state_code": "523",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Nový Jičín",
      "state_code": "804",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Nymburk",
      "state_code": "208",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Olomouc",
      "state_code": "712",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Olomoucký kraj",
      "state_code": "71",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Opava",
      "state_code": "805",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Ostrava-město",
      "state_code": "806",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Pardubice",
      "state_code": "532",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Pardubický kraj",
      "state_code": "53",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Pelhřimov",
      "state_code": "633",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Písek",
      "state_code": "314",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Plzeň-jih",
      "state_code": "324",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Plzeň-město",
      "state_code": "323",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Plzeň-sever",
      "state_code": "325",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Plzeňský kraj",
      "state_code": "32",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Prachatice",
      "state_code": "315",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Praha-východ",
      "state_code": "209",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Praha-západ",
      "state_code": "20A",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Praha, Hlavní město",
      "state_code": "10",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Přerov",
      "state_code": "714",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Příbram",
      "state_code": "20B",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Prostějov",
      "state_code": "713",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Rakovník",
      "state_code": "20C",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Rokycany",
      "state_code": "326",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Rychnov nad Kněžnou",
      "state_code": "524",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Semily",
      "state_code": "514",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Sokolov",
      "state_code": "413",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Strakonice",
      "state_code": "316",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Středočeský kraj",
      "state_code": "20",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Šumperk",
      "state_code": "715",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Svitavy",
      "state_code": "533",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Tábor",
      "state_code": "317",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Tachov",
      "state_code": "327",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Teplice",
      "state_code": "426",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Třebíč",
      "state_code": "634",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Trutnov",
      "state_code": "525",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Uherské Hradiště",
      "state_code": "722",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Ústecký kraj",
      "state_code": "42",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Ústí nad Labem",
      "state_code": "427",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Ústí nad Orlicí",
      "state_code": "534",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Vsetín",
      "state_code": "723",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Vyškov",
      "state_code": "646",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Žďár nad Sázavou",
      "state_code": "635",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Zlín",
      "state_code": "724",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Zlínský kraj",
      "state_code": "72",
      "country_id": 58
    },
    {
      "country_code": "CZ",
      "country_name": "Czech Republic",
      "name": "Znojmo",
      "state_code": "647",
      "country_id": 58
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Bas-Uélé",
      "state_code": "BU",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Équateur",
      "state_code": "EQ",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Haut-Katanga",
      "state_code": "HK",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Haut-Lomami",
      "state_code": "HL",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Haut-Uélé",
      "state_code": "HU",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Ituri",
      "state_code": "IT",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Kasaï",
      "state_code": "KS",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Kasaï Central",
      "state_code": "KC",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Kasaï Oriental",
      "state_code": "KE",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Kinshasa",
      "state_code": "KN",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Kongo Central",
      "state_code": "BC",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Kwango",
      "state_code": "KG",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Kwilu",
      "state_code": "KL",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Lomami",
      "state_code": "LO",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Lualaba",
      "state_code": "LU",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Mai-Ndombe",
      "state_code": "MN",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Maniema",
      "state_code": "MA",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Mongala",
      "state_code": "MO",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Nord-Kivu",
      "state_code": "NK",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Nord-Ubangi",
      "state_code": "NU",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Sankuru",
      "state_code": "SA",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Sud-Kivu",
      "state_code": "SK",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Sud-Ubangi",
      "state_code": "SU",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Tanganyika",
      "state_code": "TA",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Tshopo",
      "state_code": "TO",
      "country_id": 51
    },
    {
      "country_code": "CD",
      "country_name": "Democratic Republic of the Congo",
      "name": "Tshuapa",
      "state_code": "TU",
      "country_id": 51
    },
    {
      "country_code": "DK",
      "country_name": "Denmark",
      "name": "Capital Region of Denmark",
      "state_code": "84",
      "country_id": 59
    },
    {
      "country_code": "DK",
      "country_name": "Denmark",
      "name": "Central Denmark Region",
      "state_code": "82",
      "country_id": 59
    },
    {
      "country_code": "DK",
      "country_name": "Denmark",
      "name": "North Denmark Region",
      "state_code": "81",
      "country_id": 59
    },
    {
      "country_code": "DK",
      "country_name": "Denmark",
      "name": "Region of Southern Denmark",
      "state_code": "83",
      "country_id": 59
    },
    {
      "country_code": "DK",
      "country_name": "Denmark",
      "name": "Region Zealand",
      "state_code": "85",
      "country_id": 59
    },
    {
      "country_code": "DJ",
      "country_name": "Djibouti",
      "name": "Ali Sabieh Region",
      "state_code": "AS",
      "country_id": 60
    },
    {
      "country_code": "DJ",
      "country_name": "Djibouti",
      "name": "Arta Region",
      "state_code": "AR",
      "country_id": 60
    },
    {
      "country_code": "DJ",
      "country_name": "Djibouti",
      "name": "Dikhil Region",
      "state_code": "DI",
      "country_id": 60
    },
    {
      "country_code": "DJ",
      "country_name": "Djibouti",
      "name": "Djibouti",
      "state_code": "DJ",
      "country_id": 60
    },
    {
      "country_code": "DJ",
      "country_name": "Djibouti",
      "name": "Obock Region",
      "state_code": "OB",
      "country_id": 60
    },
    {
      "country_code": "DJ",
      "country_name": "Djibouti",
      "name": "Tadjourah Region",
      "state_code": "TA",
      "country_id": 60
    },
    {
      "country_code": "DM",
      "country_name": "Dominica",
      "name": "Saint Andrew Parish",
      "state_code": "02",
      "country_id": 61
    },
    {
      "country_code": "DM",
      "country_name": "Dominica",
      "name": "Saint David Parish",
      "state_code": "03",
      "country_id": 61
    },
    {
      "country_code": "DM",
      "country_name": "Dominica",
      "name": "Saint George Parish",
      "state_code": "04",
      "country_id": 61
    },
    {
      "country_code": "DM",
      "country_name": "Dominica",
      "name": "Saint John Parish",
      "state_code": "05",
      "country_id": 61
    },
    {
      "country_code": "DM",
      "country_name": "Dominica",
      "name": "Saint Joseph Parish",
      "state_code": "06",
      "country_id": 61
    },
    {
      "country_code": "DM",
      "country_name": "Dominica",
      "name": "Saint Luke Parish",
      "state_code": "07",
      "country_id": 61
    },
    {
      "country_code": "DM",
      "country_name": "Dominica",
      "name": "Saint Mark Parish",
      "state_code": "08",
      "country_id": 61
    },
    {
      "country_code": "DM",
      "country_name": "Dominica",
      "name": "Saint Patrick Parish",
      "state_code": "09",
      "country_id": 61
    },
    {
      "country_code": "DM",
      "country_name": "Dominica",
      "name": "Saint Paul Parish",
      "state_code": "10",
      "country_id": 61
    },
    {
      "country_code": "DM",
      "country_name": "Dominica",
      "name": "Saint Peter Parish",
      "state_code": "11",
      "country_id": 61
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Azua Province",
      "state_code": "02",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Baoruco Province",
      "state_code": "03",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Barahona Province",
      "state_code": "04",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Dajabón Province",
      "state_code": "05",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Distrito Nacional",
      "state_code": "01",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Duarte Province",
      "state_code": "06",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "El Seibo Province",
      "state_code": "08",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Espaillat Province",
      "state_code": "09",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Hato Mayor Province",
      "state_code": "30",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Hermanas Mirabal Province",
      "state_code": "19",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Independencia",
      "state_code": "10",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "La Altagracia Province",
      "state_code": "11",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "La Romana Province",
      "state_code": "12",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "La Vega Province",
      "state_code": "13",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "María Trinidad Sánchez Province",
      "state_code": "14",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Monseñor Nouel Province",
      "state_code": "28",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Monte Cristi Province",
      "state_code": "15",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Monte Plata Province",
      "state_code": "29",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Pedernales Province",
      "state_code": "16",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Peravia Province",
      "state_code": "17",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Puerto Plata Province",
      "state_code": "18",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Samaná Province",
      "state_code": "20",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "San Cristóbal Province",
      "state_code": "21",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "San José de Ocoa Province",
      "state_code": "31",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "San Juan Province",
      "state_code": "22",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "San Pedro de Macorís",
      "state_code": "23",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Sánchez Ramírez Province",
      "state_code": "24",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Santiago Province",
      "state_code": "25",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Santiago Rodríguez Province",
      "state_code": "26",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Santo Domingo Province",
      "state_code": "32",
      "country_id": 62
    },
    {
      "country_code": "DO",
      "country_name": "Dominican Republic",
      "name": "Valverde Province",
      "state_code": "27",
      "country_id": 62
    },
    {
      "country_code": "TL",
      "country_name": "East Timor",
      "name": "Aileu municipality",
      "state_code": "AL",
      "country_id": 63
    },
    {
      "country_code": "TL",
      "country_name": "East Timor",
      "name": "Ainaro Municipality",
      "state_code": "AN",
      "country_id": 63
    },
    {
      "country_code": "TL",
      "country_name": "East Timor",
      "name": "Baucau Municipality",
      "state_code": "BA",
      "country_id": 63
    },
    {
      "country_code": "TL",
      "country_name": "East Timor",
      "name": "Bobonaro Municipality",
      "state_code": "BO",
      "country_id": 63
    },
    {
      "country_code": "TL",
      "country_name": "East Timor",
      "name": "Cova Lima Municipality",
      "state_code": "CO",
      "country_id": 63
    },
    {
      "country_code": "TL",
      "country_name": "East Timor",
      "name": "Dili municipality",
      "state_code": "DI",
      "country_id": 63
    },
    {
      "country_code": "TL",
      "country_name": "East Timor",
      "name": "Ermera District",
      "state_code": "ER",
      "country_id": 63
    },
    {
      "country_code": "TL",
      "country_name": "East Timor",
      "name": "Lautém Municipality",
      "state_code": "LA",
      "country_id": 63
    },
    {
      "country_code": "TL",
      "country_name": "East Timor",
      "name": "Liquiçá Municipality",
      "state_code": "LI",
      "country_id": 63
    },
    {
      "country_code": "TL",
      "country_name": "East Timor",
      "name": "Manatuto District",
      "state_code": "MT",
      "country_id": 63
    },
    {
      "country_code": "TL",
      "country_name": "East Timor",
      "name": "Manufahi Municipality",
      "state_code": "MF",
      "country_id": 63
    },
    {
      "country_code": "TL",
      "country_name": "East Timor",
      "name": "Viqueque Municipality",
      "state_code": "VI",
      "country_id": 63
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Azuay",
      "state_code": "A",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Bolívar",
      "state_code": "B",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Cañar",
      "state_code": "F",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Carchi",
      "state_code": "C",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Chimborazo",
      "state_code": "H",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Cotopaxi",
      "state_code": "X",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "El Oro",
      "state_code": "O",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Esmeraldas",
      "state_code": "E",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Galápagos",
      "state_code": "W",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Guayas",
      "state_code": "G",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Imbabura",
      "state_code": "I",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Loja",
      "state_code": "L",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Los Ríos",
      "state_code": "R",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Manabí",
      "state_code": "M",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Morona-Santiago",
      "state_code": "S",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Napo",
      "state_code": "N",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Orellana",
      "state_code": "D",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Pastaza",
      "state_code": "Y",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Pichincha",
      "state_code": "P",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Santa Elena",
      "state_code": "SE",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Santo Domingo de los Tsáchilas",
      "state_code": "SD",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Sucumbíos",
      "state_code": "U",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Tungurahua",
      "state_code": "T",
      "country_id": 64
    },
    {
      "country_code": "EC",
      "country_name": "Ecuador",
      "name": "Zamora Chinchipe",
      "state_code": "Z",
      "country_id": 64
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Alexandria",
      "state_code": "ALX",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Aswan",
      "state_code": "ASN",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Asyut",
      "state_code": "AST",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Beheira",
      "state_code": "BH",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Beni Suef",
      "state_code": "BNS",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Cairo",
      "state_code": "C",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Dakahlia",
      "state_code": "DK",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Damietta",
      "state_code": "DT",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Faiyum",
      "state_code": "FYM",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Gharbia",
      "state_code": "GH",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Giza",
      "state_code": "GZ",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Ismailia",
      "state_code": "IS",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Kafr el-Sheikh",
      "state_code": "KFS",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Luxor",
      "state_code": "LX",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Matrouh",
      "state_code": "MT",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Minya",
      "state_code": "MN",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Monufia",
      "state_code": "MNF",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "New Valley",
      "state_code": "WAD",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "North Sinai",
      "state_code": "SIN",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Port Said",
      "state_code": "PTS",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Qalyubia",
      "state_code": "KB",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Qena",
      "state_code": "KN",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Red Sea",
      "state_code": "BA",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Sharqia",
      "state_code": "SHR",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Sohag",
      "state_code": "SHG",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "South Sinai",
      "state_code": "JS",
      "country_id": 65
    },
    {
      "country_code": "EG",
      "country_name": "Egypt",
      "name": "Suez",
      "state_code": "SUZ",
      "country_id": 65
    },
    {
      "country_code": "SV",
      "country_name": "El Salvador",
      "name": "Ahuachapán Department",
      "state_code": "AH",
      "country_id": 66
    },
    {
      "country_code": "SV",
      "country_name": "El Salvador",
      "name": "Cabañas Department",
      "state_code": "CA",
      "country_id": 66
    },
    {
      "country_code": "SV",
      "country_name": "El Salvador",
      "name": "Chalatenango Department",
      "state_code": "CH",
      "country_id": 66
    },
    {
      "country_code": "SV",
      "country_name": "El Salvador",
      "name": "Cuscatlán Department",
      "state_code": "CU",
      "country_id": 66
    },
    {
      "country_code": "SV",
      "country_name": "El Salvador",
      "name": "La Libertad Department",
      "state_code": "LI",
      "country_id": 66
    },
    {
      "country_code": "SV",
      "country_name": "El Salvador",
      "name": "La Paz Department",
      "state_code": "PA",
      "country_id": 66
    },
    {
      "country_code": "SV",
      "country_name": "El Salvador",
      "name": "La Unión Department",
      "state_code": "UN",
      "country_id": 66
    },
    {
      "country_code": "SV",
      "country_name": "El Salvador",
      "name": "Morazán Department",
      "state_code": "MO",
      "country_id": 66
    },
    {
      "country_code": "SV",
      "country_name": "El Salvador",
      "name": "San Miguel Department",
      "state_code": "SM",
      "country_id": 66
    },
    {
      "country_code": "SV",
      "country_name": "El Salvador",
      "name": "San Salvador Department",
      "state_code": "SS",
      "country_id": 66
    },
    {
      "country_code": "SV",
      "country_name": "El Salvador",
      "name": "San Vicente Department",
      "state_code": "SV",
      "country_id": 66
    },
    {
      "country_code": "SV",
      "country_name": "El Salvador",
      "name": "Santa Ana Department",
      "state_code": "SA",
      "country_id": 66
    },
    {
      "country_code": "SV",
      "country_name": "El Salvador",
      "name": "Sonsonate Department",
      "state_code": "SO",
      "country_id": 66
    },
    {
      "country_code": "SV",
      "country_name": "El Salvador",
      "name": "Usulután Department",
      "state_code": "US",
      "country_id": 66
    },
    {
      "country_code": "GQ",
      "country_name": "Equatorial Guinea",
      "name": "Annobón Province",
      "state_code": "AN",
      "country_id": 67
    },
    {
      "country_code": "GQ",
      "country_name": "Equatorial Guinea",
      "name": "Bioko Norte Province",
      "state_code": "BN",
      "country_id": 67
    },
    {
      "country_code": "GQ",
      "country_name": "Equatorial Guinea",
      "name": "Bioko Sur Province",
      "state_code": "BS",
      "country_id": 67
    },
    {
      "country_code": "GQ",
      "country_name": "Equatorial Guinea",
      "name": "Centro Sur Province",
      "state_code": "CS",
      "country_id": 67
    },
    {
      "country_code": "GQ",
      "country_name": "Equatorial Guinea",
      "name": "Insular Region",
      "state_code": "I",
      "country_id": 67
    },
    {
      "country_code": "GQ",
      "country_name": "Equatorial Guinea",
      "name": "Kié-Ntem Province",
      "state_code": "KN",
      "country_id": 67
    },
    {
      "country_code": "GQ",
      "country_name": "Equatorial Guinea",
      "name": "Litoral Province",
      "state_code": "LI",
      "country_id": 67
    },
    {
      "country_code": "GQ",
      "country_name": "Equatorial Guinea",
      "name": "Río Muni",
      "state_code": "C",
      "country_id": 67
    },
    {
      "country_code": "GQ",
      "country_name": "Equatorial Guinea",
      "name": "Wele-Nzas Province",
      "state_code": "WN",
      "country_id": 67
    },
    {
      "country_code": "ER",
      "country_name": "Eritrea",
      "name": "Anseba Region",
      "state_code": "AN",
      "country_id": 68
    },
    {
      "country_code": "ER",
      "country_name": "Eritrea",
      "name": "Debub Region",
      "state_code": "DU",
      "country_id": 68
    },
    {
      "country_code": "ER",
      "country_name": "Eritrea",
      "name": "Gash-Barka Region",
      "state_code": "GB",
      "country_id": 68
    },
    {
      "country_code": "ER",
      "country_name": "Eritrea",
      "name": "Maekel Region",
      "state_code": "MA",
      "country_id": 68
    },
    {
      "country_code": "ER",
      "country_name": "Eritrea",
      "name": "Northern Red Sea Region",
      "state_code": "SK",
      "country_id": 68
    },
    {
      "country_code": "ER",
      "country_name": "Eritrea",
      "name": "Southern Red Sea Region",
      "state_code": "DK",
      "country_id": 68
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Harju County",
      "state_code": "37",
      "country_id": 69
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Hiiu County",
      "state_code": "39",
      "country_id": 69
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Ida-Viru County",
      "state_code": "44",
      "country_id": 69
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Järva County",
      "state_code": "51",
      "country_id": 69
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Jõgeva County",
      "state_code": "49",
      "country_id": 69
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Lääne County",
      "state_code": "57",
      "country_id": 69
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Lääne-Viru County",
      "state_code": "59",
      "country_id": 69
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Pärnu County",
      "state_code": "67",
      "country_id": 69
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Põlva County",
      "state_code": "65",
      "country_id": 69
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Rapla County",
      "state_code": "70",
      "country_id": 69
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Saare County",
      "state_code": "74",
      "country_id": 69
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Tartu County",
      "state_code": "78",
      "country_id": 69
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Valga County",
      "state_code": "82",
      "country_id": 69
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Viljandi County",
      "state_code": "84",
      "country_id": 69
    },
    {
      "country_code": "EE",
      "country_name": "Estonia",
      "name": "Võru County",
      "state_code": "86",
      "country_id": 69
    },
    {
      "country_code": "ET",
      "country_name": "Ethiopia",
      "name": "Addis Ababa",
      "state_code": "AA",
      "country_id": 70
    },
    {
      "country_code": "ET",
      "country_name": "Ethiopia",
      "name": "Afar Region",
      "state_code": "AF",
      "country_id": 70
    },
    {
      "country_code": "ET",
      "country_name": "Ethiopia",
      "name": "Amhara Region",
      "state_code": "AM",
      "country_id": 70
    },
    {
      "country_code": "ET",
      "country_name": "Ethiopia",
      "name": "Benishangul-Gumuz Region",
      "state_code": "BE",
      "country_id": 70
    },
    {
      "country_code": "ET",
      "country_name": "Ethiopia",
      "name": "Dire Dawa",
      "state_code": "DD",
      "country_id": 70
    },
    {
      "country_code": "ET",
      "country_name": "Ethiopia",
      "name": "Gambela Region",
      "state_code": "GA",
      "country_id": 70
    },
    {
      "country_code": "ET",
      "country_name": "Ethiopia",
      "name": "Harari Region",
      "state_code": "HA",
      "country_id": 70
    },
    {
      "country_code": "ET",
      "country_name": "Ethiopia",
      "name": "Oromia Region",
      "state_code": "OR",
      "country_id": 70
    },
    {
      "country_code": "ET",
      "country_name": "Ethiopia",
      "name": "Somali Region",
      "state_code": "SO",
      "country_id": 70
    },
    {
      "country_code": "ET",
      "country_name": "Ethiopia",
      "name": "Southern Nations, Nationalities, and Peoples' Region",
      "state_code": "SN",
      "country_id": 70
    },
    {
      "country_code": "ET",
      "country_name": "Ethiopia",
      "name": "Tigray Region",
      "state_code": "TI",
      "country_id": 70
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Ba",
      "state_code": "01",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Bua",
      "state_code": "02",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Cakaudrove",
      "state_code": "03",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Central Division",
      "state_code": "C",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Eastern Division",
      "state_code": "E",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Kadavu",
      "state_code": "04",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Lau",
      "state_code": "05",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Lomaiviti",
      "state_code": "06",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Macuata",
      "state_code": "07",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Nadroga-Navosa",
      "state_code": "08",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Naitasiri",
      "state_code": "09",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Namosi",
      "state_code": "10",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Northern Division",
      "state_code": "N",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Ra",
      "state_code": "11",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Rewa",
      "state_code": "12",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Rotuma",
      "state_code": "R",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Serua",
      "state_code": "13",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Tailevu",
      "state_code": "14",
      "country_id": 73
    },
    {
      "country_code": "FJ",
      "country_name": "Fiji Islands",
      "name": "Western Division",
      "state_code": "W",
      "country_id": 73
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Åland Islands",
      "state_code": "01",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Central Finland",
      "state_code": "08",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Central Ostrobothnia",
      "state_code": "07",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Finland Proper",
      "state_code": "19",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Kainuu",
      "state_code": "05",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Kymenlaakso",
      "state_code": "09",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Lapland",
      "state_code": "10",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "North Karelia",
      "state_code": "13",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Northern Ostrobothnia",
      "state_code": "14",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Northern Savonia",
      "state_code": "15",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Ostrobothnia",
      "state_code": "12",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Päijänne Tavastia",
      "state_code": "16",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Pirkanmaa",
      "state_code": "11",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Satakunta",
      "state_code": "17",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "South Karelia",
      "state_code": "02",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Southern Ostrobothnia",
      "state_code": "03",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Southern Savonia",
      "state_code": "04",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Tavastia Proper",
      "state_code": "06",
      "country_id": 74
    },
    {
      "country_code": "FI",
      "country_name": "Finland",
      "name": "Uusimaa",
      "state_code": "18",
      "country_id": 74
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Ain",
      "state_code": "01",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Aisne",
      "state_code": "02",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Allier",
      "state_code": "03",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Alpes-de-Haute-Provence",
      "state_code": "04",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Alpes-Maritimes",
      "state_code": "06",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Alsace",
      "state_code": "6AE",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Ardèche",
      "state_code": "07",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Ardennes",
      "state_code": "08",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Ariège",
      "state_code": "09",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Aube",
      "state_code": "10",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Aude",
      "state_code": "11",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Auvergne-Rhône-Alpes",
      "state_code": "ARA",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Aveyron",
      "state_code": "12",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Bas-Rhin",
      "state_code": "67",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Bouches-du-Rhône",
      "state_code": "13",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Bourgogne-Franche-Comté",
      "state_code": "BFC",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Bretagne",
      "state_code": "BRE",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Calvados",
      "state_code": "14",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Cantal",
      "state_code": "15",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Centre-Val de Loire",
      "state_code": "CVL",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Charente",
      "state_code": "16",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Charente-Maritime",
      "state_code": "17",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Cher",
      "state_code": "18",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Clipperton",
      "state_code": "CP",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Corrèze",
      "state_code": "19",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Corse",
      "state_code": "20R",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Corse-du-Sud",
      "state_code": "2A",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Côte-d'Or",
      "state_code": "21",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Côtes-d'Armor",
      "state_code": "22",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Creuse",
      "state_code": "23",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Deux-Sèvres",
      "state_code": "79",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Dordogne",
      "state_code": "24",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Doubs",
      "state_code": "25",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Drôme",
      "state_code": "26",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Essonne",
      "state_code": "91",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Eure",
      "state_code": "27",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Eure-et-Loir",
      "state_code": "28",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Finistère",
      "state_code": "29",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "French Guiana",
      "state_code": "973",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "French Polynesia",
      "state_code": "PF",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "French Southern and Antarctic Lands",
      "state_code": "TF",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Gard",
      "state_code": "30",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Gers",
      "state_code": "32",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Gironde",
      "state_code": "33",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Grand-Est",
      "state_code": "GES",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Guadeloupe",
      "state_code": "971",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Haut-Rhin",
      "state_code": "68",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Haute-Corse",
      "state_code": "2B",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Haute-Garonne",
      "state_code": "31",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Haute-Loire",
      "state_code": "43",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Haute-Marne",
      "state_code": "52",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Haute-Saône",
      "state_code": "70",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Haute-Savoie",
      "state_code": "74",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Haute-Vienne",
      "state_code": "87",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Hautes-Alpes",
      "state_code": "05",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Hautes-Pyrénées",
      "state_code": "65",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Hauts-de-France",
      "state_code": "HDF",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Hauts-de-Seine",
      "state_code": "92",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Hérault",
      "state_code": "34",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Île-de-France",
      "state_code": "IDF",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Ille-et-Vilaine",
      "state_code": "35",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Indre",
      "state_code": "36",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Indre-et-Loire",
      "state_code": "37",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Isère",
      "state_code": "38",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Jura",
      "state_code": "39",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "La Réunion",
      "state_code": "974",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Landes",
      "state_code": "40",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Loir-et-Cher",
      "state_code": "41",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Loire",
      "state_code": "42",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Loire-Atlantique",
      "state_code": "44",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Loiret",
      "state_code": "45",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Lot",
      "state_code": "46",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Lot-et-Garonne",
      "state_code": "47",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Lozère",
      "state_code": "48",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Maine-et-Loire",
      "state_code": "49",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Manche",
      "state_code": "50",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Marne",
      "state_code": "51",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Martinique",
      "state_code": "972",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Mayenne",
      "state_code": "53",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Mayotte",
      "state_code": "976",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Métropole de Lyon",
      "state_code": "69M",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Meurthe-et-Moselle",
      "state_code": "54",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Meuse",
      "state_code": "55",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Morbihan",
      "state_code": "56",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Moselle",
      "state_code": "57",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Nièvre",
      "state_code": "58",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Nord",
      "state_code": "59",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Normandie",
      "state_code": "NOR",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Nouvelle-Aquitaine",
      "state_code": "NAQ",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Occitanie",
      "state_code": "OCC",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Oise",
      "state_code": "60",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Orne",
      "state_code": "61",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Paris",
      "state_code": "75C",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Pas-de-Calais",
      "state_code": "62",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Pays-de-la-Loire",
      "state_code": "PDL",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Provence-Alpes-Côte-d’Azur",
      "state_code": "PAC",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Puy-de-Dôme",
      "state_code": "63",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Pyrénées-Atlantiques",
      "state_code": "64",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Pyrénées-Orientales",
      "state_code": "66",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Rhône",
      "state_code": "69",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Saint Pierre and Miquelon",
      "state_code": "PM",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Saint-Barthélemy",
      "state_code": "BL",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Saint-Martin",
      "state_code": "MF",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Saône-et-Loire",
      "state_code": "71",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Sarthe",
      "state_code": "72",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Savoie",
      "state_code": "73",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Seine-et-Marne",
      "state_code": "77",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Seine-Maritime",
      "state_code": "76",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Seine-Saint-Denis",
      "state_code": "93",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Somme",
      "state_code": "80",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Tarn",
      "state_code": "81",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Tarn-et-Garonne",
      "state_code": "82",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Territoire de Belfort",
      "state_code": "90",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Val-d'Oise",
      "state_code": "95",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Val-de-Marne",
      "state_code": "94",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Var",
      "state_code": "83",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Vaucluse",
      "state_code": "84",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Vendée",
      "state_code": "85",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Vienne",
      "state_code": "86",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Vosges",
      "state_code": "88",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Wallis and Futuna",
      "state_code": "WF",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Yonne",
      "state_code": "89",
      "country_id": 75
    },
    {
      "country_code": "FR",
      "country_name": "France",
      "name": "Yvelines",
      "state_code": "78",
      "country_id": 75
    },
    {
      "country_code": "GA",
      "country_name": "Gabon",
      "name": "Estuaire Province",
      "state_code": "1",
      "country_id": 79
    },
    {
      "country_code": "GA",
      "country_name": "Gabon",
      "name": "Haut-Ogooué Province",
      "state_code": "2",
      "country_id": 79
    },
    {
      "country_code": "GA",
      "country_name": "Gabon",
      "name": "Moyen-Ogooué Province",
      "state_code": "3",
      "country_id": 79
    },
    {
      "country_code": "GA",
      "country_name": "Gabon",
      "name": "Ngounié Province",
      "state_code": "4",
      "country_id": 79
    },
    {
      "country_code": "GA",
      "country_name": "Gabon",
      "name": "Nyanga Province",
      "state_code": "5",
      "country_id": 79
    },
    {
      "country_code": "GA",
      "country_name": "Gabon",
      "name": "Ogooué-Ivindo Province",
      "state_code": "6",
      "country_id": 79
    },
    {
      "country_code": "GA",
      "country_name": "Gabon",
      "name": "Ogooué-Lolo Province",
      "state_code": "7",
      "country_id": 79
    },
    {
      "country_code": "GA",
      "country_name": "Gabon",
      "name": "Ogooué-Maritime Province",
      "state_code": "8",
      "country_id": 79
    },
    {
      "country_code": "GA",
      "country_name": "Gabon",
      "name": "Woleu-Ntem Province",
      "state_code": "9",
      "country_id": 79
    },
    {
      "country_code": "GM",
      "country_name": "Gambia The",
      "name": "Banjul",
      "state_code": "B",
      "country_id": 80
    },
    {
      "country_code": "GM",
      "country_name": "Gambia The",
      "name": "Central River Division",
      "state_code": "M",
      "country_id": 80
    },
    {
      "country_code": "GM",
      "country_name": "Gambia The",
      "name": "Lower River Division",
      "state_code": "L",
      "country_id": 80
    },
    {
      "country_code": "GM",
      "country_name": "Gambia The",
      "name": "North Bank Division",
      "state_code": "N",
      "country_id": 80
    },
    {
      "country_code": "GM",
      "country_name": "Gambia The",
      "name": "Upper River Division",
      "state_code": "U",
      "country_id": 80
    },
    {
      "country_code": "GM",
      "country_name": "Gambia The",
      "name": "West Coast Division",
      "state_code": "W",
      "country_id": 80
    },
    {
      "country_code": "GE",
      "country_name": "Georgia",
      "name": "Adjara",
      "state_code": "AJ",
      "country_id": 81
    },
    {
      "country_code": "GE",
      "country_name": "Georgia",
      "name": "Autonomous Republic of Abkhazia",
      "state_code": "AB",
      "country_id": 81
    },
    {
      "country_code": "GE",
      "country_name": "Georgia",
      "name": "Guria",
      "state_code": "GU",
      "country_id": 81
    },
    {
      "country_code": "GE",
      "country_name": "Georgia",
      "name": "Imereti",
      "state_code": "IM",
      "country_id": 81
    },
    {
      "country_code": "GE",
      "country_name": "Georgia",
      "name": "Kakheti",
      "state_code": "KA",
      "country_id": 81
    },
    {
      "country_code": "GE",
      "country_name": "Georgia",
      "name": "Khelvachauri Municipality",
      "state_code": "29",
      "country_id": 81
    },
    {
      "country_code": "GE",
      "country_name": "Georgia",
      "name": "Kvemo Kartli",
      "state_code": "KK",
      "country_id": 81
    },
    {
      "country_code": "GE",
      "country_name": "Georgia",
      "name": "Mtskheta-Mtianeti",
      "state_code": "MM",
      "country_id": 81
    },
    {
      "country_code": "GE",
      "country_name": "Georgia",
      "name": "Racha-Lechkhumi and Kvemo Svaneti",
      "state_code": "RL",
      "country_id": 81
    },
    {
      "country_code": "GE",
      "country_name": "Georgia",
      "name": "Samegrelo-Zemo Svaneti",
      "state_code": "SZ",
      "country_id": 81
    },
    {
      "country_code": "GE",
      "country_name": "Georgia",
      "name": "Samtskhe-Javakheti",
      "state_code": "SJ",
      "country_id": 81
    },
    {
      "country_code": "GE",
      "country_name": "Georgia",
      "name": "Senaki Municipality",
      "state_code": "50",
      "country_id": 81
    },
    {
      "country_code": "GE",
      "country_name": "Georgia",
      "name": "Shida Kartli",
      "state_code": "SK",
      "country_id": 81
    },
    {
      "country_code": "GE",
      "country_name": "Georgia",
      "name": "Tbilisi",
      "state_code": "TB",
      "country_id": 81
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Baden-Württemberg",
      "state_code": "BW",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Bavaria",
      "state_code": "BY",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Berlin",
      "state_code": "BE",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Brandenburg",
      "state_code": "BB",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Bremen",
      "state_code": "HB",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Hamburg",
      "state_code": "HH",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Hesse",
      "state_code": "HE",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Lower Saxony",
      "state_code": "NI",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Mecklenburg-Vorpommern",
      "state_code": "MV",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "North Rhine-Westphalia",
      "state_code": "NW",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Rhineland-Palatinate",
      "state_code": "RP",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Saarland",
      "state_code": "SL",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Saxony",
      "state_code": "SN",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Saxony-Anhalt",
      "state_code": "ST",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Schleswig-Holstein",
      "state_code": "SH",
      "country_id": 82
    },
    {
      "country_code": "DE",
      "country_name": "Germany",
      "name": "Thuringia",
      "state_code": "TH",
      "country_id": 82
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Ahafo",
      "state_code": "AF",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Ashanti",
      "state_code": "AH",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Bono",
      "state_code": "BO",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Bono East",
      "state_code": "BE",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Central",
      "state_code": "CP",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Eastern",
      "state_code": "EP",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Greater Accra",
      "state_code": "AA",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "North East",
      "state_code": "NE",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Northern",
      "state_code": "NP",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Oti",
      "state_code": "OT",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Savannah",
      "state_code": "SV",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Upper East",
      "state_code": "UE",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Upper West",
      "state_code": "UW",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Volta",
      "state_code": "TV",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Western",
      "state_code": "WP",
      "country_id": 83
    },
    {
      "country_code": "GH",
      "country_name": "Ghana",
      "name": "Western North",
      "state_code": "WN",
      "country_id": 83
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Achaea Regional Unit",
      "state_code": "13",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Aetolia-Acarnania Regional Unit",
      "state_code": "01",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Arcadia Prefecture",
      "state_code": "12",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Argolis Regional Unit",
      "state_code": "11",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Attica Region",
      "state_code": "I",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Boeotia Regional Unit",
      "state_code": "03",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Central Greece Region",
      "state_code": "H",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Central Macedonia",
      "state_code": "B",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Chania Regional Unit",
      "state_code": "94",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Corfu Prefecture",
      "state_code": "22",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Corinthia Regional Unit",
      "state_code": "15",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Crete Region",
      "state_code": "M",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Drama Regional Unit",
      "state_code": "52",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "East Attica Regional Unit",
      "state_code": "A2",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "East Macedonia and Thrace",
      "state_code": "A",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Epirus Region",
      "state_code": "D",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Euboea",
      "state_code": "04",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Grevena Prefecture",
      "state_code": "51",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Imathia Regional Unit",
      "state_code": "53",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Ioannina Regional Unit",
      "state_code": "33",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Ionian Islands Region",
      "state_code": "F",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Karditsa Regional Unit",
      "state_code": "41",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Kastoria Regional Unit",
      "state_code": "56",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Kefalonia Prefecture",
      "state_code": "23",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Kilkis Regional Unit",
      "state_code": "57",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Kozani Prefecture",
      "state_code": "58",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Laconia",
      "state_code": "16",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Larissa Prefecture",
      "state_code": "42",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Lefkada Regional Unit",
      "state_code": "24",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Pella Regional Unit",
      "state_code": "59",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Peloponnese Region",
      "state_code": "J",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Phthiotis Prefecture",
      "state_code": "06",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Preveza Prefecture",
      "state_code": "34",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Serres Prefecture",
      "state_code": "62",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "South Aegean",
      "state_code": "L",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "Thessaloniki Regional Unit",
      "state_code": "54",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "West Greece Region",
      "state_code": "G",
      "country_id": 85
    },
    {
      "country_code": "GR",
      "country_name": "Greece",
      "name": "West Macedonia Region",
      "state_code": "C",
      "country_id": 85
    },
    {
      "country_code": "GD",
      "country_name": "Grenada",
      "name": "Carriacou and Petite Martinique",
      "state_code": "10",
      "country_id": 87
    },
    {
      "country_code": "GD",
      "country_name": "Grenada",
      "name": "Saint Andrew Parish",
      "state_code": "01",
      "country_id": 87
    },
    {
      "country_code": "GD",
      "country_name": "Grenada",
      "name": "Saint David Parish",
      "state_code": "02",
      "country_id": 87
    },
    {
      "country_code": "GD",
      "country_name": "Grenada",
      "name": "Saint George Parish",
      "state_code": "03",
      "country_id": 87
    },
    {
      "country_code": "GD",
      "country_name": "Grenada",
      "name": "Saint John Parish",
      "state_code": "04",
      "country_id": 87
    },
    {
      "country_code": "GD",
      "country_name": "Grenada",
      "name": "Saint Mark Parish",
      "state_code": "05",
      "country_id": 87
    },
    {
      "country_code": "GD",
      "country_name": "Grenada",
      "name": "Saint Patrick Parish",
      "state_code": "06",
      "country_id": 87
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Alta Verapaz Department",
      "state_code": "AV",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Baja Verapaz Department",
      "state_code": "BV",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Chimaltenango Department",
      "state_code": "CM",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Chiquimula Department",
      "state_code": "CQ",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "El Progreso Department",
      "state_code": "PR",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Escuintla Department",
      "state_code": "ES",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Guatemala Department",
      "state_code": "GU",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Huehuetenango Department",
      "state_code": "HU",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Izabal Department",
      "state_code": "IZ",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Jalapa Department",
      "state_code": "JA",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Jutiapa Department",
      "state_code": "JU",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Petén Department",
      "state_code": "PE",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Quetzaltenango Department",
      "state_code": "QZ",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Quiché Department",
      "state_code": "QC",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Retalhuleu Department",
      "state_code": "RE",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Sacatepéquez Department",
      "state_code": "SA",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "San Marcos Department",
      "state_code": "SM",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Santa Rosa Department",
      "state_code": "SR",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Sololá Department",
      "state_code": "SO",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Suchitepéquez Department",
      "state_code": "SU",
      "country_id": 90
    },
    {
      "country_code": "GT",
      "country_name": "Guatemala",
      "name": "Totonicapán Department",
      "state_code": "TO",
      "country_id": 90
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Beyla Prefecture",
      "state_code": "BE",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Boffa Prefecture",
      "state_code": "BF",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Boké Prefecture",
      "state_code": "BK",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Boké Region",
      "state_code": "B",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Conakry",
      "state_code": "C",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Coyah Prefecture",
      "state_code": "CO",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Dabola Prefecture",
      "state_code": "DB",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Dalaba Prefecture",
      "state_code": "DL",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Dinguiraye Prefecture",
      "state_code": "DI",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Dubréka Prefecture",
      "state_code": "DU",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Faranah Prefecture",
      "state_code": "FA",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Forécariah Prefecture",
      "state_code": "FO",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Fria Prefecture",
      "state_code": "FR",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Gaoual Prefecture",
      "state_code": "GA",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Guéckédou Prefecture",
      "state_code": "GU",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Kankan Prefecture",
      "state_code": "KA",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Kankan Region",
      "state_code": "K",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Kérouané Prefecture",
      "state_code": "KE",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Kindia Prefecture",
      "state_code": "KD",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Kindia Region",
      "state_code": "D",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Kissidougou Prefecture",
      "state_code": "KS",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Koubia Prefecture",
      "state_code": "KB",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Koundara Prefecture",
      "state_code": "KN",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Kouroussa Prefecture",
      "state_code": "KO",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Labé Prefecture",
      "state_code": "LA",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Labé Region",
      "state_code": "L",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Lélouma Prefecture",
      "state_code": "LE",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Lola Prefecture",
      "state_code": "LO",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Macenta Prefecture",
      "state_code": "MC",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Mali Prefecture",
      "state_code": "ML",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Mamou Prefecture",
      "state_code": "MM",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Mamou Region",
      "state_code": "M",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Mandiana Prefecture",
      "state_code": "MD",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Nzérékoré Prefecture",
      "state_code": "NZ",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Nzérékoré Region",
      "state_code": "N",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Pita Prefecture",
      "state_code": "PI",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Siguiri Prefecture",
      "state_code": "SI",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Télimélé Prefecture",
      "state_code": "TE",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Tougué Prefecture",
      "state_code": "TO",
      "country_id": 92
    },
    {
      "country_code": "GN",
      "country_name": "Guinea",
      "name": "Yomou Prefecture",
      "state_code": "YO",
      "country_id": 92
    },
    {
      "country_code": "GW",
      "country_name": "Guinea-Bissau",
      "name": "Bafatá",
      "state_code": "BA",
      "country_id": 93
    },
    {
      "country_code": "GW",
      "country_name": "Guinea-Bissau",
      "name": "Biombo Region",
      "state_code": "BM",
      "country_id": 93
    },
    {
      "country_code": "GW",
      "country_name": "Guinea-Bissau",
      "name": "Bolama Region",
      "state_code": "BL",
      "country_id": 93
    },
    {
      "country_code": "GW",
      "country_name": "Guinea-Bissau",
      "name": "Cacheu Region",
      "state_code": "CA",
      "country_id": 93
    },
    {
      "country_code": "GW",
      "country_name": "Guinea-Bissau",
      "name": "Gabú Region",
      "state_code": "GA",
      "country_id": 93
    },
    {
      "country_code": "GW",
      "country_name": "Guinea-Bissau",
      "name": "Leste Province",
      "state_code": "L",
      "country_id": 93
    },
    {
      "country_code": "GW",
      "country_name": "Guinea-Bissau",
      "name": "Norte Province",
      "state_code": "N",
      "country_id": 93
    },
    {
      "country_code": "GW",
      "country_name": "Guinea-Bissau",
      "name": "Oio Region",
      "state_code": "OI",
      "country_id": 93
    },
    {
      "country_code": "GW",
      "country_name": "Guinea-Bissau",
      "name": "Quinara Region",
      "state_code": "QU",
      "country_id": 93
    },
    {
      "country_code": "GW",
      "country_name": "Guinea-Bissau",
      "name": "Sul Province",
      "state_code": "S",
      "country_id": 93
    },
    {
      "country_code": "GW",
      "country_name": "Guinea-Bissau",
      "name": "Tombali Region",
      "state_code": "TO",
      "country_id": 93
    },
    {
      "country_code": "GY",
      "country_name": "Guyana",
      "name": "Barima-Waini",
      "state_code": "BA",
      "country_id": 94
    },
    {
      "country_code": "GY",
      "country_name": "Guyana",
      "name": "Cuyuni-Mazaruni",
      "state_code": "CU",
      "country_id": 94
    },
    {
      "country_code": "GY",
      "country_name": "Guyana",
      "name": "Demerara-Mahaica",
      "state_code": "DE",
      "country_id": 94
    },
    {
      "country_code": "GY",
      "country_name": "Guyana",
      "name": "East Berbice-Corentyne",
      "state_code": "EB",
      "country_id": 94
    },
    {
      "country_code": "GY",
      "country_name": "Guyana",
      "name": "Essequibo Islands-West Demerara",
      "state_code": "ES",
      "country_id": 94
    },
    {
      "country_code": "GY",
      "country_name": "Guyana",
      "name": "Mahaica-Berbice",
      "state_code": "MA",
      "country_id": 94
    },
    {
      "country_code": "GY",
      "country_name": "Guyana",
      "name": "Pomeroon-Supenaam",
      "state_code": "PM",
      "country_id": 94
    },
    {
      "country_code": "GY",
      "country_name": "Guyana",
      "name": "Potaro-Siparuni",
      "state_code": "PT",
      "country_id": 94
    },
    {
      "country_code": "GY",
      "country_name": "Guyana",
      "name": "Upper Demerara-Berbice",
      "state_code": "UD",
      "country_id": 94
    },
    {
      "country_code": "GY",
      "country_name": "Guyana",
      "name": "Upper Takutu-Upper Essequibo",
      "state_code": "UT",
      "country_id": 94
    },
    {
      "country_code": "HT",
      "country_name": "Haiti",
      "name": "Artibonite",
      "state_code": "AR",
      "country_id": 95
    },
    {
      "country_code": "HT",
      "country_name": "Haiti",
      "name": "Centre",
      "state_code": "CE",
      "country_id": 95
    },
    {
      "country_code": "HT",
      "country_name": "Haiti",
      "name": "Grand'Anse",
      "state_code": "GA",
      "country_id": 95
    },
    {
      "country_code": "HT",
      "country_name": "Haiti",
      "name": "Nippes",
      "state_code": "NI",
      "country_id": 95
    },
    {
      "country_code": "HT",
      "country_name": "Haiti",
      "name": "Nord",
      "state_code": "ND",
      "country_id": 95
    },
    {
      "country_code": "HT",
      "country_name": "Haiti",
      "name": "Nord-Est",
      "state_code": "NE",
      "country_id": 95
    },
    {
      "country_code": "HT",
      "country_name": "Haiti",
      "name": "Nord-Ouest",
      "state_code": "NO",
      "country_id": 95
    },
    {
      "country_code": "HT",
      "country_name": "Haiti",
      "name": "Ouest",
      "state_code": "OU",
      "country_id": 95
    },
    {
      "country_code": "HT",
      "country_name": "Haiti",
      "name": "Sud",
      "state_code": "SD",
      "country_id": 95
    },
    {
      "country_code": "HT",
      "country_name": "Haiti",
      "name": "Sud-Est",
      "state_code": "SE",
      "country_id": 95
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Atlántida Department",
      "state_code": "AT",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Bay Islands Department",
      "state_code": "IB",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Choluteca Department",
      "state_code": "CH",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Colón Department",
      "state_code": "CL",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Comayagua Department",
      "state_code": "CM",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Copán Department",
      "state_code": "CP",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Cortés Department",
      "state_code": "CR",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "El Paraíso Department",
      "state_code": "EP",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Francisco Morazán Department",
      "state_code": "FM",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Gracias a Dios Department",
      "state_code": "GD",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Intibucá Department",
      "state_code": "IN",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "La Paz Department",
      "state_code": "LP",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Lempira Department",
      "state_code": "LE",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Ocotepeque Department",
      "state_code": "OC",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Olancho Department",
      "state_code": "OL",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Santa Bárbara Department",
      "state_code": "SB",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Valle Department",
      "state_code": "VA",
      "country_id": 97
    },
    {
      "country_code": "HN",
      "country_name": "Honduras",
      "name": "Yoro Department",
      "state_code": "YO",
      "country_id": 97
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Central and Western District",
      "state_code": "HCW",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Eastern",
      "state_code": "HEA",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Islands District",
      "state_code": "NIS",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Kowloon City",
      "state_code": "KKC",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Kwai Tsing",
      "state_code": "NKT",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Kwun Tong",
      "state_code": "KKT",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "North",
      "state_code": "NNO",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Sai Kung District",
      "state_code": "NSK",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Sha Tin",
      "state_code": "NST",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Sham Shui Po",
      "state_code": "KSS",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Southern",
      "state_code": "HSO",
      "country_id": 98
    },
    {
      "country_code": "KH",
      "country_name": "Hong Kong S.A.R.",
      "name": "Tai Po District",
      "state_code": "NTP",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Tsuen Wan District",
      "state_code": "NTW",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Tuen Mun",
      "state_code": "NTM",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Wan Chai",
      "state_code": "HWC",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Wong Tai Sin",
      "state_code": "KWT",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Yau Tsim Mong",
      "state_code": "KYT",
      "country_id": 98
    },
    {
      "country_code": "HK",
      "country_name": "Hong Kong S.A.R.",
      "name": "Yuen Long District",
      "state_code": "NYL",
      "country_id": 98
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Bács-Kiskun",
      "state_code": "BK",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Baranya",
      "state_code": "BA",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Békés",
      "state_code": "BE",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Békéscsaba",
      "state_code": "BC",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Borsod-Abaúj-Zemplén",
      "state_code": "BZ",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Budapest",
      "state_code": "BU",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Csongrád County",
      "state_code": "CS",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Debrecen",
      "state_code": "DE",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Dunaújváros",
      "state_code": "DU",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Eger",
      "state_code": "EG",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Érd",
      "state_code": "ER",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Fejér County",
      "state_code": "FE",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Győr",
      "state_code": "GY",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Győr-Moson-Sopron County",
      "state_code": "GS",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Hajdú-Bihar County",
      "state_code": "HB",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Heves County",
      "state_code": "HE",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Hódmezővásárhely",
      "state_code": "HV",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Jász-Nagykun-Szolnok County",
      "state_code": "JN",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Kaposvár",
      "state_code": "KV",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Kecskemét",
      "state_code": "KM",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Komárom-Esztergom",
      "state_code": "KE",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Miskolc",
      "state_code": "MI",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Nagykanizsa",
      "state_code": "NK",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Nógrád County",
      "state_code": "NO",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Nyíregyháza",
      "state_code": "NY",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Pécs",
      "state_code": "PS",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Pest County",
      "state_code": "PE",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Salgótarján",
      "state_code": "ST",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Somogy County",
      "state_code": "SO",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Sopron",
      "state_code": "SN",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Szabolcs-Szatmár-Bereg County",
      "state_code": "SZ",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Szeged",
      "state_code": "SD",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Székesfehérvár",
      "state_code": "SF",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Szekszárd",
      "state_code": "SS",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Szolnok",
      "state_code": "SK",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Szombathely",
      "state_code": "SH",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Tatabánya",
      "state_code": "TB",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Tolna County",
      "state_code": "TO",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Vas County",
      "state_code": "VA",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Veszprém",
      "state_code": "VM",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Veszprém County",
      "state_code": "VE",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Zala County",
      "state_code": "ZA",
      "country_id": 99
    },
    {
      "country_code": "HU",
      "country_name": "Hungary",
      "name": "Zalaegerszeg",
      "state_code": "ZE",
      "country_id": 99
    },
    {
      "country_code": "IS",
      "country_name": "Iceland",
      "name": "Capital Region",
      "state_code": "1",
      "country_id": 100
    },
    {
      "country_code": "IS",
      "country_name": "Iceland",
      "name": "Eastern Region",
      "state_code": "7",
      "country_id": 100
    },
    {
      "country_code": "IS",
      "country_name": "Iceland",
      "name": "Northeastern Region",
      "state_code": "6",
      "country_id": 100
    },
    {
      "country_code": "IS",
      "country_name": "Iceland",
      "name": "Northwestern Region",
      "state_code": "5",
      "country_id": 100
    },
    {
      "country_code": "IS",
      "country_name": "Iceland",
      "name": "Southern Peninsula Region",
      "state_code": "2",
      "country_id": 100
    },
    {
      "country_code": "IS",
      "country_name": "Iceland",
      "name": "Southern Region",
      "state_code": "8",
      "country_id": 100
    },
    {
      "country_code": "IS",
      "country_name": "Iceland",
      "name": "Western Region",
      "state_code": "3",
      "country_id": 100
    },
    {
      "country_code": "IS",
      "country_name": "Iceland",
      "name": "Westfjords",
      "state_code": "4",
      "country_id": 100
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Andaman and Nicobar Islands",
      "state_code": "AN",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Andhra Pradesh",
      "state_code": "AP",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Arunachal Pradesh",
      "state_code": "AR",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Assam",
      "state_code": "AS",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Bihar",
      "state_code": "BR",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Chandigarh",
      "state_code": "CH",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Chhattisgarh",
      "state_code": "CT",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Dadra and Nagar Haveli and Daman and Diu",
      "state_code": "DH",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Delhi",
      "state_code": "DL",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Goa",
      "state_code": "GA",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Gujarat",
      "state_code": "GJ",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Haryana",
      "state_code": "HR",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Himachal Pradesh",
      "state_code": "HP",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Jammu and Kashmir",
      "state_code": "JK",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Jharkhand",
      "state_code": "JH",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Karnataka",
      "state_code": "KA",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Kerala",
      "state_code": "KL",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Ladakh",
      "state_code": "LA",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Lakshadweep",
      "state_code": "LD",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Madhya Pradesh",
      "state_code": "MP",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Maharashtra",
      "state_code": "MH",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Manipur",
      "state_code": "MN",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Meghalaya",
      "state_code": "ML",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Mizoram",
      "state_code": "MZ",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Nagaland",
      "state_code": "NL",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Odisha",
      "state_code": "OR",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Puducherry",
      "state_code": "PY",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Punjab",
      "state_code": "PB",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Rajasthan",
      "state_code": "RJ",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Sikkim",
      "state_code": "SK",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Tamil Nadu",
      "state_code": "TN",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Telangana",
      "state_code": "TG",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Tripura",
      "state_code": "TR",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Uttar Pradesh",
      "state_code": "UP",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "Uttarakhand",
      "state_code": "UT",
      "country_id": 101
    },
    {
      "country_code": "IN",
      "country_name": "India",
      "name": "West Bengal",
      "state_code": "WB",
      "country_id": 101
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Aceh",
      "state_code": "AC",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Bali",
      "state_code": "BA",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Banten",
      "state_code": "BT",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Bengkulu",
      "state_code": "BE",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "DI Yogyakarta",
      "state_code": "YO",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "DKI Jakarta",
      "state_code": "JK",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Gorontalo",
      "state_code": "GO",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Jambi",
      "state_code": "JA",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Jawa Barat",
      "state_code": "JB",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Jawa Tengah",
      "state_code": "JT",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Jawa Timur",
      "state_code": "JI",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Kalimantan Barat",
      "state_code": "KB",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Kalimantan Selatan",
      "state_code": "KS",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Kalimantan Tengah",
      "state_code": "KT",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Kalimantan Timur",
      "state_code": "KI",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Kalimantan Utara",
      "state_code": "KU",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Kepulauan Bangka Belitung",
      "state_code": "BB",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Kepulauan Riau",
      "state_code": "KR",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Lampung",
      "state_code": "LA",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Maluku",
      "state_code": "MA",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Maluku Utara",
      "state_code": "MU",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Nusa Tenggara Barat",
      "state_code": "NB",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Nusa Tenggara Timur",
      "state_code": "NT",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Papua",
      "state_code": "PA",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Papua Barat",
      "state_code": "PB",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Riau",
      "state_code": "RI",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Sulawesi Barat",
      "state_code": "SR",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Sulawesi Selatan",
      "state_code": "SN",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Sulawesi Tengah",
      "state_code": "ST",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Sulawesi Tenggara",
      "state_code": "SG",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Sulawesi Utara",
      "state_code": "SA",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Sumatera Barat",
      "state_code": "SB",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Sumatera Selatan",
      "state_code": "SS",
      "country_id": 102
    },
    {
      "country_code": "ID",
      "country_name": "Indonesia",
      "name": "Sumatera Utara",
      "state_code": "SU",
      "country_id": 102
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Alborz",
      "state_code": "30",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Ardabil",
      "state_code": "24",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Bushehr",
      "state_code": "18",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Chaharmahal and Bakhtiari",
      "state_code": "14",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "East Azerbaijan",
      "state_code": "03",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Fars",
      "state_code": "07",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Gilan",
      "state_code": "01",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Golestan",
      "state_code": "27",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Hamadan",
      "state_code": "13",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Hormozgan",
      "state_code": "22",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Ilam",
      "state_code": "16",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Isfahan",
      "state_code": "10",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Kerman",
      "state_code": "08",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Kermanshah",
      "state_code": "05",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Khuzestan",
      "state_code": "06",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Kohgiluyeh and Boyer-Ahmad",
      "state_code": "17",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Kurdistan",
      "state_code": "12",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Lorestan",
      "state_code": "15",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Markazi",
      "state_code": "00",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Mazandaran",
      "state_code": "02",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "North Khorasan",
      "state_code": "28",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Qazvin",
      "state_code": "26",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Qom",
      "state_code": "25",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Razavi Khorasan",
      "state_code": "09",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Semnan",
      "state_code": "20",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Sistan and Baluchestan",
      "state_code": "11",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "South Khorasan",
      "state_code": "29",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Tehran",
      "state_code": "23",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "West Azarbaijan",
      "state_code": "04",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Yazd",
      "state_code": "21",
      "country_id": 103
    },
    {
      "country_code": "IR",
      "country_name": "Iran",
      "name": "Zanjan",
      "state_code": "19",
      "country_id": 103
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Al Anbar",
      "state_code": "AN",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Al Muthanna",
      "state_code": "MU",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Al-Qādisiyyah",
      "state_code": "QA",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Babylon",
      "state_code": "BB",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Baghdad",
      "state_code": "BG",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Basra",
      "state_code": "BA",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Dhi Qar",
      "state_code": "DQ",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Diyala",
      "state_code": "DI",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Dohuk",
      "state_code": "DA",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Erbil",
      "state_code": "AR",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Karbala",
      "state_code": "KA",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Kirkuk",
      "state_code": "KI",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Maysan",
      "state_code": "MA",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Najaf",
      "state_code": "NA",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Nineveh",
      "state_code": "NI",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Saladin",
      "state_code": "SD",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Sulaymaniyah",
      "state_code": "SU",
      "country_id": 104
    },
    {
      "country_code": "IQ",
      "country_name": "Iraq",
      "name": "Wasit",
      "state_code": "WA",
      "country_id": 104
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Carlow",
      "state_code": "CW",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Cavan",
      "state_code": "CN",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Clare",
      "state_code": "CE",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Connacht",
      "state_code": "C",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Cork",
      "state_code": "CO",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Donegal",
      "state_code": "DL",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Dublin",
      "state_code": "D",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Galway",
      "state_code": "G",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Kerry",
      "state_code": "KY",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Kildare",
      "state_code": "KE",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Kilkenny",
      "state_code": "KK",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Laois",
      "state_code": "LS",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Leinster",
      "state_code": "L",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Limerick",
      "state_code": "LK",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Longford",
      "state_code": "LD",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Louth",
      "state_code": "LH",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Mayo",
      "state_code": "MO",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Meath",
      "state_code": "MH",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Monaghan",
      "state_code": "MN",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Munster",
      "state_code": "M",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Offaly",
      "state_code": "OY",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Roscommon",
      "state_code": "RN",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Sligo",
      "state_code": "SO",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Tipperary",
      "state_code": "TA",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Ulster",
      "state_code": "U",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Waterford",
      "state_code": "WD",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Westmeath",
      "state_code": "WH",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Wexford",
      "state_code": "WX",
      "country_id": 105
    },
    {
      "country_code": "IE",
      "country_name": "Ireland",
      "name": "Wicklow",
      "state_code": "WW",
      "country_id": 105
    },
    {
      "country_code": "IL",
      "country_name": "Israel",
      "name": "Central District",
      "state_code": "M",
      "country_id": 106
    },
    {
      "country_code": "IL",
      "country_name": "Israel",
      "name": "Haifa District",
      "state_code": "HA",
      "country_id": 106
    },
    {
      "country_code": "IL",
      "country_name": "Israel",
      "name": "Jerusalem District",
      "state_code": "JM",
      "country_id": 106
    },
    {
      "country_code": "IL",
      "country_name": "Israel",
      "name": "Northern District",
      "state_code": "Z",
      "country_id": 106
    },
    {
      "country_code": "IL",
      "country_name": "Israel",
      "name": "Southern District",
      "state_code": "D",
      "country_id": 106
    },
    {
      "country_code": "IL",
      "country_name": "Israel",
      "name": "Tel Aviv District",
      "state_code": "TA",
      "country_id": 106
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Abruzzo",
      "state_code": "65",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Agrigento",
      "state_code": "AG",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Alessandria",
      "state_code": "AL",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Ancona",
      "state_code": "AN",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Aosta Valley",
      "state_code": "23",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Apulia",
      "state_code": "75",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Ascoli Piceno",
      "state_code": "AP",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Asti",
      "state_code": "AT",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Avellino",
      "state_code": "AV",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Barletta-Andria-Trani",
      "state_code": "BT",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Basilicata",
      "state_code": "77",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Belluno",
      "state_code": "BL",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Benevento",
      "state_code": "BN",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Bergamo",
      "state_code": "BG",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Biella",
      "state_code": "BI",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Brescia",
      "state_code": "BS",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Brindisi",
      "state_code": "BR",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Calabria",
      "state_code": "78",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Caltanissetta",
      "state_code": "CL",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Campania",
      "state_code": "72",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Campobasso",
      "state_code": "CB",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Caserta",
      "state_code": "CE",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Catanzaro",
      "state_code": "CZ",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Chieti",
      "state_code": "CH",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Como",
      "state_code": "CO",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Cosenza",
      "state_code": "CS",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Cremona",
      "state_code": "CR",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Crotone",
      "state_code": "KR",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Cuneo",
      "state_code": "CN",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Emilia-Romagna",
      "state_code": "45",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Enna",
      "state_code": "EN",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Fermo",
      "state_code": "FM",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Ferrara",
      "state_code": "FE",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Foggia",
      "state_code": "FG",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Forlì-Cesena",
      "state_code": "FC",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Friuli–Venezia Giulia",
      "state_code": "36",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Frosinone",
      "state_code": "FR",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Gorizia",
      "state_code": "GO",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Grosseto",
      "state_code": "GR",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Imperia",
      "state_code": "IM",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Isernia",
      "state_code": "IS",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "L'Aquila",
      "state_code": "AQ",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "La Spezia",
      "state_code": "SP",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Latina",
      "state_code": "LT",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Lazio",
      "state_code": "62",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Lecce",
      "state_code": "LE",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Lecco",
      "state_code": "LC",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Liguria",
      "state_code": "42",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Livorno",
      "state_code": "LI",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Lodi",
      "state_code": "LO",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Lombardy",
      "state_code": "25",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Lucca",
      "state_code": "LU",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Macerata",
      "state_code": "MC",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Mantua",
      "state_code": "MN",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Marche",
      "state_code": "57",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Massa and Carrara",
      "state_code": "MS",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Matera",
      "state_code": "MT",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Medio Campidano",
      "state_code": "VS",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Modena",
      "state_code": "MO",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Molise",
      "state_code": "67",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Monza and Brianza",
      "state_code": "MB",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Novara",
      "state_code": "NO",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Nuoro",
      "state_code": "NU",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Oristano",
      "state_code": "OR",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Padua",
      "state_code": "PD",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Palermo",
      "state_code": "PA",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Parma",
      "state_code": "PR",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Pavia",
      "state_code": "PV",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Perugia",
      "state_code": "PG",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Pesaro and Urbino",
      "state_code": "PU",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Pescara",
      "state_code": "PE",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Piacenza",
      "state_code": "PC",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Piedmont",
      "state_code": "21",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Pisa",
      "state_code": "PI",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Pistoia",
      "state_code": "PT",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Pordenone",
      "state_code": "PN",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Potenza",
      "state_code": "PZ",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Prato",
      "state_code": "PO",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Ragusa",
      "state_code": "RG",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Ravenna",
      "state_code": "RA",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Reggio Emilia",
      "state_code": "RE",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Rieti",
      "state_code": "RI",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Rimini",
      "state_code": "RN",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Rovigo",
      "state_code": "RO",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Salerno",
      "state_code": "SA",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Sardinia",
      "state_code": "88",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Sassari",
      "state_code": "SS",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Savona",
      "state_code": "SV",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Sicily",
      "state_code": "82",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Siena",
      "state_code": "SI",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Siracusa",
      "state_code": "SR",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Sondrio",
      "state_code": "SO",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "South Sardinia",
      "state_code": "SU",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Taranto",
      "state_code": "TA",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Teramo",
      "state_code": "TE",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Terni",
      "state_code": "TR",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Trapani",
      "state_code": "TP",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Trentino-South Tyrol",
      "state_code": "32",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Treviso",
      "state_code": "TV",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Trieste",
      "state_code": "TS",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Tuscany",
      "state_code": "52",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Udine",
      "state_code": "UD",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Umbria",
      "state_code": "55",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Varese",
      "state_code": "VA",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Veneto",
      "state_code": "34",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Verbano-Cusio-Ossola",
      "state_code": "VB",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Vercelli",
      "state_code": "VC",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Verona",
      "state_code": "VR",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Vibo Valentia",
      "state_code": "VV",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Vicenza",
      "state_code": "VI",
      "country_id": 107
    },
    {
      "country_code": "IT",
      "country_name": "Italy",
      "name": "Viterbo",
      "state_code": "VT",
      "country_id": 107
    },
    {
      "country_code": "JM",
      "country_name": "Jamaica",
      "name": "Clarendon Parish",
      "state_code": "13",
      "country_id": 108
    },
    {
      "country_code": "JM",
      "country_name": "Jamaica",
      "name": "Hanover Parish",
      "state_code": "09",
      "country_id": 108
    },
    {
      "country_code": "JM",
      "country_name": "Jamaica",
      "name": "Kingston Parish",
      "state_code": "01",
      "country_id": 108
    },
    {
      "country_code": "JM",
      "country_name": "Jamaica",
      "name": "Manchester Parish",
      "state_code": "12",
      "country_id": 108
    },
    {
      "country_code": "JM",
      "country_name": "Jamaica",
      "name": "Portland Parish",
      "state_code": "04",
      "country_id": 108
    },
    {
      "country_code": "JM",
      "country_name": "Jamaica",
      "name": "Saint Andrew",
      "state_code": "02",
      "country_id": 108
    },
    {
      "country_code": "JM",
      "country_name": "Jamaica",
      "name": "Saint Ann Parish",
      "state_code": "06",
      "country_id": 108
    },
    {
      "country_code": "JM",
      "country_name": "Jamaica",
      "name": "Saint Catherine Parish",
      "state_code": "14",
      "country_id": 108
    },
    {
      "country_code": "JM",
      "country_name": "Jamaica",
      "name": "Saint Elizabeth Parish",
      "state_code": "11",
      "country_id": 108
    },
    {
      "country_code": "JM",
      "country_name": "Jamaica",
      "name": "Saint James Parish",
      "state_code": "08",
      "country_id": 108
    },
    {
      "country_code": "JM",
      "country_name": "Jamaica",
      "name": "Saint Mary Parish",
      "state_code": "05",
      "country_id": 108
    },
    {
      "country_code": "JM",
      "country_name": "Jamaica",
      "name": "Saint Thomas Parish",
      "state_code": "03",
      "country_id": 108
    },
    {
      "country_code": "JM",
      "country_name": "Jamaica",
      "name": "Trelawny Parish",
      "state_code": "07",
      "country_id": 108
    },
    {
      "country_code": "JM",
      "country_name": "Jamaica",
      "name": "Westmoreland Parish",
      "state_code": "10",
      "country_id": 108
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Aichi Prefecture",
      "state_code": "23",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Akita Prefecture",
      "state_code": "05",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Aomori Prefecture",
      "state_code": "02",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Chiba Prefecture",
      "state_code": "12",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Ehime Prefecture",
      "state_code": "38",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Fukui Prefecture",
      "state_code": "18",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Fukuoka Prefecture",
      "state_code": "40",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Fukushima Prefecture",
      "state_code": "07",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Gifu Prefecture",
      "state_code": "21",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Gunma Prefecture",
      "state_code": "10",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Hiroshima Prefecture",
      "state_code": "34",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Hokkaidō Prefecture",
      "state_code": "01",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Hyōgo Prefecture",
      "state_code": "28",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Ibaraki Prefecture",
      "state_code": "08",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Ishikawa Prefecture",
      "state_code": "17",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Iwate Prefecture",
      "state_code": "03",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Kagawa Prefecture",
      "state_code": "37",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Kagoshima Prefecture",
      "state_code": "46",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Kanagawa Prefecture",
      "state_code": "14",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Kōchi Prefecture",
      "state_code": "39",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Kumamoto Prefecture",
      "state_code": "43",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Kyōto Prefecture",
      "state_code": "26",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Mie Prefecture",
      "state_code": "24",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Miyagi Prefecture",
      "state_code": "04",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Miyazaki Prefecture",
      "state_code": "45",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Nagano Prefecture",
      "state_code": "20",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Nagasaki Prefecture",
      "state_code": "42",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Nara Prefecture",
      "state_code": "29",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Niigata Prefecture",
      "state_code": "15",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Ōita Prefecture",
      "state_code": "44",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Okayama Prefecture",
      "state_code": "33",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Okinawa Prefecture",
      "state_code": "47",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Ōsaka Prefecture",
      "state_code": "27",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Saga Prefecture",
      "state_code": "41",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Saitama Prefecture",
      "state_code": "11",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Shiga Prefecture",
      "state_code": "25",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Shimane Prefecture",
      "state_code": "32",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Shizuoka Prefecture",
      "state_code": "22",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Tochigi Prefecture",
      "state_code": "09",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Tokushima Prefecture",
      "state_code": "36",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Tokyo",
      "state_code": "13",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Tottori Prefecture",
      "state_code": "31",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Toyama Prefecture",
      "state_code": "16",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Wakayama Prefecture",
      "state_code": "30",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Yamagata Prefecture",
      "state_code": "06",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Yamaguchi Prefecture",
      "state_code": "35",
      "country_id": 109
    },
    {
      "country_code": "JP",
      "country_name": "Japan",
      "name": "Yamanashi Prefecture",
      "state_code": "19",
      "country_id": 109
    },
    {
      "country_code": "JO",
      "country_name": "Jordan",
      "name": "Ajloun",
      "state_code": "AJ",
      "country_id": 111
    },
    {
      "country_code": "JO",
      "country_name": "Jordan",
      "name": "Amman",
      "state_code": "AM",
      "country_id": 111
    },
    {
      "country_code": "JO",
      "country_name": "Jordan",
      "name": "Aqaba",
      "state_code": "AQ",
      "country_id": 111
    },
    {
      "country_code": "JO",
      "country_name": "Jordan",
      "name": "Balqa",
      "state_code": "BA",
      "country_id": 111
    },
    {
      "country_code": "JO",
      "country_name": "Jordan",
      "name": "Irbid",
      "state_code": "IR",
      "country_id": 111
    },
    {
      "country_code": "JO",
      "country_name": "Jordan",
      "name": "Jerash",
      "state_code": "JA",
      "country_id": 111
    },
    {
      "country_code": "JO",
      "country_name": "Jordan",
      "name": "Karak",
      "state_code": "KA",
      "country_id": 111
    },
    {
      "country_code": "JO",
      "country_name": "Jordan",
      "name": "Ma'an",
      "state_code": "MN",
      "country_id": 111
    },
    {
      "country_code": "JO",
      "country_name": "Jordan",
      "name": "Madaba",
      "state_code": "MD",
      "country_id": 111
    },
    {
      "country_code": "JO",
      "country_name": "Jordan",
      "name": "Mafraq",
      "state_code": "MA",
      "country_id": 111
    },
    {
      "country_code": "JO",
      "country_name": "Jordan",
      "name": "Tafilah",
      "state_code": "AT",
      "country_id": 111
    },
    {
      "country_code": "JO",
      "country_name": "Jordan",
      "name": "Zarqa",
      "state_code": "AZ",
      "country_id": 111
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "Akmola Region",
      "state_code": "AKM",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "Aktobe Region",
      "state_code": "AKT",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "Almaty",
      "state_code": "ALA",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "Almaty Region",
      "state_code": "ALM",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "Atyrau Region",
      "state_code": "ATY",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "Baikonur",
      "state_code": "BAY",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "East Kazakhstan Region",
      "state_code": "VOS",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "Jambyl Region",
      "state_code": "ZHA",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "Karaganda Region",
      "state_code": "KAR",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "Kostanay Region",
      "state_code": "KUS",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "Kyzylorda Region",
      "state_code": "KZY",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "Mangystau Region",
      "state_code": "MAN",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "North Kazakhstan Region",
      "state_code": "SEV",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "Nur-Sultan",
      "state_code": "AST",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "Pavlodar Region",
      "state_code": "PAV",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "Turkestan Region",
      "state_code": "YUZ",
      "country_id": 112
    },
    {
      "country_code": "KZ",
      "country_name": "Kazakhstan",
      "name": "West Kazakhstan Province",
      "state_code": "ZAP",
      "country_id": 112
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Baringo",
      "state_code": "01",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Bomet",
      "state_code": "02",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Bungoma",
      "state_code": "03",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Busia",
      "state_code": "04",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Elgeyo-Marakwet",
      "state_code": "05",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Embu",
      "state_code": "06",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Garissa",
      "state_code": "07",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Homa Bay",
      "state_code": "08",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Isiolo",
      "state_code": "09",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Kajiado",
      "state_code": "10",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Kakamega",
      "state_code": "11",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Kericho",
      "state_code": "12",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Kiambu",
      "state_code": "13",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Kilifi",
      "state_code": "14",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Kirinyaga",
      "state_code": "15",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Kisii",
      "state_code": "16",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Kisumu",
      "state_code": "17",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Kitui",
      "state_code": "18",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Kwale",
      "state_code": "19",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Laikipia",
      "state_code": "20",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Lamu",
      "state_code": "21",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Machakos",
      "state_code": "22",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Makueni",
      "state_code": "23",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Mandera",
      "state_code": "24",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Marsabit",
      "state_code": "25",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Meru",
      "state_code": "26",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Migori",
      "state_code": "27",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Mombasa",
      "state_code": "28",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Murang'a",
      "state_code": "29",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Nairobi City",
      "state_code": "30",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Nakuru",
      "state_code": "31",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Nandi",
      "state_code": "32",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Narok",
      "state_code": "33",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Nyamira",
      "state_code": "34",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Nyandarua",
      "state_code": "35",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Nyeri",
      "state_code": "36",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Samburu",
      "state_code": "37",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Siaya",
      "state_code": "38",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Taita–Taveta",
      "state_code": "39",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Tana River",
      "state_code": "40",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Tharaka-Nithi",
      "state_code": "41",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Trans Nzoia",
      "state_code": "42",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Turkana",
      "state_code": "43",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Uasin Gishu",
      "state_code": "44",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Vihiga",
      "state_code": "45",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "Wajir",
      "state_code": "46",
      "country_id": 113
    },
    {
      "country_code": "KE",
      "country_name": "Kenya",
      "name": "West Pokot",
      "state_code": "47",
      "country_id": 113
    },
    {
      "country_code": "KI",
      "country_name": "Kiribati",
      "name": "Gilbert Islands",
      "state_code": "G",
      "country_id": 114
    },
    {
      "country_code": "KI",
      "country_name": "Kiribati",
      "name": "Line Islands",
      "state_code": "L",
      "country_id": 114
    },
    {
      "country_code": "KI",
      "country_name": "Kiribati",
      "name": "Phoenix Islands",
      "state_code": "P",
      "country_id": 114
    },
    {
      "country_code": "XK",
      "country_name": "Kosovo",
      "name": "Đakovica District (Gjakove)",
      "state_code": "XDG",
      "country_id": 248
    },
    {
      "country_code": "XK",
      "country_name": "Kosovo",
      "name": "Gjilan District",
      "state_code": "XGJ",
      "country_id": 248
    },
    {
      "country_code": "XK",
      "country_name": "Kosovo",
      "name": "Kosovska Mitrovica District",
      "state_code": "XKM",
      "country_id": 248
    },
    {
      "country_code": "XK",
      "country_name": "Kosovo",
      "name": "Peć District",
      "state_code": "XPE",
      "country_id": 248
    },
    {
      "country_code": "XK",
      "country_name": "Kosovo",
      "name": "Pristina (Priştine)",
      "state_code": "XPI",
      "country_id": 248
    },
    {
      "country_code": "XK",
      "country_name": "Kosovo",
      "name": "Prizren District",
      "state_code": "XPR",
      "country_id": 248
    },
    {
      "country_code": "XK",
      "country_name": "Kosovo",
      "name": "Uroševac District (Ferizaj)",
      "state_code": "XUF",
      "country_id": 248
    },
    {
      "country_code": "KW",
      "country_name": "Kuwait",
      "name": "Al Ahmadi",
      "state_code": "AH",
      "country_id": 117
    },
    {
      "country_code": "KW",
      "country_name": "Kuwait",
      "name": "Al Farwaniyah",
      "state_code": "FA",
      "country_id": 117
    },
    {
      "country_code": "KW",
      "country_name": "Kuwait",
      "name": "Al Jahra",
      "state_code": "JA",
      "country_id": 117
    },
    {
      "country_code": "KW",
      "country_name": "Kuwait",
      "name": "Capital",
      "state_code": "KU",
      "country_id": 117
    },
    {
      "country_code": "KW",
      "country_name": "Kuwait",
      "name": "Hawalli",
      "state_code": "HA",
      "country_id": 117
    },
    {
      "country_code": "KW",
      "country_name": "Kuwait",
      "name": "Mubarak Al-Kabeer",
      "state_code": "MU",
      "country_id": 117
    },
    {
      "country_code": "KG",
      "country_name": "Kyrgyzstan",
      "name": "Batken Region",
      "state_code": "B",
      "country_id": 118
    },
    {
      "country_code": "KG",
      "country_name": "Kyrgyzstan",
      "name": "Bishkek",
      "state_code": "GB",
      "country_id": 118
    },
    {
      "country_code": "KG",
      "country_name": "Kyrgyzstan",
      "name": "Chuy Region",
      "state_code": "C",
      "country_id": 118
    },
    {
      "country_code": "KG",
      "country_name": "Kyrgyzstan",
      "name": "Issyk-Kul Region",
      "state_code": "Y",
      "country_id": 118
    },
    {
      "country_code": "KG",
      "country_name": "Kyrgyzstan",
      "name": "Jalal-Abad Region",
      "state_code": "J",
      "country_id": 118
    },
    {
      "country_code": "KG",
      "country_name": "Kyrgyzstan",
      "name": "Naryn Region",
      "state_code": "N",
      "country_id": 118
    },
    {
      "country_code": "KG",
      "country_name": "Kyrgyzstan",
      "name": "Osh",
      "state_code": "GO",
      "country_id": 118
    },
    {
      "country_code": "KG",
      "country_name": "Kyrgyzstan",
      "name": "Osh Region",
      "state_code": "O",
      "country_id": 118
    },
    {
      "country_code": "KG",
      "country_name": "Kyrgyzstan",
      "name": "Talas Region",
      "state_code": "T",
      "country_id": 118
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Attapeu Province",
      "state_code": "AT",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Bokeo Province",
      "state_code": "BK",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Bolikhamsai Province",
      "state_code": "BL",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Champasak Province",
      "state_code": "CH",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Houaphanh Province",
      "state_code": "HO",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Khammouane Province",
      "state_code": "KH",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Luang Namtha Province",
      "state_code": "LM",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Luang Prabang Province",
      "state_code": "LP",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Oudomxay Province",
      "state_code": "OU",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Phongsaly Province",
      "state_code": "PH",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Sainyabuli Province",
      "state_code": "XA",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Salavan Province",
      "state_code": "SL",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Savannakhet Province",
      "state_code": "SV",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Sekong Province",
      "state_code": "XE",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Vientiane Prefecture",
      "state_code": "VT",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Vientiane Province",
      "state_code": "VI",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Xaisomboun",
      "state_code": "XN",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Xaisomboun Province",
      "state_code": "XS",
      "country_id": 119
    },
    {
      "country_code": "LA",
      "country_name": "Laos",
      "name": "Xiangkhouang Province",
      "state_code": "XI",
      "country_id": 119
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Aglona Municipality",
      "state_code": "001",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Aizkraukle Municipality",
      "state_code": "002",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Aizpute Municipality",
      "state_code": "003",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Aknīste Municipality",
      "state_code": "004",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Aloja Municipality",
      "state_code": "005",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Alsunga Municipality",
      "state_code": "006",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Alūksne Municipality",
      "state_code": "007",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Amata Municipality",
      "state_code": "008",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Ape Municipality",
      "state_code": "009",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Auce Municipality",
      "state_code": "010",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Babīte Municipality",
      "state_code": "012",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Baldone Municipality",
      "state_code": "013",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Baltinava Municipality",
      "state_code": "014",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Balvi Municipality",
      "state_code": "015",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Bauska Municipality",
      "state_code": "016",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Beverīna Municipality",
      "state_code": "017",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Brocēni Municipality",
      "state_code": "018",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Burtnieki Municipality",
      "state_code": "019",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Carnikava Municipality",
      "state_code": "020",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Cēsis Municipality",
      "state_code": "022",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Cesvaine Municipality",
      "state_code": "021",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Cibla Municipality",
      "state_code": "023",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Dagda Municipality",
      "state_code": "024",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Daugavpils",
      "state_code": "DGV",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Daugavpils Municipality",
      "state_code": "025",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Dobele Municipality",
      "state_code": "026",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Dundaga Municipality",
      "state_code": "027",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Durbe Municipality",
      "state_code": "028",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Engure Municipality",
      "state_code": "029",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Ērgļi Municipality",
      "state_code": "030",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Garkalne Municipality",
      "state_code": "031",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Grobiņa Municipality",
      "state_code": "032",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Gulbene Municipality",
      "state_code": "033",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Iecava Municipality",
      "state_code": "034",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Ikšķile Municipality",
      "state_code": "035",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Ilūkste Municipality",
      "state_code": "036",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Inčukalns Municipality",
      "state_code": "037",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Jaunjelgava Municipality",
      "state_code": "038",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Jaunpiebalga Municipality",
      "state_code": "039",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Jaunpils Municipality",
      "state_code": "040",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Jēkabpils",
      "state_code": "JKB",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Jēkabpils Municipality",
      "state_code": "042",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Jelgava",
      "state_code": "JEL",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Jelgava Municipality",
      "state_code": "041",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Jūrmala",
      "state_code": "JUR",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Kandava Municipality",
      "state_code": "043",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Kārsava Municipality",
      "state_code": "044",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Ķegums Municipality",
      "state_code": "051",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Ķekava Municipality",
      "state_code": "052",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Kocēni Municipality",
      "state_code": "045",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Koknese Municipality",
      "state_code": "046",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Krāslava Municipality",
      "state_code": "047",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Krimulda Municipality",
      "state_code": "048",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Krustpils Municipality",
      "state_code": "049",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Kuldīga Municipality",
      "state_code": "050",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Lielvārde Municipality",
      "state_code": "053",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Liepāja",
      "state_code": "LPX",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Līgatne Municipality",
      "state_code": "055",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Limbaži Municipality",
      "state_code": "054",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Līvāni Municipality",
      "state_code": "056",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Lubāna Municipality",
      "state_code": "057",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Ludza Municipality",
      "state_code": "058",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Madona Municipality",
      "state_code": "059",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Mālpils Municipality",
      "state_code": "061",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Mārupe Municipality",
      "state_code": "062",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Mazsalaca Municipality",
      "state_code": "060",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Mērsrags Municipality",
      "state_code": "063",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Naukšēni Municipality",
      "state_code": "064",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Nereta Municipality",
      "state_code": "065",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Nīca Municipality",
      "state_code": "066",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Ogre Municipality",
      "state_code": "067",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Olaine Municipality",
      "state_code": "068",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Ozolnieki Municipality",
      "state_code": "069",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Pārgauja Municipality",
      "state_code": "070",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Pāvilosta Municipality",
      "state_code": "071",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Pļaviņas Municipality",
      "state_code": "072",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Preiļi Municipality",
      "state_code": "073",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Priekule Municipality",
      "state_code": "074",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Priekuļi Municipality",
      "state_code": "075",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Rauna Municipality",
      "state_code": "076",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Rēzekne",
      "state_code": "REZ",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Rēzekne Municipality",
      "state_code": "077",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Riebiņi Municipality",
      "state_code": "078",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Riga",
      "state_code": "RIX",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Roja Municipality",
      "state_code": "079",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Ropaži Municipality",
      "state_code": "080",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Rucava Municipality",
      "state_code": "081",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Rugāji Municipality",
      "state_code": "082",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Rūjiena Municipality",
      "state_code": "084",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Rundāle Municipality",
      "state_code": "083",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Sala Municipality",
      "state_code": "085",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Salacgrīva Municipality",
      "state_code": "086",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Salaspils Municipality",
      "state_code": "087",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Saldus Municipality",
      "state_code": "088",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Saulkrasti Municipality",
      "state_code": "089",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Sēja Municipality",
      "state_code": "090",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Sigulda Municipality",
      "state_code": "091",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Skrīveri Municipality",
      "state_code": "092",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Skrunda Municipality",
      "state_code": "093",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Smiltene Municipality",
      "state_code": "094",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Stopiņi Municipality",
      "state_code": "095",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Strenči Municipality",
      "state_code": "096",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Talsi Municipality",
      "state_code": "097",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Tērvete Municipality",
      "state_code": "098",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Tukums Municipality",
      "state_code": "099",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Vaiņode Municipality",
      "state_code": "100",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Valka Municipality",
      "state_code": "101",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Valmiera",
      "state_code": "VMR",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Varakļāni Municipality",
      "state_code": "102",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Vārkava Municipality",
      "state_code": "103",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Vecpiebalga Municipality",
      "state_code": "104",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Vecumnieki Municipality",
      "state_code": "105",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Ventspils",
      "state_code": "VEN",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Ventspils Municipality",
      "state_code": "106",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Viesīte Municipality",
      "state_code": "107",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Viļaka Municipality",
      "state_code": "108",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Viļāni Municipality",
      "state_code": "109",
      "country_id": 120
    },
    {
      "country_code": "LV",
      "country_name": "Latvia",
      "name": "Zilupe Municipality",
      "state_code": "110",
      "country_id": 120
    },
    {
      "country_code": "LB",
      "country_name": "Lebanon",
      "name": "Akkar",
      "state_code": "AK",
      "country_id": 121
    },
    {
      "country_code": "LB",
      "country_name": "Lebanon",
      "name": "Baalbek-Hermel",
      "state_code": "BH",
      "country_id": 121
    },
    {
      "country_code": "LB",
      "country_name": "Lebanon",
      "name": "Beirut",
      "state_code": "BA",
      "country_id": 121
    },
    {
      "country_code": "LB",
      "country_name": "Lebanon",
      "name": "Beqaa",
      "state_code": "BI",
      "country_id": 121
    },
    {
      "country_code": "LB",
      "country_name": "Lebanon",
      "name": "Mount Lebanon",
      "state_code": "JL",
      "country_id": 121
    },
    {
      "country_code": "LB",
      "country_name": "Lebanon",
      "name": "Nabatieh",
      "state_code": "NA",
      "country_id": 121
    },
    {
      "country_code": "LB",
      "country_name": "Lebanon",
      "name": "North",
      "state_code": "AS",
      "country_id": 121
    },
    {
      "country_code": "LB",
      "country_name": "Lebanon",
      "name": "South",
      "state_code": "JA",
      "country_id": 121
    },
    {
      "country_code": "LS",
      "country_name": "Lesotho",
      "name": "Berea District",
      "state_code": "D",
      "country_id": 122
    },
    {
      "country_code": "LS",
      "country_name": "Lesotho",
      "name": "Butha-Buthe District",
      "state_code": "B",
      "country_id": 122
    },
    {
      "country_code": "LS",
      "country_name": "Lesotho",
      "name": "Leribe District",
      "state_code": "C",
      "country_id": 122
    },
    {
      "country_code": "LS",
      "country_name": "Lesotho",
      "name": "Mafeteng District",
      "state_code": "E",
      "country_id": 122
    },
    {
      "country_code": "LS",
      "country_name": "Lesotho",
      "name": "Maseru District",
      "state_code": "A",
      "country_id": 122
    },
    {
      "country_code": "LS",
      "country_name": "Lesotho",
      "name": "Mohale's Hoek District",
      "state_code": "F",
      "country_id": 122
    },
    {
      "country_code": "LS",
      "country_name": "Lesotho",
      "name": "Mokhotlong District",
      "state_code": "J",
      "country_id": 122
    },
    {
      "country_code": "LS",
      "country_name": "Lesotho",
      "name": "Qacha's Nek District",
      "state_code": "H",
      "country_id": 122
    },
    {
      "country_code": "LS",
      "country_name": "Lesotho",
      "name": "Quthing District",
      "state_code": "G",
      "country_id": 122
    },
    {
      "country_code": "LS",
      "country_name": "Lesotho",
      "name": "Thaba-Tseka District",
      "state_code": "K",
      "country_id": 122
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "Bomi County",
      "state_code": "BM",
      "country_id": 123
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "Bong County",
      "state_code": "BG",
      "country_id": 123
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "Gbarpolu County",
      "state_code": "GP",
      "country_id": 123
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "Grand Bassa County",
      "state_code": "GB",
      "country_id": 123
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "Grand Cape Mount County",
      "state_code": "CM",
      "country_id": 123
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "Grand Gedeh County",
      "state_code": "GG",
      "country_id": 123
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "Grand Kru County",
      "state_code": "GK",
      "country_id": 123
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "Lofa County",
      "state_code": "LO",
      "country_id": 123
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "Margibi County",
      "state_code": "MG",
      "country_id": 123
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "Maryland County",
      "state_code": "MY",
      "country_id": 123
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "Montserrado County",
      "state_code": "MO",
      "country_id": 123
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "Nimba",
      "state_code": "NI",
      "country_id": 123
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "River Cess County",
      "state_code": "RI",
      "country_id": 123
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "River Gee County",
      "state_code": "RG",
      "country_id": 123
    },
    {
      "country_code": "LR",
      "country_name": "Liberia",
      "name": "Sinoe County",
      "state_code": "SI",
      "country_id": 123
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Al Wahat District",
      "state_code": "WA",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Benghazi",
      "state_code": "BA",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Derna District",
      "state_code": "DR",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Ghat District",
      "state_code": "GT",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Jabal al Akhdar",
      "state_code": "JA",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Jabal al Gharbi District",
      "state_code": "JG",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Jafara",
      "state_code": "JI",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Jufra",
      "state_code": "JU",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Kufra District",
      "state_code": "KF",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Marj District",
      "state_code": "MJ",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Misrata District",
      "state_code": "MI",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Murqub",
      "state_code": "MB",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Murzuq District",
      "state_code": "MQ",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Nalut District",
      "state_code": "NL",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Nuqat al Khams",
      "state_code": "NQ",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Sabha District",
      "state_code": "SB",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Sirte District",
      "state_code": "SR",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Tripoli District",
      "state_code": "TB",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Wadi al Hayaa District",
      "state_code": "WD",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Wadi al Shatii District",
      "state_code": "WS",
      "country_id": 124
    },
    {
      "country_code": "LY",
      "country_name": "Libya",
      "name": "Zawiya District",
      "state_code": "ZA",
      "country_id": 124
    },
    {
      "country_code": "LI",
      "country_name": "Liechtenstein",
      "name": "Balzers",
      "state_code": "01",
      "country_id": 125
    },
    {
      "country_code": "LI",
      "country_name": "Liechtenstein",
      "name": "Eschen",
      "state_code": "02",
      "country_id": 125
    },
    {
      "country_code": "LI",
      "country_name": "Liechtenstein",
      "name": "Gamprin",
      "state_code": "03",
      "country_id": 125
    },
    {
      "country_code": "LI",
      "country_name": "Liechtenstein",
      "name": "Mauren",
      "state_code": "04",
      "country_id": 125
    },
    {
      "country_code": "LI",
      "country_name": "Liechtenstein",
      "name": "Planken",
      "state_code": "05",
      "country_id": 125
    },
    {
      "country_code": "LI",
      "country_name": "Liechtenstein",
      "name": "Ruggell",
      "state_code": "06",
      "country_id": 125
    },
    {
      "country_code": "LI",
      "country_name": "Liechtenstein",
      "name": "Schaan",
      "state_code": "07",
      "country_id": 125
    },
    {
      "country_code": "LI",
      "country_name": "Liechtenstein",
      "name": "Schellenberg",
      "state_code": "08",
      "country_id": 125
    },
    {
      "country_code": "LI",
      "country_name": "Liechtenstein",
      "name": "Triesen",
      "state_code": "09",
      "country_id": 125
    },
    {
      "country_code": "LI",
      "country_name": "Liechtenstein",
      "name": "Triesenberg",
      "state_code": "10",
      "country_id": 125
    },
    {
      "country_code": "LI",
      "country_name": "Liechtenstein",
      "name": "Vaduz",
      "state_code": "11",
      "country_id": 125
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Akmenė District Municipality",
      "state_code": "01",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Alytus City Municipality",
      "state_code": "02",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Alytus County",
      "state_code": "AL",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Alytus District Municipality",
      "state_code": "03",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Birštonas Municipality",
      "state_code": "05",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Biržai District Municipality",
      "state_code": "06",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Druskininkai municipality",
      "state_code": "07",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Elektrėnai municipality",
      "state_code": "08",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Ignalina District Municipality",
      "state_code": "09",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Jonava District Municipality",
      "state_code": "10",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Joniškis District Municipality",
      "state_code": "11",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Jurbarkas District Municipality",
      "state_code": "12",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Kaišiadorys District Municipality",
      "state_code": "13",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Kalvarija municipality",
      "state_code": "14",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Kaunas City Municipality",
      "state_code": "15",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Kaunas County",
      "state_code": "KU",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Kaunas District Municipality",
      "state_code": "16",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Kazlų Rūda municipality",
      "state_code": "17",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Kėdainiai District Municipality",
      "state_code": "18",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Kelmė District Municipality",
      "state_code": "19",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Klaipeda City Municipality",
      "state_code": "20",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Klaipėda County",
      "state_code": "KL",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Klaipėda District Municipality",
      "state_code": "21",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Kretinga District Municipality",
      "state_code": "22",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Kupiškis District Municipality",
      "state_code": "23",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Lazdijai District Municipality",
      "state_code": "24",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Marijampolė County",
      "state_code": "MR",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Marijampolė Municipality",
      "state_code": "25",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Mažeikiai District Municipality",
      "state_code": "26",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Molėtai District Municipality",
      "state_code": "27",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Neringa Municipality",
      "state_code": "28",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Pagėgiai municipality",
      "state_code": "29",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Pakruojis District Municipality",
      "state_code": "30",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Palanga City Municipality",
      "state_code": "31",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Panevėžys City Municipality",
      "state_code": "32",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Panevėžys County",
      "state_code": "PN",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Panevėžys District Municipality",
      "state_code": "33",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Pasvalys District Municipality",
      "state_code": "34",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Plungė District Municipality",
      "state_code": "35",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Prienai District Municipality",
      "state_code": "36",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Radviliškis District Municipality",
      "state_code": "37",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Raseiniai District Municipality",
      "state_code": "38",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Rietavas municipality",
      "state_code": "39",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Rokiškis District Municipality",
      "state_code": "40",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Šakiai District Municipality",
      "state_code": "41",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Šalčininkai District Municipality",
      "state_code": "42",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Šiauliai City Municipality",
      "state_code": "43",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Šiauliai County",
      "state_code": "SA",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Šiauliai District Municipality",
      "state_code": "44",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Šilalė District Municipality",
      "state_code": "45",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Šilutė District Municipality",
      "state_code": "46",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Širvintos District Municipality",
      "state_code": "47",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Skuodas District Municipality",
      "state_code": "48",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Švenčionys District Municipality",
      "state_code": "49",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Tauragė County",
      "state_code": "TA",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Tauragė District Municipality",
      "state_code": "50",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Telšiai County",
      "state_code": "TE",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Telšiai District Municipality",
      "state_code": "51",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Trakai District Municipality",
      "state_code": "52",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Ukmergė District Municipality",
      "state_code": "53",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Utena County",
      "state_code": "UT",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Utena District Municipality",
      "state_code": "54",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Varėna District Municipality",
      "state_code": "55",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Vilkaviškis District Municipality",
      "state_code": "56",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Vilnius City Municipality",
      "state_code": "57",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Vilnius County",
      "state_code": "VL",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Vilnius District Municipality",
      "state_code": "58",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Visaginas Municipality",
      "state_code": "59",
      "country_id": 126
    },
    {
      "country_code": "LT",
      "country_name": "Lithuania",
      "name": "Zarasai District Municipality",
      "state_code": "60",
      "country_id": 126
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Canton of Capellen",
      "state_code": "CA",
      "country_id": 127
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Canton of Clervaux",
      "state_code": "CL",
      "country_id": 127
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Canton of Diekirch",
      "state_code": "DI",
      "country_id": 127
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Canton of Echternach",
      "state_code": "EC",
      "country_id": 127
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Canton of Esch-sur-Alzette",
      "state_code": "ES",
      "country_id": 127
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Canton of Grevenmacher",
      "state_code": "GR",
      "country_id": 127
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Canton of Luxembourg",
      "state_code": "LU",
      "country_id": 127
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Canton of Mersch",
      "state_code": "ME",
      "country_id": 127
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Canton of Redange",
      "state_code": "RD",
      "country_id": 127
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Canton of Remich",
      "state_code": "RM",
      "country_id": 127
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Canton of Vianden",
      "state_code": "VD",
      "country_id": 127
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Canton of Wiltz",
      "state_code": "WI",
      "country_id": 127
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Diekirch District",
      "state_code": "D",
      "country_id": 127
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Grevenmacher District",
      "state_code": "G",
      "country_id": 127
    },
    {
      "country_code": "LU",
      "country_name": "Luxembourg",
      "name": "Luxembourg District",
      "state_code": "L",
      "country_id": 127
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Aerodrom Municipality",
      "state_code": "01",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Aračinovo Municipality",
      "state_code": "02",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Berovo Municipality",
      "state_code": "03",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Bitola Municipality",
      "state_code": "04",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Bogdanci Municipality",
      "state_code": "05",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Bogovinje Municipality",
      "state_code": "06",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Bosilovo Municipality",
      "state_code": "07",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Brvenica Municipality",
      "state_code": "08",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Butel Municipality",
      "state_code": "09",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Čair Municipality",
      "state_code": "79",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Čaška Municipality",
      "state_code": "80",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Centar Municipality",
      "state_code": "77",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Centar Župa Municipality",
      "state_code": "78",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Češinovo-Obleševo Municipality",
      "state_code": "81",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Čučer-Sandevo Municipality",
      "state_code": "82",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Debarca Municipality",
      "state_code": "22",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Delčevo Municipality",
      "state_code": "23",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Demir Hisar Municipality",
      "state_code": "25",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Demir Kapija Municipality",
      "state_code": "24",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Dojran Municipality",
      "state_code": "26",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Dolneni Municipality",
      "state_code": "27",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Drugovo Municipality",
      "state_code": "28",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Gazi Baba Municipality",
      "state_code": "17",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Gevgelija Municipality",
      "state_code": "18",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Gjorče Petrov Municipality",
      "state_code": "29",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Gostivar Municipality",
      "state_code": "19",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Gradsko Municipality",
      "state_code": "20",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Greater Skopje",
      "state_code": "85",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Ilinden Municipality",
      "state_code": "34",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Jegunovce Municipality",
      "state_code": "35",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Karbinci",
      "state_code": "37",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Karpoš Municipality",
      "state_code": "38",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Kavadarci Municipality",
      "state_code": "36",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Kičevo Municipality",
      "state_code": "40",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Kisela Voda Municipality",
      "state_code": "39",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Kočani Municipality",
      "state_code": "42",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Konče Municipality",
      "state_code": "41",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Kratovo Municipality",
      "state_code": "43",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Kriva Palanka Municipality",
      "state_code": "44",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Krivogaštani Municipality",
      "state_code": "45",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Kruševo Municipality",
      "state_code": "46",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Kumanovo Municipality",
      "state_code": "47",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Lipkovo Municipality",
      "state_code": "48",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Lozovo Municipality",
      "state_code": "49",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Makedonska Kamenica Municipality",
      "state_code": "51",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Makedonski Brod Municipality",
      "state_code": "52",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Mavrovo and Rostuša Municipality",
      "state_code": "50",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Mogila Municipality",
      "state_code": "53",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Negotino Municipality",
      "state_code": "54",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Novaci Municipality",
      "state_code": "55",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Novo Selo Municipality",
      "state_code": "56",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Ohrid Municipality",
      "state_code": "58",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Oslomej Municipality",
      "state_code": "57",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Pehčevo Municipality",
      "state_code": "60",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Petrovec Municipality",
      "state_code": "59",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Plasnica Municipality",
      "state_code": "61",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Prilep Municipality",
      "state_code": "62",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Probištip Municipality",
      "state_code": "63",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Radoviš Municipality",
      "state_code": "64",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Rankovce Municipality",
      "state_code": "65",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Resen Municipality",
      "state_code": "66",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Rosoman Municipality",
      "state_code": "67",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Saraj Municipality",
      "state_code": "68",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Sopište Municipality",
      "state_code": "70",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Staro Nagoričane Municipality",
      "state_code": "71",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Štip Municipality",
      "state_code": "83",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Struga Municipality",
      "state_code": "72",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Strumica Municipality",
      "state_code": "73",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Studeničani Municipality",
      "state_code": "74",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Šuto Orizari Municipality",
      "state_code": "84",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Sveti Nikole Municipality",
      "state_code": "69",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Tearce Municipality",
      "state_code": "75",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Tetovo Municipality",
      "state_code": "76",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Valandovo Municipality",
      "state_code": "10",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Vasilevo Municipality",
      "state_code": "11",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Veles Municipality",
      "state_code": "13",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Vevčani Municipality",
      "state_code": "12",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Vinica Municipality",
      "state_code": "14",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Vraneštica Municipality",
      "state_code": "15",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Vrapčište Municipality",
      "state_code": "16",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Zajas Municipality",
      "state_code": "31",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Zelenikovo Municipality",
      "state_code": "32",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Želino Municipality",
      "state_code": "30",
      "country_id": 129
    },
    {
      "country_code": "MK",
      "country_name": "Macedonia",
      "name": "Zrnovci Municipality",
      "state_code": "33",
      "country_id": 129
    },
    {
      "country_code": "MG",
      "country_name": "Madagascar",
      "name": "Antananarivo Province",
      "state_code": "T",
      "country_id": 130
    },
    {
      "country_code": "MG",
      "country_name": "Madagascar",
      "name": "Antsiranana Province",
      "state_code": "D",
      "country_id": 130
    },
    {
      "country_code": "MG",
      "country_name": "Madagascar",
      "name": "Fianarantsoa Province",
      "state_code": "F",
      "country_id": 130
    },
    {
      "country_code": "MG",
      "country_name": "Madagascar",
      "name": "Mahajanga Province",
      "state_code": "M",
      "country_id": 130
    },
    {
      "country_code": "MG",
      "country_name": "Madagascar",
      "name": "Toamasina Province",
      "state_code": "A",
      "country_id": 130
    },
    {
      "country_code": "MG",
      "country_name": "Madagascar",
      "name": "Toliara Province",
      "state_code": "U",
      "country_id": 130
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Balaka District",
      "state_code": "BA",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Blantyre District",
      "state_code": "BL",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Central Region",
      "state_code": "C",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Chikwawa District",
      "state_code": "CK",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Chiradzulu District",
      "state_code": "CR",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Chitipa district",
      "state_code": "CT",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Dedza District",
      "state_code": "DE",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Dowa District",
      "state_code": "DO",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Karonga District",
      "state_code": "KR",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Kasungu District",
      "state_code": "KS",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Likoma District",
      "state_code": "LK",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Lilongwe District",
      "state_code": "LI",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Machinga District",
      "state_code": "MH",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Mangochi District",
      "state_code": "MG",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Mchinji District",
      "state_code": "MC",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Mulanje District",
      "state_code": "MU",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Mwanza District",
      "state_code": "MW",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Mzimba District",
      "state_code": "MZ",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Nkhata Bay District",
      "state_code": "NB",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Nkhotakota District",
      "state_code": "NK",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Northern Region",
      "state_code": "N",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Nsanje District",
      "state_code": "NS",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Ntcheu District",
      "state_code": "NU",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Ntchisi District",
      "state_code": "NI",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Phalombe District",
      "state_code": "PH",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Rumphi District",
      "state_code": "RU",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Salima District",
      "state_code": "SA",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Southern Region",
      "state_code": "S",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Thyolo District",
      "state_code": "TH",
      "country_id": 131
    },
    {
      "country_code": "MW",
      "country_name": "Malawi",
      "name": "Zomba District",
      "state_code": "ZO",
      "country_id": 131
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Johor",
      "state_code": "01",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Kedah",
      "state_code": "02",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Kelantan",
      "state_code": "03",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Kuala Lumpur",
      "state_code": "14",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Labuan",
      "state_code": "15",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Malacca",
      "state_code": "04",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Negeri Sembilan",
      "state_code": "05",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Pahang",
      "state_code": "06",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Penang",
      "state_code": "07",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Perak",
      "state_code": "08",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Perlis",
      "state_code": "09",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Putrajaya",
      "state_code": "16",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Sabah",
      "state_code": "12",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Sarawak",
      "state_code": "13",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Selangor",
      "state_code": "10",
      "country_id": 132
    },
    {
      "country_code": "MY",
      "country_name": "Malaysia",
      "name": "Terengganu",
      "state_code": "11",
      "country_id": 132
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Addu Atoll",
      "state_code": "01",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Alif Alif Atoll",
      "state_code": "02",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Alif Dhaal Atoll",
      "state_code": "00",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Central Province",
      "state_code": "CE",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Dhaalu Atoll",
      "state_code": "17",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Faafu Atoll",
      "state_code": "14",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Gaafu Alif Atoll",
      "state_code": "27",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Gaafu Dhaalu Atoll",
      "state_code": "28",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Gnaviyani Atoll",
      "state_code": "29",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Haa Alif Atoll",
      "state_code": "07",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Haa Dhaalu Atoll",
      "state_code": "23",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Kaafu Atoll",
      "state_code": "26",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Laamu Atoll",
      "state_code": "05",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Lhaviyani Atoll",
      "state_code": "03",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Malé",
      "state_code": "MLE",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Meemu Atoll",
      "state_code": "12",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Noonu Atoll",
      "state_code": "25",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "North Central Province",
      "state_code": "NC",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "North Province",
      "state_code": "NO",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Raa Atoll",
      "state_code": "13",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Shaviyani Atoll",
      "state_code": "24",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "South Central Province",
      "state_code": "SC",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "South Province",
      "state_code": "SU",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Thaa Atoll",
      "state_code": "08",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Upper South Province",
      "state_code": "US",
      "country_id": 133
    },
    {
      "country_code": "MV",
      "country_name": "Maldives",
      "name": "Vaavu Atoll",
      "state_code": "04",
      "country_id": 133
    },
    {
      "country_code": "ML",
      "country_name": "Mali",
      "name": "Bamako",
      "state_code": "BKO",
      "country_id": 134
    },
    {
      "country_code": "ML",
      "country_name": "Mali",
      "name": "Gao Region",
      "state_code": "7",
      "country_id": 134
    },
    {
      "country_code": "ML",
      "country_name": "Mali",
      "name": "Kayes Region",
      "state_code": "1",
      "country_id": 134
    },
    {
      "country_code": "ML",
      "country_name": "Mali",
      "name": "Kidal Region",
      "state_code": "8",
      "country_id": 134
    },
    {
      "country_code": "ML",
      "country_name": "Mali",
      "name": "Koulikoro Region",
      "state_code": "2",
      "country_id": 134
    },
    {
      "country_code": "ML",
      "country_name": "Mali",
      "name": "Ménaka Region",
      "state_code": "9",
      "country_id": 134
    },
    {
      "country_code": "ML",
      "country_name": "Mali",
      "name": "Mopti Region",
      "state_code": "5",
      "country_id": 134
    },
    {
      "country_code": "ML",
      "country_name": "Mali",
      "name": "Ségou Region",
      "state_code": "4",
      "country_id": 134
    },
    {
      "country_code": "ML",
      "country_name": "Mali",
      "name": "Sikasso Region",
      "state_code": "3",
      "country_id": 134
    },
    {
      "country_code": "ML",
      "country_name": "Mali",
      "name": "Taoudénit Region",
      "state_code": "10",
      "country_id": 134
    },
    {
      "country_code": "ML",
      "country_name": "Mali",
      "name": "Tombouctou Region",
      "state_code": "6",
      "country_id": 134
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Attard",
      "state_code": "01",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Balzan",
      "state_code": "02",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Birgu",
      "state_code": "03",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Birkirkara",
      "state_code": "04",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Birżebbuġa",
      "state_code": "05",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Cospicua",
      "state_code": "06",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Dingli",
      "state_code": "07",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Fgura",
      "state_code": "08",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Floriana",
      "state_code": "09",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Fontana",
      "state_code": "10",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Għajnsielem",
      "state_code": "13",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Għarb",
      "state_code": "14",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Għargħur",
      "state_code": "15",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Għasri",
      "state_code": "16",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Għaxaq",
      "state_code": "17",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Gudja",
      "state_code": "11",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Gżira",
      "state_code": "12",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Ħamrun",
      "state_code": "18",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Iklin",
      "state_code": "19",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Kalkara",
      "state_code": "21",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Kerċem",
      "state_code": "22",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Kirkop",
      "state_code": "23",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Lija",
      "state_code": "24",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Luqa",
      "state_code": "25",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Marsa",
      "state_code": "26",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Marsaskala",
      "state_code": "27",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Marsaxlokk",
      "state_code": "28",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Mdina",
      "state_code": "29",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Mellieħa",
      "state_code": "30",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Mġarr",
      "state_code": "31",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Mosta",
      "state_code": "32",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Mqabba",
      "state_code": "33",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Msida",
      "state_code": "34",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Mtarfa",
      "state_code": "35",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Munxar",
      "state_code": "36",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Nadur",
      "state_code": "37",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Naxxar",
      "state_code": "38",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Paola",
      "state_code": "39",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Pembroke",
      "state_code": "40",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Pietà",
      "state_code": "41",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Qala",
      "state_code": "42",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Qormi",
      "state_code": "43",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Qrendi",
      "state_code": "44",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Rabat",
      "state_code": "46",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Saint Lawrence",
      "state_code": "50",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "San Ġwann",
      "state_code": "49",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Sannat",
      "state_code": "52",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Santa Luċija",
      "state_code": "53",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Santa Venera",
      "state_code": "54",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Senglea",
      "state_code": "20",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Siġġiewi",
      "state_code": "55",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Sliema",
      "state_code": "56",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "St. Julian's",
      "state_code": "48",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "St. Paul's Bay",
      "state_code": "51",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Swieqi",
      "state_code": "57",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Ta' Xbiex",
      "state_code": "58",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Tarxien",
      "state_code": "59",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Valletta",
      "state_code": "60",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Victoria",
      "state_code": "45",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Xagħra",
      "state_code": "61",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Xewkija",
      "state_code": "62",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Xgħajra",
      "state_code": "63",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Żabbar",
      "state_code": "64",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Żebbuġ Gozo",
      "state_code": "65",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Żebbuġ Malta",
      "state_code": "66",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Żejtun",
      "state_code": "67",
      "country_id": 135
    },
    {
      "country_code": "MT",
      "country_name": "Malta",
      "name": "Żurrieq",
      "state_code": "68",
      "country_id": 135
    },
    {
      "country_code": "MH",
      "country_name": "Marshall Islands",
      "name": "Ralik Chain",
      "state_code": "L",
      "country_id": 137
    },
    {
      "country_code": "MH",
      "country_name": "Marshall Islands",
      "name": "Ratak Chain",
      "state_code": "T",
      "country_id": 137
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Adrar",
      "state_code": "07",
      "country_id": 139
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Assaba",
      "state_code": "03",
      "country_id": 139
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Brakna",
      "state_code": "05",
      "country_id": 139
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Dakhlet Nouadhibou",
      "state_code": "08",
      "country_id": 139
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Gorgol",
      "state_code": "04",
      "country_id": 139
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Guidimaka",
      "state_code": "10",
      "country_id": 139
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Hodh Ech Chargui",
      "state_code": "01",
      "country_id": 139
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Hodh El Gharbi",
      "state_code": "02",
      "country_id": 139
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Inchiri",
      "state_code": "12",
      "country_id": 139
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Nouakchott-Nord",
      "state_code": "14",
      "country_id": 139
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Nouakchott-Ouest",
      "state_code": "13",
      "country_id": 139
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Nouakchott-Sud",
      "state_code": "15",
      "country_id": 139
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Tagant",
      "state_code": "09",
      "country_id": 139
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Tiris Zemmour",
      "state_code": "11",
      "country_id": 139
    },
    {
      "country_code": "MR",
      "country_name": "Mauritania",
      "name": "Trarza",
      "state_code": "06",
      "country_id": 139
    },
    {
      "country_code": "MU",
      "country_name": "Mauritius",
      "name": "Agalega Islands",
      "state_code": "AG",
      "country_id": 140
    },
    {
      "country_code": "MU",
      "country_name": "Mauritius",
      "name": "Black River",
      "state_code": "BL",
      "country_id": 140
    },
    {
      "country_code": "MU",
      "country_name": "Mauritius",
      "name": "Flacq",
      "state_code": "FL",
      "country_id": 140
    },
    {
      "country_code": "MU",
      "country_name": "Mauritius",
      "name": "Grand Port",
      "state_code": "GP",
      "country_id": 140
    },
    {
      "country_code": "MU",
      "country_name": "Mauritius",
      "name": "Moka",
      "state_code": "MO",
      "country_id": 140
    },
    {
      "country_code": "MU",
      "country_name": "Mauritius",
      "name": "Pamplemousses",
      "state_code": "PA",
      "country_id": 140
    },
    {
      "country_code": "MU",
      "country_name": "Mauritius",
      "name": "Plaines Wilhems",
      "state_code": "PW",
      "country_id": 140
    },
    {
      "country_code": "MU",
      "country_name": "Mauritius",
      "name": "Port Louis",
      "state_code": "PL",
      "country_id": 140
    },
    {
      "country_code": "MU",
      "country_name": "Mauritius",
      "name": "Rivière du Rempart",
      "state_code": "RR",
      "country_id": 140
    },
    {
      "country_code": "MU",
      "country_name": "Mauritius",
      "name": "Rodrigues Island",
      "state_code": "RO",
      "country_id": 140
    },
    {
      "country_code": "MU",
      "country_name": "Mauritius",
      "name": "Saint Brandon Islands",
      "state_code": "CC",
      "country_id": 140
    },
    {
      "country_code": "MU",
      "country_name": "Mauritius",
      "name": "Savanne",
      "state_code": "SA",
      "country_id": 140
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Aguascalientes",
      "state_code": "AGU",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Baja California",
      "state_code": "BCN",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Baja California Sur",
      "state_code": "BCS",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Campeche",
      "state_code": "CAM",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Chiapas",
      "state_code": "CHP",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Chihuahua",
      "state_code": "CHH",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Ciudad de México",
      "state_code": "CDMX",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Coahuila de Zaragoza",
      "state_code": "COA",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Colima",
      "state_code": "COL",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Durango",
      "state_code": "DUR",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Estado de México",
      "state_code": "MEX",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Guanajuato",
      "state_code": "GUA",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Guerrero",
      "state_code": "GRO",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Hidalgo",
      "state_code": "HID",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Jalisco",
      "state_code": "JAL",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Michoacán de Ocampo",
      "state_code": "MIC",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Morelos",
      "state_code": "MOR",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Nayarit",
      "state_code": "NAY",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Nuevo León",
      "state_code": "NLE",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Oaxaca",
      "state_code": "OAX",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Puebla",
      "state_code": "PUE",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Querétaro",
      "state_code": "QUE",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Quintana Roo",
      "state_code": "ROO",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "San Luis Potosí",
      "state_code": "SLP",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Sinaloa",
      "state_code": "SIN",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Sonora",
      "state_code": "SON",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Tabasco",
      "state_code": "TAB",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Tamaulipas",
      "state_code": "TAM",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Tlaxcala",
      "state_code": "TLA",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Veracruz de Ignacio de la Llave",
      "state_code": "VER",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Yucatán",
      "state_code": "YUC",
      "country_id": 142
    },
    {
      "country_code": "MX",
      "country_name": "Mexico",
      "name": "Zacatecas",
      "state_code": "ZAC",
      "country_id": 142
    },
    {
      "country_code": "FM",
      "country_name": "Micronesia",
      "name": "Chuuk State",
      "state_code": "TRK",
      "country_id": 143
    },
    {
      "country_code": "FM",
      "country_name": "Micronesia",
      "name": "Kosrae State",
      "state_code": "KSA",
      "country_id": 143
    },
    {
      "country_code": "FM",
      "country_name": "Micronesia",
      "name": "Pohnpei State",
      "state_code": "PNI",
      "country_id": 143
    },
    {
      "country_code": "FM",
      "country_name": "Micronesia",
      "name": "Yap State",
      "state_code": "YAP",
      "country_id": 143
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Anenii Noi District",
      "state_code": "AN",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Bălți Municipality",
      "state_code": "BA",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Basarabeasca District",
      "state_code": "BS",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Bender Municipality",
      "state_code": "BD",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Briceni District",
      "state_code": "BR",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Cahul District",
      "state_code": "CA",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Călărași District",
      "state_code": "CL",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Cantemir District",
      "state_code": "CT",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Căușeni District",
      "state_code": "CS",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Chișinău Municipality",
      "state_code": "CU",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Cimișlia District",
      "state_code": "CM",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Criuleni District",
      "state_code": "CR",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Dondușeni District",
      "state_code": "DO",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Drochia District",
      "state_code": "DR",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Dubăsari District",
      "state_code": "DU",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Edineț District",
      "state_code": "ED",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Fălești District",
      "state_code": "FA",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Florești District",
      "state_code": "FL",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Gagauzia",
      "state_code": "GA",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Glodeni District",
      "state_code": "GL",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Hîncești District",
      "state_code": "HI",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Ialoveni District",
      "state_code": "IA",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Nisporeni District",
      "state_code": "NI",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Ocnița District",
      "state_code": "OC",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Orhei District",
      "state_code": "OR",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Rezina District",
      "state_code": "RE",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Rîșcani District",
      "state_code": "RI",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Sîngerei District",
      "state_code": "SI",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Șoldănești District",
      "state_code": "SD",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Soroca District",
      "state_code": "SO",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Ștefan Vodă District",
      "state_code": "SV",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Strășeni District",
      "state_code": "ST",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Taraclia District",
      "state_code": "TA",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Telenești District",
      "state_code": "TE",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Transnistria autonomous territorial unit",
      "state_code": "SN",
      "country_id": 144
    },
    {
      "country_code": "MD",
      "country_name": "Moldova",
      "name": "Ungheni District",
      "state_code": "UN",
      "country_id": 144
    },
    {
      "country_code": "MC",
      "country_name": "Monaco",
      "name": "La Colle",
      "state_code": "CL",
      "country_id": 145
    },
    {
      "country_code": "MC",
      "country_name": "Monaco",
      "name": "La Condamine",
      "state_code": "CO",
      "country_id": 145
    },
    {
      "country_code": "MC",
      "country_name": "Monaco",
      "name": "Moneghetti",
      "state_code": "MG",
      "country_id": 145
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Arkhangai Province",
      "state_code": "073",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Bayan-Ölgii Province",
      "state_code": "071",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Bayankhongor Province",
      "state_code": "069",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Bulgan Province",
      "state_code": "067",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Darkhan-Uul Province",
      "state_code": "037",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Dornod Province",
      "state_code": "061",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Dornogovi Province",
      "state_code": "063",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Dundgovi Province",
      "state_code": "059",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Govi-Altai Province",
      "state_code": "065",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Govisümber Province",
      "state_code": "064",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Khentii Province",
      "state_code": "039",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Khovd Province",
      "state_code": "043",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Khövsgöl Province",
      "state_code": "041",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Ömnögovi Province",
      "state_code": "053",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Orkhon Province",
      "state_code": "035",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Övörkhangai Province",
      "state_code": "055",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Selenge Province",
      "state_code": "049",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Sükhbaatar Province",
      "state_code": "051",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Töv Province",
      "state_code": "047",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Uvs Province",
      "state_code": "046",
      "country_id": 146
    },
    {
      "country_code": "MN",
      "country_name": "Mongolia",
      "name": "Zavkhan Province",
      "state_code": "057",
      "country_id": 146
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Andrijevica Municipality",
      "state_code": "01",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Bar Municipality",
      "state_code": "02",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Berane Municipality",
      "state_code": "03",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Bijelo Polje Municipality",
      "state_code": "04",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Budva Municipality",
      "state_code": "05",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Danilovgrad Municipality",
      "state_code": "07",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Gusinje Municipality",
      "state_code": "22",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Kolašin Municipality",
      "state_code": "09",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Kotor Municipality",
      "state_code": "10",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Mojkovac Municipality",
      "state_code": "11",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Nikšić Municipality",
      "state_code": "12",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Old Royal Capital Cetinje",
      "state_code": "06",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Petnjica Municipality",
      "state_code": "23",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Plav Municipality",
      "state_code": "13",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Pljevlja Municipality",
      "state_code": "14",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Plužine Municipality",
      "state_code": "15",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Podgorica Municipality",
      "state_code": "16",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Rožaje Municipality",
      "state_code": "17",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Šavnik Municipality",
      "state_code": "18",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Tivat Municipality",
      "state_code": "19",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Ulcinj Municipality",
      "state_code": "20",
      "country_id": 147
    },
    {
      "country_code": "ME",
      "country_name": "Montenegro",
      "name": "Žabljak Municipality",
      "state_code": "21",
      "country_id": 147
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Agadir-Ida-Ou-Tanane",
      "state_code": "AGD",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Al Haouz",
      "state_code": "HAO",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Al Hoceïma",
      "state_code": "HOC",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Aousserd (EH)",
      "state_code": "AOU",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Assa-Zag (EH-partial)",
      "state_code": "ASZ",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Azilal",
      "state_code": "AZI",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Béni Mellal",
      "state_code": "BEM",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Béni Mellal-Khénifra",
      "state_code": "05",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Benslimane",
      "state_code": "BES",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Berkane",
      "state_code": "BER",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Berrechid",
      "state_code": "BRR",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Boujdour (EH)",
      "state_code": "BOD",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Boulemane",
      "state_code": "BOM",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Casablanca",
      "state_code": "CAS",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Casablanca-Settat",
      "state_code": "06",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Chefchaouen",
      "state_code": "CHE",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Chichaoua",
      "state_code": "CHI",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Chtouka-Ait Baha",
      "state_code": "CHT",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Dakhla-Oued Ed-Dahab (EH)",
      "state_code": "12",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Drâa-Tafilalet",
      "state_code": "08",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Driouch",
      "state_code": "DRI",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "El Hajeb",
      "state_code": "HAJ",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "El Jadida",
      "state_code": "JDI",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "El Kelâa des Sraghna",
      "state_code": "KES",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Errachidia",
      "state_code": "ERR",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Es-Semara (EH-partial)",
      "state_code": "ESM",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Essaouira",
      "state_code": "ESI",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Fahs-Anjra",
      "state_code": "FAH",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Fès",
      "state_code": "FES",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Fès-Meknès",
      "state_code": "03",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Figuig",
      "state_code": "FIG",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Fquih Ben Salah",
      "state_code": "FQH",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Guelmim",
      "state_code": "GUE",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Guelmim-Oued Noun (EH-partial)",
      "state_code": "10",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Guercif",
      "state_code": "GUF",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Ifrane",
      "state_code": "IFR",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Inezgane-Ait Melloul",
      "state_code": "INE",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Jerada",
      "state_code": "JRA",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Kénitra",
      "state_code": "KEN",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Khémisset",
      "state_code": "KHE",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Khénifra",
      "state_code": "KHN",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Khouribga",
      "state_code": "KHO",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "L'Oriental",
      "state_code": "02",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Laâyoune (EH)",
      "state_code": "LAA",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Laâyoune-Sakia El Hamra (EH-partial)",
      "state_code": "11",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Larache",
      "state_code": "LAR",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "M’diq-Fnideq",
      "state_code": "MDF",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Marrakech",
      "state_code": "MAR",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Marrakesh-Safi",
      "state_code": "07",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Médiouna",
      "state_code": "MED",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Meknès",
      "state_code": "MEK",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Midelt",
      "state_code": "MID",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Mohammadia",
      "state_code": "MOH",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Moulay Yacoub",
      "state_code": "MOU",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Nador",
      "state_code": "NAD",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Nouaceur",
      "state_code": "NOU",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Ouarzazate",
      "state_code": "OUA",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Oued Ed-Dahab (EH)",
      "state_code": "OUD",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Ouezzane",
      "state_code": "OUZ",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Oujda-Angad",
      "state_code": "OUJ",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Rabat",
      "state_code": "RAB",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Rabat-Salé-Kénitra",
      "state_code": "04",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Rehamna",
      "state_code": "REH",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Safi",
      "state_code": "SAF",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Salé",
      "state_code": "SAL",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Sefrou",
      "state_code": "SEF",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Settat",
      "state_code": "SET",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Sidi Bennour",
      "state_code": "SIB",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Sidi Ifni",
      "state_code": "SIF",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Sidi Kacem",
      "state_code": "SIK",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Sidi Slimane",
      "state_code": "SIL",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Skhirate-Témara",
      "state_code": "SKH",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Souss-Massa",
      "state_code": "09",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Tan-Tan (EH-partial)",
      "state_code": "TNT",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Tanger-Assilah",
      "state_code": "TNG",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Tanger-Tétouan-Al Hoceïma",
      "state_code": "01",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Taounate",
      "state_code": "TAO",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Taourirt",
      "state_code": "TAI",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Tarfaya (EH-partial)",
      "state_code": "TAF",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Taroudannt",
      "state_code": "TAR",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Tata",
      "state_code": "TAT",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Taza",
      "state_code": "TAZ",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Tétouan",
      "state_code": "TET",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Tinghir",
      "state_code": "TIN",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Tiznit",
      "state_code": "TIZ",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Youssoufia",
      "state_code": "YUS",
      "country_id": 149
    },
    {
      "country_code": "MA",
      "country_name": "Morocco",
      "name": "Zagora",
      "state_code": "ZAG",
      "country_id": 149
    },
    {
      "country_code": "MZ",
      "country_name": "Mozambique",
      "name": "Cabo Delgado Province",
      "state_code": "P",
      "country_id": 150
    },
    {
      "country_code": "MZ",
      "country_name": "Mozambique",
      "name": "Gaza Province",
      "state_code": "G",
      "country_id": 150
    },
    {
      "country_code": "MZ",
      "country_name": "Mozambique",
      "name": "Inhambane Province",
      "state_code": "I",
      "country_id": 150
    },
    {
      "country_code": "MZ",
      "country_name": "Mozambique",
      "name": "Manica Province",
      "state_code": "B",
      "country_id": 150
    },
    {
      "country_code": "MZ",
      "country_name": "Mozambique",
      "name": "Maputo",
      "state_code": "MPM",
      "country_id": 150
    },
    {
      "country_code": "MZ",
      "country_name": "Mozambique",
      "name": "Maputo Province",
      "state_code": "L",
      "country_id": 150
    },
    {
      "country_code": "MZ",
      "country_name": "Mozambique",
      "name": "Nampula Province",
      "state_code": "N",
      "country_id": 150
    },
    {
      "country_code": "MZ",
      "country_name": "Mozambique",
      "name": "Niassa Province",
      "state_code": "A",
      "country_id": 150
    },
    {
      "country_code": "MZ",
      "country_name": "Mozambique",
      "name": "Sofala Province",
      "state_code": "S",
      "country_id": 150
    },
    {
      "country_code": "MZ",
      "country_name": "Mozambique",
      "name": "Tete Province",
      "state_code": "T",
      "country_id": 150
    },
    {
      "country_code": "MZ",
      "country_name": "Mozambique",
      "name": "Zambezia Province",
      "state_code": "Q",
      "country_id": 150
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Ayeyarwady Region",
      "state_code": "07",
      "country_id": 151
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Bago",
      "state_code": "02",
      "country_id": 151
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Chin State",
      "state_code": "14",
      "country_id": 151
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Kachin State",
      "state_code": "11",
      "country_id": 151
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Kayah State",
      "state_code": "12",
      "country_id": 151
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Kayin State",
      "state_code": "13",
      "country_id": 151
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Magway Region",
      "state_code": "03",
      "country_id": 151
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Mandalay Region",
      "state_code": "04",
      "country_id": 151
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Mon State",
      "state_code": "15",
      "country_id": 151
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Naypyidaw Union Territory",
      "state_code": "18",
      "country_id": 151
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Rakhine State",
      "state_code": "16",
      "country_id": 151
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Sagaing Region",
      "state_code": "01",
      "country_id": 151
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Shan State",
      "state_code": "17",
      "country_id": 151
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Tanintharyi Region",
      "state_code": "05",
      "country_id": 151
    },
    {
      "country_code": "MM",
      "country_name": "Myanmar",
      "name": "Yangon Region",
      "state_code": "06",
      "country_id": 151
    },
    {
      "country_code": "NA",
      "country_name": "Namibia",
      "name": "Erongo Region",
      "state_code": "ER",
      "country_id": 152
    },
    {
      "country_code": "NA",
      "country_name": "Namibia",
      "name": "Hardap Region",
      "state_code": "HA",
      "country_id": 152
    },
    {
      "country_code": "NA",
      "country_name": "Namibia",
      "name": "Karas Region",
      "state_code": "KA",
      "country_id": 152
    },
    {
      "country_code": "NA",
      "country_name": "Namibia",
      "name": "Kavango East Region",
      "state_code": "KE",
      "country_id": 152
    },
    {
      "country_code": "NA",
      "country_name": "Namibia",
      "name": "Kavango West Region",
      "state_code": "KW",
      "country_id": 152
    },
    {
      "country_code": "NA",
      "country_name": "Namibia",
      "name": "Khomas Region",
      "state_code": "KH",
      "country_id": 152
    },
    {
      "country_code": "NA",
      "country_name": "Namibia",
      "name": "Kunene Region",
      "state_code": "KU",
      "country_id": 152
    },
    {
      "country_code": "NA",
      "country_name": "Namibia",
      "name": "Ohangwena Region",
      "state_code": "OW",
      "country_id": 152
    },
    {
      "country_code": "NA",
      "country_name": "Namibia",
      "name": "Omaheke Region",
      "state_code": "OH",
      "country_id": 152
    },
    {
      "country_code": "NA",
      "country_name": "Namibia",
      "name": "Omusati Region",
      "state_code": "OS",
      "country_id": 152
    },
    {
      "country_code": "NA",
      "country_name": "Namibia",
      "name": "Oshana Region",
      "state_code": "ON",
      "country_id": 152
    },
    {
      "country_code": "NA",
      "country_name": "Namibia",
      "name": "Oshikoto Region",
      "state_code": "OT",
      "country_id": 152
    },
    {
      "country_code": "NA",
      "country_name": "Namibia",
      "name": "Otjozondjupa Region",
      "state_code": "OD",
      "country_id": 152
    },
    {
      "country_code": "NA",
      "country_name": "Namibia",
      "name": "Zambezi Region",
      "state_code": "CA",
      "country_id": 152
    },
    {
      "country_code": "NR",
      "country_name": "Nauru",
      "name": "Aiwo District",
      "state_code": "01",
      "country_id": 153
    },
    {
      "country_code": "NR",
      "country_name": "Nauru",
      "name": "Anabar District",
      "state_code": "02",
      "country_id": 153
    },
    {
      "country_code": "NR",
      "country_name": "Nauru",
      "name": "Anetan District",
      "state_code": "03",
      "country_id": 153
    },
    {
      "country_code": "NR",
      "country_name": "Nauru",
      "name": "Anibare District",
      "state_code": "04",
      "country_id": 153
    },
    {
      "country_code": "NR",
      "country_name": "Nauru",
      "name": "Baiti District",
      "state_code": "05",
      "country_id": 153
    },
    {
      "country_code": "NR",
      "country_name": "Nauru",
      "name": "Boe District",
      "state_code": "06",
      "country_id": 153
    },
    {
      "country_code": "NR",
      "country_name": "Nauru",
      "name": "Buada District",
      "state_code": "07",
      "country_id": 153
    },
    {
      "country_code": "NR",
      "country_name": "Nauru",
      "name": "Denigomodu District",
      "state_code": "08",
      "country_id": 153
    },
    {
      "country_code": "NR",
      "country_name": "Nauru",
      "name": "Ewa District",
      "state_code": "09",
      "country_id": 153
    },
    {
      "country_code": "NR",
      "country_name": "Nauru",
      "name": "Ijuw District",
      "state_code": "10",
      "country_id": 153
    },
    {
      "country_code": "NR",
      "country_name": "Nauru",
      "name": "Meneng District",
      "state_code": "11",
      "country_id": 153
    },
    {
      "country_code": "NR",
      "country_name": "Nauru",
      "name": "Nibok District",
      "state_code": "12",
      "country_id": 153
    },
    {
      "country_code": "NR",
      "country_name": "Nauru",
      "name": "Uaboe District",
      "state_code": "13",
      "country_id": 153
    },
    {
      "country_code": "NR",
      "country_name": "Nauru",
      "name": "Yaren District",
      "state_code": "14",
      "country_id": 153
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Bagmati Zone",
      "state_code": "BA",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Bheri Zone",
      "state_code": "BH",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Central Region",
      "state_code": "1",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Dhaulagiri Zone",
      "state_code": "DH",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Eastern Development Region",
      "state_code": "4",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Far-Western Development Region",
      "state_code": "5",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Gandaki Zone",
      "state_code": "GA",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Janakpur Zone",
      "state_code": "JA",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Karnali Zone",
      "state_code": "KA",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Kosi Zone",
      "state_code": "KO",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Lumbini Zone",
      "state_code": "LU",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Mahakali Zone",
      "state_code": "MA",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Mechi Zone",
      "state_code": "ME",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Mid-Western Region",
      "state_code": "2",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Narayani Zone",
      "state_code": "NA",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Rapti Zone",
      "state_code": "RA",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Sagarmatha Zone",
      "state_code": "SA",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Seti Zone",
      "state_code": "SE",
      "country_id": 154
    },
    {
      "country_code": "NP",
      "country_name": "Nepal",
      "name": "Western Region",
      "state_code": "3",
      "country_id": 154
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "Bonaire",
      "state_code": "BQ1",
      "country_id": 156
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "Drenthe",
      "state_code": "DR",
      "country_id": 156
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "Flevoland",
      "state_code": "FL",
      "country_id": 156
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "Friesland",
      "state_code": "FR",
      "country_id": 156
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "Gelderland",
      "state_code": "GE",
      "country_id": 156
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "Groningen",
      "state_code": "GR",
      "country_id": 156
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "Limburg",
      "state_code": "LI",
      "country_id": 156
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "North Brabant",
      "state_code": "NB",
      "country_id": 156
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "North Holland",
      "state_code": "NH",
      "country_id": 156
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "Overijssel",
      "state_code": "OV",
      "country_id": 156
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "Saba",
      "state_code": "BQ2",
      "country_id": 156
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "Sint Eustatius",
      "state_code": "BQ3",
      "country_id": 156
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "South Holland",
      "state_code": "ZH",
      "country_id": 156
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "Utrecht",
      "state_code": "UT",
      "country_id": 156
    },
    {
      "country_code": "NL",
      "country_name": "Netherlands",
      "name": "Zeeland",
      "state_code": "ZE",
      "country_id": 156
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Auckland Region",
      "state_code": "AUK",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Bay of Plenty Region",
      "state_code": "BOP",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Canterbury Region",
      "state_code": "CAN",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Chatham Islands",
      "state_code": "CIT",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Gisborne District",
      "state_code": "GIS",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Hawke's Bay Region",
      "state_code": "HKB",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Manawatu-Wanganui Region",
      "state_code": "MWT",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Marlborough Region",
      "state_code": "MBH",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Nelson Region",
      "state_code": "NSN",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Northland Region",
      "state_code": "NTL",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Otago Region",
      "state_code": "OTA",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Southland Region",
      "state_code": "STL",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Taranaki Region",
      "state_code": "TKI",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Tasman District",
      "state_code": "TAS",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Waikato Region",
      "state_code": "WKO",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "Wellington Region",
      "state_code": "WGN",
      "country_id": 158
    },
    {
      "country_code": "NZ",
      "country_name": "New Zealand",
      "name": "West Coast Region",
      "state_code": "WTC",
      "country_id": 158
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "Boaco",
      "state_code": "BO",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "Carazo",
      "state_code": "CA",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "Chinandega",
      "state_code": "CI",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "Chontales",
      "state_code": "CO",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "Estelí",
      "state_code": "ES",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "Granada",
      "state_code": "GR",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "Jinotega",
      "state_code": "JI",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "León",
      "state_code": "LE",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "Madriz",
      "state_code": "MD",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "Managua",
      "state_code": "MN",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "Masaya",
      "state_code": "MS",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "Matagalpa",
      "state_code": "MT",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "North Caribbean Coast",
      "state_code": "AN",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "Nueva Segovia",
      "state_code": "NS",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "Río San Juan",
      "state_code": "SJ",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "Rivas",
      "state_code": "RI",
      "country_id": 159
    },
    {
      "country_code": "NI",
      "country_name": "Nicaragua",
      "name": "South Caribbean Coast",
      "state_code": "AS",
      "country_id": 159
    },
    {
      "country_code": "NE",
      "country_name": "Niger",
      "name": "Agadez Region",
      "state_code": "1",
      "country_id": 160
    },
    {
      "country_code": "NE",
      "country_name": "Niger",
      "name": "Diffa Region",
      "state_code": "2",
      "country_id": 160
    },
    {
      "country_code": "NE",
      "country_name": "Niger",
      "name": "Dosso Region",
      "state_code": "3",
      "country_id": 160
    },
    {
      "country_code": "NE",
      "country_name": "Niger",
      "name": "Maradi Region",
      "state_code": "4",
      "country_id": 160
    },
    {
      "country_code": "NE",
      "country_name": "Niger",
      "name": "Tahoua Region",
      "state_code": "5",
      "country_id": 160
    },
    {
      "country_code": "NE",
      "country_name": "Niger",
      "name": "Tillabéri Region",
      "state_code": "6",
      "country_id": 160
    },
    {
      "country_code": "NE",
      "country_name": "Niger",
      "name": "Zinder Region",
      "state_code": "7",
      "country_id": 160
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Abia",
      "state_code": "AB",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Abuja Federal Capital Territory",
      "state_code": "FC",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Adamawa",
      "state_code": "AD",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Akwa Ibom",
      "state_code": "AK",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Anambra",
      "state_code": "AN",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Bauchi",
      "state_code": "BA",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Bayelsa",
      "state_code": "BY",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Benue",
      "state_code": "BE",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Borno",
      "state_code": "BO",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Cross River",
      "state_code": "CR",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Delta",
      "state_code": "DE",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Ebonyi",
      "state_code": "EB",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Edo",
      "state_code": "ED",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Ekiti",
      "state_code": "EK",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Enugu",
      "state_code": "EN",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Gombe",
      "state_code": "GO",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Imo",
      "state_code": "IM",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Jigawa",
      "state_code": "JI",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Kaduna",
      "state_code": "KD",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Kano",
      "state_code": "KN",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Katsina",
      "state_code": "KT",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Kebbi",
      "state_code": "KE",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Kogi",
      "state_code": "KO",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Kwara",
      "state_code": "KW",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Lagos",
      "state_code": "LA",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Nasarawa",
      "state_code": "NA",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Niger",
      "state_code": "NI",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Ogun",
      "state_code": "OG",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Ondo",
      "state_code": "ON",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Osun",
      "state_code": "OS",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Oyo",
      "state_code": "OY",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Plateau",
      "state_code": "PL",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Rivers",
      "state_code": "RI",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Sokoto",
      "state_code": "SO",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Taraba",
      "state_code": "TA",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Yobe",
      "state_code": "YO",
      "country_id": 161
    },
    {
      "country_code": "NG",
      "country_name": "Nigeria",
      "name": "Zamfara",
      "state_code": "ZA",
      "country_id": 161
    },
    {
      "country_code": "KP",
      "country_name": "North Korea",
      "name": "Chagang Province",
      "state_code": "04",
      "country_id": 115
    },
    {
      "country_code": "KP",
      "country_name": "North Korea",
      "name": "Kangwon Province",
      "state_code": "07",
      "country_id": 115
    },
    {
      "country_code": "KP",
      "country_name": "North Korea",
      "name": "North Hamgyong Province",
      "state_code": "09",
      "country_id": 115
    },
    {
      "country_code": "KP",
      "country_name": "North Korea",
      "name": "North Hwanghae Province",
      "state_code": "06",
      "country_id": 115
    },
    {
      "country_code": "KP",
      "country_name": "North Korea",
      "name": "North Pyongan Province",
      "state_code": "03",
      "country_id": 115
    },
    {
      "country_code": "KP",
      "country_name": "North Korea",
      "name": "Pyongyang",
      "state_code": "01",
      "country_id": 115
    },
    {
      "country_code": "KP",
      "country_name": "North Korea",
      "name": "Rason",
      "state_code": "13",
      "country_id": 115
    },
    {
      "country_code": "KP",
      "country_name": "North Korea",
      "name": "Ryanggang Province",
      "state_code": "10",
      "country_id": 115
    },
    {
      "country_code": "KP",
      "country_name": "North Korea",
      "name": "South Hamgyong Province",
      "state_code": "08",
      "country_id": 115
    },
    {
      "country_code": "KP",
      "country_name": "North Korea",
      "name": "South Hwanghae Province",
      "state_code": "05",
      "country_id": 115
    },
    {
      "country_code": "KP",
      "country_name": "North Korea",
      "name": "South Pyongan Province",
      "state_code": "02",
      "country_id": 115
    },
    {
      "country_code": "NO",
      "country_name": "Norway",
      "name": "Agder",
      "state_code": "42",
      "country_id": 165
    },
    {
      "country_code": "NO",
      "country_name": "Norway",
      "name": "Innlandet",
      "state_code": "34",
      "country_id": 165
    },
    {
      "country_code": "NO",
      "country_name": "Norway",
      "name": "Jan Mayen",
      "state_code": "22",
      "country_id": 165
    },
    {
      "country_code": "NO",
      "country_name": "Norway",
      "name": "Møre og Romsdal",
      "state_code": "15",
      "country_id": 165
    },
    {
      "country_code": "NO",
      "country_name": "Norway",
      "name": "Nordland",
      "state_code": "18",
      "country_id": 165
    },
    {
      "country_code": "NO",
      "country_name": "Norway",
      "name": "Oslo",
      "state_code": "03",
      "country_id": 165
    },
    {
      "country_code": "NO",
      "country_name": "Norway",
      "name": "Rogaland",
      "state_code": "11",
      "country_id": 165
    },
    {
      "country_code": "NO",
      "country_name": "Norway",
      "name": "Svalbard",
      "state_code": "21",
      "country_id": 165
    },
    {
      "country_code": "NO",
      "country_name": "Norway",
      "name": "Troms og Finnmark",
      "state_code": "54",
      "country_id": 165
    },
    {
      "country_code": "NO",
      "country_name": "Norway",
      "name": "Trøndelag",
      "state_code": "50",
      "country_id": 165
    },
    {
      "country_code": "NO",
      "country_name": "Norway",
      "name": "Vestfold og Telemark",
      "state_code": "38",
      "country_id": 165
    },
    {
      "country_code": "NO",
      "country_name": "Norway",
      "name": "Vestland",
      "state_code": "46",
      "country_id": 165
    },
    {
      "country_code": "NO",
      "country_name": "Norway",
      "name": "Viken",
      "state_code": "30",
      "country_id": 165
    },
    {
      "country_code": "OM",
      "country_name": "Oman",
      "name": "Ad Dakhiliyah",
      "state_code": "DA",
      "country_id": 166
    },
    {
      "country_code": "OM",
      "country_name": "Oman",
      "name": "Ad Dhahirah",
      "state_code": "ZA",
      "country_id": 166
    },
    {
      "country_code": "OM",
      "country_name": "Oman",
      "name": "Al Batinah North",
      "state_code": "BS",
      "country_id": 166
    },
    {
      "country_code": "OM",
      "country_name": "Oman",
      "name": "Al Batinah Region",
      "state_code": "BA",
      "country_id": 166
    },
    {
      "country_code": "OM",
      "country_name": "Oman",
      "name": "Al Batinah South",
      "state_code": "BJ",
      "country_id": 166
    },
    {
      "country_code": "OM",
      "country_name": "Oman",
      "name": "Al Buraimi",
      "state_code": "BU",
      "country_id": 166
    },
    {
      "country_code": "OM",
      "country_name": "Oman",
      "name": "Al Wusta",
      "state_code": "WU",
      "country_id": 166
    },
    {
      "country_code": "OM",
      "country_name": "Oman",
      "name": "Ash Sharqiyah North",
      "state_code": "SS",
      "country_id": 166
    },
    {
      "country_code": "OM",
      "country_name": "Oman",
      "name": "Ash Sharqiyah Region",
      "state_code": "SH",
      "country_id": 166
    },
    {
      "country_code": "OM",
      "country_name": "Oman",
      "name": "Ash Sharqiyah South",
      "state_code": "SJ",
      "country_id": 166
    },
    {
      "country_code": "OM",
      "country_name": "Oman",
      "name": "Dhofar",
      "state_code": "ZU",
      "country_id": 166
    },
    {
      "country_code": "OM",
      "country_name": "Oman",
      "name": "Musandam",
      "state_code": "MU",
      "country_id": 166
    },
    {
      "country_code": "OM",
      "country_name": "Oman",
      "name": "Muscat",
      "state_code": "MA",
      "country_id": 166
    },
    {
      "country_code": "PK",
      "country_name": "Pakistan",
      "name": "Azad Kashmir",
      "state_code": "JK",
      "country_id": 167
    },
    {
      "country_code": "PK",
      "country_name": "Pakistan",
      "name": "Balochistan",
      "state_code": "BA",
      "country_id": 167
    },
    {
      "country_code": "PK",
      "country_name": "Pakistan",
      "name": "Federally Administered Tribal Areas",
      "state_code": "TA",
      "country_id": 167
    },
    {
      "country_code": "PK",
      "country_name": "Pakistan",
      "name": "Gilgit-Baltistan",
      "state_code": "GB",
      "country_id": 167
    },
    {
      "country_code": "PK",
      "country_name": "Pakistan",
      "name": "Islamabad Capital Territory",
      "state_code": "IS",
      "country_id": 167
    },
    {
      "country_code": "PK",
      "country_name": "Pakistan",
      "name": "Khyber Pakhtunkhwa",
      "state_code": "KP",
      "country_id": 167
    },
    {
      "country_code": "PK",
      "country_name": "Pakistan",
      "name": "Punjab",
      "state_code": "PB",
      "country_id": 167
    },
    {
      "country_code": "PK",
      "country_name": "Pakistan",
      "name": "Sindh",
      "state_code": "SD",
      "country_id": 167
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Aimeliik",
      "state_code": "002",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Airai",
      "state_code": "004",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Angaur",
      "state_code": "010",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Hatohobei",
      "state_code": "050",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Kayangel",
      "state_code": "100",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Koror",
      "state_code": "150",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Melekeok",
      "state_code": "212",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Ngaraard",
      "state_code": "214",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Ngarchelong",
      "state_code": "218",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Ngardmau",
      "state_code": "222",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Ngatpang",
      "state_code": "224",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Ngchesar",
      "state_code": "226",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Ngeremlengui",
      "state_code": "227",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Ngiwal",
      "state_code": "228",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Peleliu",
      "state_code": "350",
      "country_id": 168
    },
    {
      "country_code": "PW",
      "country_name": "Palau",
      "name": "Sonsorol",
      "state_code": "370",
      "country_id": 168
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Bethlehem",
      "state_code": "BTH",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Deir El Balah",
      "state_code": "DEB",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Gaza",
      "state_code": "GZA",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Hebron",
      "state_code": "HBN",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Jenin",
      "state_code": "JEN",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Jericho and Al Aghwar",
      "state_code": "JRH",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Jerusalem",
      "state_code": "JEM",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Khan Yunis",
      "state_code": "KYS",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Nablus",
      "state_code": "NBS",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "North Gaza",
      "state_code": "NGZ",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Qalqilya",
      "state_code": "QQA",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Rafah",
      "state_code": "RFH",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Ramallah",
      "state_code": "RBH",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Salfit",
      "state_code": "SLT",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Tubas",
      "state_code": "TBS",
      "country_id": 169
    },
    {
      "country_code": "PS",
      "country_name": "Palestinian Territory Occupied",
      "name": "Tulkarm",
      "state_code": "TKM",
      "country_id": 169
    },
    {
      "country_code": "PA",
      "country_name": "Panama",
      "name": "Bocas del Toro Province",
      "state_code": "1",
      "country_id": 170
    },
    {
      "country_code": "PA",
      "country_name": "Panama",
      "name": "Chiriquí Province",
      "state_code": "4",
      "country_id": 170
    },
    {
      "country_code": "PA",
      "country_name": "Panama",
      "name": "Coclé Province",
      "state_code": "2",
      "country_id": 170
    },
    {
      "country_code": "PA",
      "country_name": "Panama",
      "name": "Colón Province",
      "state_code": "3",
      "country_id": 170
    },
    {
      "country_code": "PA",
      "country_name": "Panama",
      "name": "Darién Province",
      "state_code": "5",
      "country_id": 170
    },
    {
      "country_code": "PA",
      "country_name": "Panama",
      "name": "Emberá-Wounaan Comarca",
      "state_code": "EM",
      "country_id": 170
    },
    {
      "country_code": "PA",
      "country_name": "Panama",
      "name": "Guna Yala",
      "state_code": "KY",
      "country_id": 170
    },
    {
      "country_code": "PA",
      "country_name": "Panama",
      "name": "Herrera Province",
      "state_code": "6",
      "country_id": 170
    },
    {
      "country_code": "PA",
      "country_name": "Panama",
      "name": "Los Santos Province",
      "state_code": "7",
      "country_id": 170
    },
    {
      "country_code": "PA",
      "country_name": "Panama",
      "name": "Ngöbe-Buglé Comarca",
      "state_code": "NB",
      "country_id": 170
    },
    {
      "country_code": "PA",
      "country_name": "Panama",
      "name": "Panamá Oeste Province",
      "state_code": "10",
      "country_id": 170
    },
    {
      "country_code": "PA",
      "country_name": "Panama",
      "name": "Panamá Province",
      "state_code": "8",
      "country_id": 170
    },
    {
      "country_code": "PA",
      "country_name": "Panama",
      "name": "Veraguas Province",
      "state_code": "9",
      "country_id": 170
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Bougainville",
      "state_code": "NSB",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Central Province",
      "state_code": "CPM",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Chimbu Province",
      "state_code": "CPK",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "East New Britain",
      "state_code": "EBR",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Eastern Highlands Province",
      "state_code": "EHG",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Enga Province",
      "state_code": "EPW",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Gulf",
      "state_code": "GPK",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Hela",
      "state_code": "HLA",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Jiwaka Province",
      "state_code": "JWK",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Madang Province",
      "state_code": "MPM",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Manus Province",
      "state_code": "MRL",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Milne Bay Province",
      "state_code": "MBA",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Morobe Province",
      "state_code": "MPL",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "New Ireland Province",
      "state_code": "NIK",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Oro Province",
      "state_code": "NPP",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Port Moresby",
      "state_code": "NCD",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Sandaun Province",
      "state_code": "SAN",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Southern Highlands Province",
      "state_code": "SHM",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "West New Britain Province",
      "state_code": "WBK",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Western Highlands Province",
      "state_code": "WHM",
      "country_id": 171
    },
    {
      "country_code": "PG",
      "country_name": "Papua new Guinea",
      "name": "Western Province",
      "state_code": "WPD",
      "country_id": 171
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Alto Paraguay Department",
      "state_code": "16",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Alto Paraná Department",
      "state_code": "10",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Amambay Department",
      "state_code": "13",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Boquerón Department",
      "state_code": "19",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Caaguazú",
      "state_code": "5",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Caazapá",
      "state_code": "6",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Canindeyú",
      "state_code": "14",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Central Department",
      "state_code": "11",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Concepción Department",
      "state_code": "1",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Cordillera Department",
      "state_code": "3",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Guairá Department",
      "state_code": "4",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Itapúa",
      "state_code": "7",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Misiones Department",
      "state_code": "8",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Ñeembucú Department",
      "state_code": "12",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Paraguarí Department",
      "state_code": "9",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "Presidente Hayes Department",
      "state_code": "15",
      "country_id": 172
    },
    {
      "country_code": "PY",
      "country_name": "Paraguay",
      "name": "San Pedro Department",
      "state_code": "2",
      "country_id": 172
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Amazonas",
      "state_code": "AMA",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Áncash",
      "state_code": "ANC",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Apurímac",
      "state_code": "APU",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Arequipa",
      "state_code": "ARE",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Ayacucho",
      "state_code": "AYA",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Cajamarca",
      "state_code": "CAJ",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Callao",
      "state_code": "CAL",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Cusco",
      "state_code": "CUS",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Huancavelica",
      "state_code": "HUV",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Huanuco",
      "state_code": "HUC",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Ica",
      "state_code": "ICA",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Junín",
      "state_code": "JUN",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "La Libertad",
      "state_code": "LAL",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Lambayeque",
      "state_code": "LAM",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Lima",
      "state_code": "LIM",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Loreto",
      "state_code": "LOR",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Madre de Dios",
      "state_code": "MDD",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Moquegua",
      "state_code": "MOQ",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Pasco",
      "state_code": "PAS",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Piura",
      "state_code": "PIU",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Puno",
      "state_code": "PUN",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "San Martín",
      "state_code": "SAM",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Tacna",
      "state_code": "TAC",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Tumbes",
      "state_code": "TUM",
      "country_id": 173
    },
    {
      "country_code": "PE",
      "country_name": "Peru",
      "name": "Ucayali",
      "state_code": "UCA",
      "country_id": 173
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Abra",
      "state_code": "ABR",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Agusan del Norte",
      "state_code": "AGN",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Agusan del Sur",
      "state_code": "AGS",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Aklan",
      "state_code": "AKL",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Albay",
      "state_code": "ALB",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Antique",
      "state_code": "ANT",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Apayao",
      "state_code": "APA",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Aurora",
      "state_code": "AUR",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Autonomous Region in Muslim Mindanao",
      "state_code": "14",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Basilan",
      "state_code": "BAS",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Bataan",
      "state_code": "BAN",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Batanes",
      "state_code": "BTN",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Batangas",
      "state_code": "BTG",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Benguet",
      "state_code": "BEN",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Bicol",
      "state_code": "05",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Biliran",
      "state_code": "BIL",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Bohol",
      "state_code": "BOH",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Bukidnon",
      "state_code": "BUK",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Bulacan",
      "state_code": "BUL",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Cagayan",
      "state_code": "CAG",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Cagayan Valley",
      "state_code": "02",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Calabarzon",
      "state_code": "40",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Camarines Norte",
      "state_code": "CAN",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Camarines Sur",
      "state_code": "CAS",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Camiguin",
      "state_code": "CAM",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Capiz",
      "state_code": "CAP",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Caraga",
      "state_code": "13",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Catanduanes",
      "state_code": "CAT",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Cavite",
      "state_code": "CAV",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Cebu",
      "state_code": "CEB",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Central Luzon",
      "state_code": "03",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Central Visayas",
      "state_code": "07",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Compostela Valley",
      "state_code": "COM",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Cordillera Administrative",
      "state_code": "15",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Cotabato",
      "state_code": "NCO",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Davao",
      "state_code": "11",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Davao del Norte",
      "state_code": "DAV",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Davao del Sur",
      "state_code": "DAS",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Davao Occidental",
      "state_code": "DVO",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Davao Oriental",
      "state_code": "DAO",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Dinagat Islands",
      "state_code": "DIN",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Eastern Samar",
      "state_code": "EAS",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Eastern Visayas",
      "state_code": "08",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Guimaras",
      "state_code": "GUI",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Ifugao",
      "state_code": "IFU",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Ilocos",
      "state_code": "01",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Ilocos Norte",
      "state_code": "ILN",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Ilocos Sur",
      "state_code": "ILS",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Iloilo",
      "state_code": "ILI",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Isabela",
      "state_code": "ISA",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Kalinga",
      "state_code": "KAL",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "La Union",
      "state_code": "LUN",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Laguna",
      "state_code": "LAG",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Lanao del Norte",
      "state_code": "LAN",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Lanao del Sur",
      "state_code": "LAS",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Leyte",
      "state_code": "LEY",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Maguindanao",
      "state_code": "MAG",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Marinduque",
      "state_code": "MAD",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Masbate",
      "state_code": "MAS",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Metro Manila",
      "state_code": "NCR",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Mimaropa",
      "state_code": "41",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Misamis Occidental",
      "state_code": "MSC",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Misamis Oriental",
      "state_code": "MSR",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Mountain Province",
      "state_code": "MOU",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Negros Occidental",
      "state_code": "NEC",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Negros Oriental",
      "state_code": "NER",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Northern Mindanao",
      "state_code": "10",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Northern Samar",
      "state_code": "NSA",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Nueva Ecija",
      "state_code": "NUE",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Nueva Vizcaya",
      "state_code": "NUV",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Occidental Mindoro",
      "state_code": "MDC",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Oriental Mindoro",
      "state_code": "MDR",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Palawan",
      "state_code": "PLW",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Pampanga",
      "state_code": "PAM",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Pangasinan",
      "state_code": "PAN",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Quezon",
      "state_code": "QUE",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Quirino",
      "state_code": "QUI",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Rizal",
      "state_code": "RIZ",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Romblon",
      "state_code": "ROM",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Sarangani",
      "state_code": "SAR",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Siquijor",
      "state_code": "SIG",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Soccsksargen",
      "state_code": "12",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Sorsogon",
      "state_code": "SOR",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "South Cotabato",
      "state_code": "SCO",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Southern Leyte",
      "state_code": "SLE",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Sultan Kudarat",
      "state_code": "SUK",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Sulu",
      "state_code": "SLU",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Surigao del Norte",
      "state_code": "SUN",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Surigao del Sur",
      "state_code": "SUR",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Tarlac",
      "state_code": "TAR",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Tawi-Tawi",
      "state_code": "TAW",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Western Samar",
      "state_code": "WSA",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Western Visayas",
      "state_code": "06",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Zambales",
      "state_code": "ZMB",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Zamboanga del Norte",
      "state_code": "ZAN",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Zamboanga del Sur",
      "state_code": "ZAS",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Zamboanga Peninsula",
      "state_code": "09",
      "country_id": 174
    },
    {
      "country_code": "PH",
      "country_name": "Philippines",
      "name": "Zamboanga Sibugay",
      "state_code": "ZSI",
      "country_id": 174
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Greater Poland Voivodeship",
      "state_code": "WP",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Kuyavian-Pomeranian Voivodeship",
      "state_code": "KP",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Lesser Poland Voivodeship",
      "state_code": "MA",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Lower Silesian Voivodeship",
      "state_code": "DS",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Lublin Voivodeship",
      "state_code": "LU",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Lubusz Voivodeship",
      "state_code": "LB",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Łódź Voivodeship",
      "state_code": "LD",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Masovian Voivodeship",
      "state_code": "MZ",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Opole Voivodeship",
      "state_code": "OP",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Podkarpackie Voivodeship",
      "state_code": "PK",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Podlaskie Voivodeship",
      "state_code": "PD",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Pomeranian Voivodeship",
      "state_code": "PM",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Silesian Voivodeship",
      "state_code": "SL",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Świętokrzyskie Voivodeship",
      "state_code": "SK",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "Warmian-Masurian Voivodeship",
      "state_code": "WN",
      "country_id": 176
    },
    {
      "country_code": "PL",
      "country_name": "Poland",
      "name": "West Pomeranian Voivodeship",
      "state_code": "ZP",
      "country_id": 176
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Açores",
      "state_code": "20",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Aveiro",
      "state_code": "01",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Beja",
      "state_code": "02",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Braga",
      "state_code": "03",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Bragança",
      "state_code": "04",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Castelo Branco",
      "state_code": "05",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Coimbra",
      "state_code": "06",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Évora",
      "state_code": "07",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Faro",
      "state_code": "08",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Guarda",
      "state_code": "09",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Leiria",
      "state_code": "10",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Lisbon",
      "state_code": "11",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Madeira",
      "state_code": "30",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Portalegre",
      "state_code": "12",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Porto",
      "state_code": "13",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Santarém",
      "state_code": "14",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Setúbal",
      "state_code": "15",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Viana do Castelo",
      "state_code": "16",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Vila Real",
      "state_code": "17",
      "country_id": 177
    },
    {
      "country_code": "PT",
      "country_name": "Portugal",
      "name": "Viseu",
      "state_code": "18",
      "country_id": 177
    },
    {
      "country_code": "PR",
      "country_name": "Puerto Rico",
      "name": "Arecibo",
      "state_code": "AR",
      "country_id": 178
    },
    {
      "country_code": "PR",
      "country_name": "Puerto Rico",
      "name": "Bayamon",
      "state_code": "BY",
      "country_id": 178
    },
    {
      "country_code": "PR",
      "country_name": "Puerto Rico",
      "name": "Caguas",
      "state_code": "CG",
      "country_id": 178
    },
    {
      "country_code": "PR",
      "country_name": "Puerto Rico",
      "name": "Carolina",
      "state_code": "CL",
      "country_id": 178
    },
    {
      "country_code": "PR",
      "country_name": "Puerto Rico",
      "name": "Guaynabo",
      "state_code": "GN",
      "country_id": 178
    },
    {
      "country_code": "PR",
      "country_name": "Puerto Rico",
      "name": "Mayagüez",
      "state_code": "MG",
      "country_id": 178
    },
    {
      "country_code": "PR",
      "country_name": "Puerto Rico",
      "name": "Ponce",
      "state_code": "PO",
      "country_id": 178
    },
    {
      "country_code": "PR",
      "country_name": "Puerto Rico",
      "name": "San Juan",
      "state_code": "SJ",
      "country_id": 178
    },
    {
      "country_code": "PR",
      "country_name": "Puerto Rico",
      "name": "Toa Baja",
      "state_code": "TB",
      "country_id": 178
    },
    {
      "country_code": "PR",
      "country_name": "Puerto Rico",
      "name": "Trujillo Alto",
      "state_code": "TA",
      "country_id": 178
    },
    {
      "country_code": "QA",
      "country_name": "Qatar",
      "name": "Al Daayen",
      "state_code": "ZA",
      "country_id": 179
    },
    {
      "country_code": "QA",
      "country_name": "Qatar",
      "name": "Al Khor",
      "state_code": "KH",
      "country_id": 179
    },
    {
      "country_code": "QA",
      "country_name": "Qatar",
      "name": "Al Rayyan Municipality",
      "state_code": "RA",
      "country_id": 179
    },
    {
      "country_code": "QA",
      "country_name": "Qatar",
      "name": "Al Wakrah",
      "state_code": "WA",
      "country_id": 179
    },
    {
      "country_code": "QA",
      "country_name": "Qatar",
      "name": "Al-Shahaniya",
      "state_code": "SH",
      "country_id": 179
    },
    {
      "country_code": "QA",
      "country_name": "Qatar",
      "name": "Doha",
      "state_code": "DA",
      "country_id": 179
    },
    {
      "country_code": "QA",
      "country_name": "Qatar",
      "name": "Madinat ash Shamal",
      "state_code": "MS",
      "country_id": 179
    },
    {
      "country_code": "QA",
      "country_name": "Qatar",
      "name": "Umm Salal Municipality",
      "state_code": "US",
      "country_id": 179
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Alba",
      "state_code": "AB",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Arad County",
      "state_code": "AR",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Arges",
      "state_code": "AG",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Bacău County",
      "state_code": "BC",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Bihor County",
      "state_code": "BH",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Bistrița-Năsăud County",
      "state_code": "BN",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Botoșani County",
      "state_code": "BT",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Braila",
      "state_code": "BR",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Brașov County",
      "state_code": "BV",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Bucharest",
      "state_code": "B",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Buzău County",
      "state_code": "BZ",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Călărași County",
      "state_code": "CL",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Caraș-Severin County",
      "state_code": "CS",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Cluj County",
      "state_code": "CJ",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Constanța County",
      "state_code": "CT",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Covasna County",
      "state_code": "CV",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Dâmbovița County",
      "state_code": "DB",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Dolj County",
      "state_code": "DJ",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Galați County",
      "state_code": "GL",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Giurgiu County",
      "state_code": "GR",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Gorj County",
      "state_code": "GJ",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Harghita County",
      "state_code": "HR",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Hunedoara County",
      "state_code": "HD",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Ialomița County",
      "state_code": "IL",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Iași County",
      "state_code": "IS",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Ilfov County",
      "state_code": "IF",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Maramureș County",
      "state_code": "MM",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Mehedinți County",
      "state_code": "MH",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Mureș County",
      "state_code": "MS",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Neamț County",
      "state_code": "NT",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Olt County",
      "state_code": "OT",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Prahova County",
      "state_code": "PH",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Sălaj County",
      "state_code": "SJ",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Satu Mare County",
      "state_code": "SM",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Sibiu County",
      "state_code": "SB",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Suceava County",
      "state_code": "SV",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Teleorman County",
      "state_code": "TR",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Timiș County",
      "state_code": "TM",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Tulcea County",
      "state_code": "TL",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Vâlcea County",
      "state_code": "VL",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Vaslui County",
      "state_code": "VS",
      "country_id": 181
    },
    {
      "country_code": "RO",
      "country_name": "Romania",
      "name": "Vrancea County",
      "state_code": "VN",
      "country_id": 181
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Altai Krai",
      "state_code": "ALT",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Altai Republic",
      "state_code": "AL",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Amur Oblast",
      "state_code": "AMU",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Arkhangelsk",
      "state_code": "ARK",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Astrakhan Oblast",
      "state_code": "AST",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Belgorod Oblast",
      "state_code": "BEL",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Bryansk Oblast",
      "state_code": "BRY",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Chechen Republic",
      "state_code": "CE",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Chelyabinsk Oblast",
      "state_code": "CHE",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Chukotka Autonomous Okrug",
      "state_code": "CHU",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Chuvash Republic",
      "state_code": "CU",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Irkutsk",
      "state_code": "IRK",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Ivanovo Oblast",
      "state_code": "IVA",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Jewish Autonomous Oblast",
      "state_code": "YEV",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Kabardino-Balkar Republic",
      "state_code": "KB",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Kaliningrad",
      "state_code": "KGD",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Kaluga Oblast",
      "state_code": "KLU",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Kamchatka Krai",
      "state_code": "KAM",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Karachay-Cherkess Republic",
      "state_code": "KC",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Kemerovo Oblast",
      "state_code": "KEM",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Khabarovsk Krai",
      "state_code": "KHA",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Khanty-Mansi Autonomous Okrug",
      "state_code": "KHM",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Kirov Oblast",
      "state_code": "KIR",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Komi Republic",
      "state_code": "KO",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Kostroma Oblast",
      "state_code": "KOS",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Krasnodar Krai",
      "state_code": "KDA",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Krasnoyarsk Krai",
      "state_code": "KYA",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Kurgan Oblast",
      "state_code": "KGN",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Kursk Oblast",
      "state_code": "KRS",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Leningrad Oblast",
      "state_code": "LEN",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Lipetsk Oblast",
      "state_code": "LIP",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Magadan Oblast",
      "state_code": "MAG",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Mari El Republic",
      "state_code": "ME",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Moscow",
      "state_code": "MOW",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Moscow Oblast",
      "state_code": "MOS",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Murmansk Oblast",
      "state_code": "MUR",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Nenets Autonomous Okrug",
      "state_code": "NEN",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Nizhny Novgorod Oblast",
      "state_code": "NIZ",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Novgorod Oblast",
      "state_code": "NGR",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Novosibirsk",
      "state_code": "NVS",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Omsk Oblast",
      "state_code": "OMS",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Orenburg Oblast",
      "state_code": "ORE",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Oryol Oblast",
      "state_code": "ORL",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Penza Oblast",
      "state_code": "PNZ",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Perm Krai",
      "state_code": "PER",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Primorsky Krai",
      "state_code": "PRI",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Pskov Oblast",
      "state_code": "PSK",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Republic of Adygea",
      "state_code": "AD",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Republic of Bashkortostan",
      "state_code": "BA",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Republic of Buryatia",
      "state_code": "BU",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Republic of Dagestan",
      "state_code": "DA",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Republic of Ingushetia",
      "state_code": "IN",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Republic of Kalmykia",
      "state_code": "KL",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Republic of Karelia",
      "state_code": "KR",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Republic of Khakassia",
      "state_code": "KK",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Republic of Mordovia",
      "state_code": "MO",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Republic of North Ossetia-Alania",
      "state_code": "SE",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Republic of Tatarstan",
      "state_code": "TA",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Rostov Oblast",
      "state_code": "ROS",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Ryazan Oblast",
      "state_code": "RYA",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Saint Petersburg",
      "state_code": "SPE",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Sakha Republic",
      "state_code": "SA",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Sakhalin",
      "state_code": "SAK",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Samara Oblast",
      "state_code": "SAM",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Saratov Oblast",
      "state_code": "SAR",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Sevastopol",
      "state_code": "UA-40",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Smolensk Oblast",
      "state_code": "SMO",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Stavropol Krai",
      "state_code": "STA",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Sverdlovsk",
      "state_code": "SVE",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Tambov Oblast",
      "state_code": "TAM",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Tomsk Oblast",
      "state_code": "TOM",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Tula Oblast",
      "state_code": "TUL",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Tuva Republic",
      "state_code": "TY",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Tver Oblast",
      "state_code": "TVE",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Tyumen Oblast",
      "state_code": "TYU",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Udmurt Republic",
      "state_code": "UD",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Ulyanovsk Oblast",
      "state_code": "ULY",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Vladimir Oblast",
      "state_code": "VLA",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Volgograd Oblast",
      "state_code": "VGG",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Vologda Oblast",
      "state_code": "VLG",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Voronezh Oblast",
      "state_code": "VOR",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Yamalo-Nenets Autonomous Okrug",
      "state_code": "YAN",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Yaroslavl Oblast",
      "state_code": "YAR",
      "country_id": 182
    },
    {
      "country_code": "RU",
      "country_name": "Russia",
      "name": "Zabaykalsky Krai",
      "state_code": "ZAB",
      "country_id": 182
    },
    {
      "country_code": "RW",
      "country_name": "Rwanda",
      "name": "Eastern Province",
      "state_code": "02",
      "country_id": 183
    },
    {
      "country_code": "RW",
      "country_name": "Rwanda",
      "name": "Kigali district",
      "state_code": "01",
      "country_id": 183
    },
    {
      "country_code": "RW",
      "country_name": "Rwanda",
      "name": "Northern Province",
      "state_code": "03",
      "country_id": 183
    },
    {
      "country_code": "RW",
      "country_name": "Rwanda",
      "name": "Southern Province",
      "state_code": "05",
      "country_id": 183
    },
    {
      "country_code": "RW",
      "country_name": "Rwanda",
      "name": "Western Province",
      "state_code": "04",
      "country_id": 183
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Christ Church Nichola Town Parish",
      "state_code": "01",
      "country_id": 185
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Nevis",
      "state_code": "N",
      "country_id": 185
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Saint Anne Sandy Point Parish",
      "state_code": "02",
      "country_id": 185
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Saint George Gingerland Parish",
      "state_code": "04",
      "country_id": 185
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Saint James Windward Parish",
      "state_code": "05",
      "country_id": 185
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Saint John Capisterre Parish",
      "state_code": "06",
      "country_id": 185
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Saint John Figtree Parish",
      "state_code": "07",
      "country_id": 185
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Saint Kitts",
      "state_code": "K",
      "country_id": 185
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Saint Mary Cayon Parish",
      "state_code": "08",
      "country_id": 185
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Saint Paul Capisterre Parish",
      "state_code": "09",
      "country_id": 185
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Saint Paul Charlestown Parish",
      "state_code": "10",
      "country_id": 185
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Saint Peter Basseterre Parish",
      "state_code": "11",
      "country_id": 185
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Saint Thomas Lowland Parish",
      "state_code": "12",
      "country_id": 185
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Saint Thomas Middle Island Parish",
      "state_code": "13",
      "country_id": 185
    },
    {
      "country_code": "KN",
      "country_name": "Saint Kitts And Nevis",
      "name": "Trinity Palmetto Point Parish",
      "state_code": "15",
      "country_id": 185
    },
    {
      "country_code": "LC",
      "country_name": "Saint Lucia",
      "name": "Anse la Raye Quarter",
      "state_code": "01",
      "country_id": 186
    },
    {
      "country_code": "LC",
      "country_name": "Saint Lucia",
      "name": "Canaries",
      "state_code": "12",
      "country_id": 186
    },
    {
      "country_code": "LC",
      "country_name": "Saint Lucia",
      "name": "Castries Quarter",
      "state_code": "02",
      "country_id": 186
    },
    {
      "country_code": "LC",
      "country_name": "Saint Lucia",
      "name": "Choiseul Quarter",
      "state_code": "03",
      "country_id": 186
    },
    {
      "country_code": "LC",
      "country_name": "Saint Lucia",
      "name": "Dauphin Quarter",
      "state_code": "04",
      "country_id": 186
    },
    {
      "country_code": "LC",
      "country_name": "Saint Lucia",
      "name": "Dennery Quarter",
      "state_code": "05",
      "country_id": 186
    },
    {
      "country_code": "LC",
      "country_name": "Saint Lucia",
      "name": "Gros Islet Quarter",
      "state_code": "06",
      "country_id": 186
    },
    {
      "country_code": "LC",
      "country_name": "Saint Lucia",
      "name": "Laborie Quarter",
      "state_code": "07",
      "country_id": 186
    },
    {
      "country_code": "LC",
      "country_name": "Saint Lucia",
      "name": "Micoud Quarter",
      "state_code": "08",
      "country_id": 186
    },
    {
      "country_code": "LC",
      "country_name": "Saint Lucia",
      "name": "Praslin Quarter",
      "state_code": "09",
      "country_id": 186
    },
    {
      "country_code": "LC",
      "country_name": "Saint Lucia",
      "name": "Soufrière Quarter",
      "state_code": "10",
      "country_id": 186
    },
    {
      "country_code": "LC",
      "country_name": "Saint Lucia",
      "name": "Vieux Fort Quarter",
      "state_code": "11",
      "country_id": 186
    },
    {
      "country_code": "VC",
      "country_name": "Saint Vincent And The Grenadines",
      "name": "Charlotte Parish",
      "state_code": "01",
      "country_id": 188
    },
    {
      "country_code": "VC",
      "country_name": "Saint Vincent And The Grenadines",
      "name": "Grenadines Parish",
      "state_code": "06",
      "country_id": 188
    },
    {
      "country_code": "VC",
      "country_name": "Saint Vincent And The Grenadines",
      "name": "Saint Andrew Parish",
      "state_code": "02",
      "country_id": 188
    },
    {
      "country_code": "VC",
      "country_name": "Saint Vincent And The Grenadines",
      "name": "Saint David Parish",
      "state_code": "03",
      "country_id": 188
    },
    {
      "country_code": "VC",
      "country_name": "Saint Vincent And The Grenadines",
      "name": "Saint George Parish",
      "state_code": "04",
      "country_id": 188
    },
    {
      "country_code": "VC",
      "country_name": "Saint Vincent And The Grenadines",
      "name": "Saint Patrick Parish",
      "state_code": "05",
      "country_id": 188
    },
    {
      "country_code": "WS",
      "country_name": "Samoa",
      "name": "A'ana",
      "state_code": "AA",
      "country_id": 191
    },
    {
      "country_code": "WS",
      "country_name": "Samoa",
      "name": "Aiga-i-le-Tai",
      "state_code": "AL",
      "country_id": 191
    },
    {
      "country_code": "WS",
      "country_name": "Samoa",
      "name": "Atua",
      "state_code": "AT",
      "country_id": 191
    },
    {
      "country_code": "WS",
      "country_name": "Samoa",
      "name": "Fa'asaleleaga",
      "state_code": "FA",
      "country_id": 191
    },
    {
      "country_code": "WS",
      "country_name": "Samoa",
      "name": "Gaga'emauga",
      "state_code": "GE",
      "country_id": 191
    },
    {
      "country_code": "WS",
      "country_name": "Samoa",
      "name": "Gaga'ifomauga",
      "state_code": "GI",
      "country_id": 191
    },
    {
      "country_code": "WS",
      "country_name": "Samoa",
      "name": "Palauli",
      "state_code": "PA",
      "country_id": 191
    },
    {
      "country_code": "WS",
      "country_name": "Samoa",
      "name": "Satupa'itea",
      "state_code": "SA",
      "country_id": 191
    },
    {
      "country_code": "WS",
      "country_name": "Samoa",
      "name": "Tuamasaga",
      "state_code": "TU",
      "country_id": 191
    },
    {
      "country_code": "WS",
      "country_name": "Samoa",
      "name": "Va'a-o-Fonoti",
      "state_code": "VF",
      "country_id": 191
    },
    {
      "country_code": "WS",
      "country_name": "Samoa",
      "name": "Vaisigano",
      "state_code": "VS",
      "country_id": 191
    },
    {
      "country_code": "SM",
      "country_name": "San Marino",
      "name": "Acquaviva",
      "state_code": "01",
      "country_id": 192
    },
    {
      "country_code": "SM",
      "country_name": "San Marino",
      "name": "Borgo Maggiore",
      "state_code": "06",
      "country_id": 192
    },
    {
      "country_code": "SM",
      "country_name": "San Marino",
      "name": "Chiesanuova",
      "state_code": "02",
      "country_id": 192
    },
    {
      "country_code": "SM",
      "country_name": "San Marino",
      "name": "Domagnano",
      "state_code": "03",
      "country_id": 192
    },
    {
      "country_code": "SM",
      "country_name": "San Marino",
      "name": "Faetano",
      "state_code": "04",
      "country_id": 192
    },
    {
      "country_code": "SM",
      "country_name": "San Marino",
      "name": "Fiorentino",
      "state_code": "05",
      "country_id": 192
    },
    {
      "country_code": "SM",
      "country_name": "San Marino",
      "name": "Montegiardino",
      "state_code": "08",
      "country_id": 192
    },
    {
      "country_code": "SM",
      "country_name": "San Marino",
      "name": "San Marino",
      "state_code": "07",
      "country_id": 192
    },
    {
      "country_code": "SM",
      "country_name": "San Marino",
      "name": "Serravalle",
      "state_code": "09",
      "country_id": 192
    },
    {
      "country_code": "ST",
      "country_name": "Sao Tome and Principe",
      "name": "Príncipe Province",
      "state_code": "P",
      "country_id": 193
    },
    {
      "country_code": "ST",
      "country_name": "Sao Tome and Principe",
      "name": "São Tomé Province",
      "state_code": "S",
      "country_id": 193
    },
    {
      "country_code": "SA",
      "country_name": "Saudi Arabia",
      "name": "'Asir",
      "state_code": "14",
      "country_id": 194
    },
    {
      "country_code": "SA",
      "country_name": "Saudi Arabia",
      "name": "Al Bahah",
      "state_code": "11",
      "country_id": 194
    },
    {
      "country_code": "SA",
      "country_name": "Saudi Arabia",
      "name": "Al Jawf",
      "state_code": "12",
      "country_id": 194
    },
    {
      "country_code": "SA",
      "country_name": "Saudi Arabia",
      "name": "Al Madinah",
      "state_code": "03",
      "country_id": 194
    },
    {
      "country_code": "SA",
      "country_name": "Saudi Arabia",
      "name": "Al-Qassim",
      "state_code": "05",
      "country_id": 194
    },
    {
      "country_code": "SA",
      "country_name": "Saudi Arabia",
      "name": "Eastern Province",
      "state_code": "04",
      "country_id": 194
    },
    {
      "country_code": "SA",
      "country_name": "Saudi Arabia",
      "name": "Ha'il",
      "state_code": "06",
      "country_id": 194
    },
    {
      "country_code": "SA",
      "country_name": "Saudi Arabia",
      "name": "Jizan",
      "state_code": "09",
      "country_id": 194
    },
    {
      "country_code": "SA",
      "country_name": "Saudi Arabia",
      "name": "Makkah",
      "state_code": "02",
      "country_id": 194
    },
    {
      "country_code": "SA",
      "country_name": "Saudi Arabia",
      "name": "Najran",
      "state_code": "10",
      "country_id": 194
    },
    {
      "country_code": "SA",
      "country_name": "Saudi Arabia",
      "name": "Northern Borders",
      "state_code": "08",
      "country_id": 194
    },
    {
      "country_code": "SA",
      "country_name": "Saudi Arabia",
      "name": "Riyadh",
      "state_code": "01",
      "country_id": 194
    },
    {
      "country_code": "SA",
      "country_name": "Saudi Arabia",
      "name": "Tabuk",
      "state_code": "07",
      "country_id": 194
    },
    {
      "country_code": "SN",
      "country_name": "Senegal",
      "name": "Dakar",
      "state_code": "DK",
      "country_id": 195
    },
    {
      "country_code": "SN",
      "country_name": "Senegal",
      "name": "Diourbel Region",
      "state_code": "DB",
      "country_id": 195
    },
    {
      "country_code": "SN",
      "country_name": "Senegal",
      "name": "Fatick",
      "state_code": "FK",
      "country_id": 195
    },
    {
      "country_code": "SN",
      "country_name": "Senegal",
      "name": "Kaffrine",
      "state_code": "KA",
      "country_id": 195
    },
    {
      "country_code": "SN",
      "country_name": "Senegal",
      "name": "Kaolack",
      "state_code": "KL",
      "country_id": 195
    },
    {
      "country_code": "SN",
      "country_name": "Senegal",
      "name": "Kédougou",
      "state_code": "KE",
      "country_id": 195
    },
    {
      "country_code": "SN",
      "country_name": "Senegal",
      "name": "Kolda",
      "state_code": "KD",
      "country_id": 195
    },
    {
      "country_code": "SN",
      "country_name": "Senegal",
      "name": "Louga",
      "state_code": "LG",
      "country_id": 195
    },
    {
      "country_code": "SN",
      "country_name": "Senegal",
      "name": "Matam",
      "state_code": "MT",
      "country_id": 195
    },
    {
      "country_code": "SN",
      "country_name": "Senegal",
      "name": "Saint-Louis",
      "state_code": "SL",
      "country_id": 195
    },
    {
      "country_code": "SN",
      "country_name": "Senegal",
      "name": "Sédhiou",
      "state_code": "SE",
      "country_id": 195
    },
    {
      "country_code": "SN",
      "country_name": "Senegal",
      "name": "Tambacounda Region",
      "state_code": "TC",
      "country_id": 195
    },
    {
      "country_code": "SN",
      "country_name": "Senegal",
      "name": "Thiès Region",
      "state_code": "TH",
      "country_id": 195
    },
    {
      "country_code": "SN",
      "country_name": "Senegal",
      "name": "Ziguinchor",
      "state_code": "ZG",
      "country_id": 195
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Belgrade",
      "state_code": "00",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Bor District",
      "state_code": "14",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Braničevo District",
      "state_code": "11",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Central Banat District",
      "state_code": "02",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Jablanica District",
      "state_code": "23",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Kolubara District",
      "state_code": "09",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Mačva District",
      "state_code": "08",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Moravica District",
      "state_code": "17",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Nišava District",
      "state_code": "20",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "North Bačka District",
      "state_code": "01",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "North Banat District",
      "state_code": "03",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Pčinja District",
      "state_code": "24",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Pirot District",
      "state_code": "22",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Podunavlje District",
      "state_code": "10",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Pomoravlje District",
      "state_code": "13",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Rasina District",
      "state_code": "19",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Raška District",
      "state_code": "18",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "South Bačka District",
      "state_code": "06",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "South Banat District",
      "state_code": "04",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Srem District",
      "state_code": "07",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Šumadija District",
      "state_code": "12",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Toplica District",
      "state_code": "21",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Vojvodina",
      "state_code": "VO",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "West Bačka District",
      "state_code": "05",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Zaječar District",
      "state_code": "15",
      "country_id": 196
    },
    {
      "country_code": "RS",
      "country_name": "Serbia",
      "name": "Zlatibor District",
      "state_code": "16",
      "country_id": 196
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Anse Boileau",
      "state_code": "02",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Anse Royale",
      "state_code": "05",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Anse-aux-Pins",
      "state_code": "01",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Au Cap",
      "state_code": "04",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Baie Lazare",
      "state_code": "06",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Baie Sainte Anne",
      "state_code": "07",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Beau Vallon",
      "state_code": "08",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Bel Air",
      "state_code": "09",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Bel Ombre",
      "state_code": "10",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Cascade",
      "state_code": "11",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Glacis",
      "state_code": "12",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Grand'Anse Mahé",
      "state_code": "13",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Grand'Anse Praslin",
      "state_code": "14",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "La Digue",
      "state_code": "15",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "La Rivière Anglaise",
      "state_code": "16",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Les Mamelles",
      "state_code": "24",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Mont Buxton",
      "state_code": "17",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Mont Fleuri",
      "state_code": "18",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Plaisance",
      "state_code": "19",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Pointe La Rue",
      "state_code": "20",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Port Glaud",
      "state_code": "21",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Roche Caiman",
      "state_code": "25",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Saint Louis",
      "state_code": "22",
      "country_id": 197
    },
    {
      "country_code": "SC",
      "country_name": "Seychelles",
      "name": "Takamaka",
      "state_code": "23",
      "country_id": 197
    },
    {
      "country_code": "SL",
      "country_name": "Sierra Leone",
      "name": "Eastern Province",
      "state_code": "E",
      "country_id": 198
    },
    {
      "country_code": "SL",
      "country_name": "Sierra Leone",
      "name": "Northern Province",
      "state_code": "N",
      "country_id": 198
    },
    {
      "country_code": "SL",
      "country_name": "Sierra Leone",
      "name": "Southern Province",
      "state_code": "S",
      "country_id": 198
    },
    {
      "country_code": "SL",
      "country_name": "Sierra Leone",
      "name": "Western Area",
      "state_code": "W",
      "country_id": 198
    },
    {
      "country_code": "SG",
      "country_name": "Singapore",
      "name": "Central Singapore Community Development Council",
      "state_code": "01",
      "country_id": 199
    },
    {
      "country_code": "SG",
      "country_name": "Singapore",
      "name": "North East Community Development Council",
      "state_code": "02",
      "country_id": 199
    },
    {
      "country_code": "SG",
      "country_name": "Singapore",
      "name": "North West Community Development Council",
      "state_code": "03",
      "country_id": 199
    },
    {
      "country_code": "SG",
      "country_name": "Singapore",
      "name": "South East Community Development Council",
      "state_code": "04",
      "country_id": 199
    },
    {
      "country_code": "SG",
      "country_name": "Singapore",
      "name": "South West Community Development Council",
      "state_code": "05",
      "country_id": 199
    },
    {
      "country_code": "SK",
      "country_name": "Slovakia",
      "name": "Banská Bystrica Region",
      "state_code": "BC",
      "country_id": 200
    },
    {
      "country_code": "SK",
      "country_name": "Slovakia",
      "name": "Bratislava Region",
      "state_code": "BL",
      "country_id": 200
    },
    {
      "country_code": "SK",
      "country_name": "Slovakia",
      "name": "Košice Region",
      "state_code": "KI",
      "country_id": 200
    },
    {
      "country_code": "SK",
      "country_name": "Slovakia",
      "name": "Nitra Region",
      "state_code": "NI",
      "country_id": 200
    },
    {
      "country_code": "SK",
      "country_name": "Slovakia",
      "name": "Prešov Region",
      "state_code": "PV",
      "country_id": 200
    },
    {
      "country_code": "SK",
      "country_name": "Slovakia",
      "name": "Trenčín Region",
      "state_code": "TC",
      "country_id": 200
    },
    {
      "country_code": "SK",
      "country_name": "Slovakia",
      "name": "Trnava Region",
      "state_code": "TA",
      "country_id": 200
    },
    {
      "country_code": "SK",
      "country_name": "Slovakia",
      "name": "Žilina Region",
      "state_code": "ZI",
      "country_id": 200
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Ajdovščina Municipality",
      "state_code": "001",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Ankaran Municipality",
      "state_code": "213",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Beltinci Municipality",
      "state_code": "002",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Benedikt Municipality",
      "state_code": "148",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Bistrica ob Sotli Municipality",
      "state_code": "149",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Bled Municipality",
      "state_code": "003",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Bloke Municipality",
      "state_code": "150",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Bohinj Municipality",
      "state_code": "004",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Borovnica Municipality",
      "state_code": "005",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Bovec Municipality",
      "state_code": "006",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Braslovče Municipality",
      "state_code": "151",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Brda Municipality",
      "state_code": "007",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Brežice Municipality",
      "state_code": "009",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Brezovica Municipality",
      "state_code": "008",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Cankova Municipality",
      "state_code": "152",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Cerklje na Gorenjskem Municipality",
      "state_code": "012",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Cerknica Municipality",
      "state_code": "013",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Cerkno Municipality",
      "state_code": "014",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Cerkvenjak Municipality",
      "state_code": "153",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "City Municipality of Celje",
      "state_code": "011",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "City Municipality of Novo Mesto",
      "state_code": "085",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Črenšovci Municipality",
      "state_code": "015",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Črna na Koroškem Municipality",
      "state_code": "016",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Črnomelj Municipality",
      "state_code": "017",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Destrnik Municipality",
      "state_code": "018",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Divača Municipality",
      "state_code": "019",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Dobje Municipality",
      "state_code": "154",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Dobrepolje Municipality",
      "state_code": "020",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Dobrna Municipality",
      "state_code": "155",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Dobrova–Polhov Gradec Municipality",
      "state_code": "021",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Dobrovnik Municipality",
      "state_code": "156",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Dol pri Ljubljani Municipality",
      "state_code": "022",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Dolenjske Toplice Municipality",
      "state_code": "157",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Domžale Municipality",
      "state_code": "023",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Dornava Municipality",
      "state_code": "024",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Dravograd Municipality",
      "state_code": "025",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Duplek Municipality",
      "state_code": "026",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Gorenja Vas–Poljane Municipality",
      "state_code": "027",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Gorišnica Municipality",
      "state_code": "028",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Gorje Municipality",
      "state_code": "207",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Gornja Radgona Municipality",
      "state_code": "029",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Gornji Grad Municipality",
      "state_code": "030",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Gornji Petrovci Municipality",
      "state_code": "031",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Grad Municipality",
      "state_code": "158",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Grosuplje Municipality",
      "state_code": "032",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Hajdina Municipality",
      "state_code": "159",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Hoče–Slivnica Municipality",
      "state_code": "160",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Hodoš Municipality",
      "state_code": "161",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Horjul Municipality",
      "state_code": "162",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Hrastnik Municipality",
      "state_code": "034",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Hrpelje–Kozina Municipality",
      "state_code": "035",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Idrija Municipality",
      "state_code": "036",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Ig Municipality",
      "state_code": "037",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Ivančna Gorica Municipality",
      "state_code": "039",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Izola Municipality",
      "state_code": "040",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Jesenice Municipality",
      "state_code": "041",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Jezersko Municipality",
      "state_code": "163",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Juršinci Municipality",
      "state_code": "042",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Kamnik Municipality",
      "state_code": "043",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Kanal ob Soči Municipality",
      "state_code": "044",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Kidričevo Municipality",
      "state_code": "045",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Kobarid Municipality",
      "state_code": "046",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Kobilje Municipality",
      "state_code": "047",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Kočevje Municipality",
      "state_code": "048",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Komen Municipality",
      "state_code": "049",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Komenda Municipality",
      "state_code": "164",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Koper City Municipality",
      "state_code": "050",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Kostanjevica na Krki Municipality",
      "state_code": "197",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Kostel Municipality",
      "state_code": "165",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Kozje Municipality",
      "state_code": "051",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Kranj City Municipality",
      "state_code": "052",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Kranjska Gora Municipality",
      "state_code": "053",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Križevci Municipality",
      "state_code": "166",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Kungota",
      "state_code": "055",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Kuzma Municipality",
      "state_code": "056",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Laško Municipality",
      "state_code": "057",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Lenart Municipality",
      "state_code": "058",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Lendava Municipality",
      "state_code": "059",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Litija Municipality",
      "state_code": "060",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Ljubljana City Municipality",
      "state_code": "061",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Ljubno Municipality",
      "state_code": "062",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Ljutomer Municipality",
      "state_code": "063",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Log–Dragomer Municipality",
      "state_code": "208",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Logatec Municipality",
      "state_code": "064",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Loška Dolina Municipality",
      "state_code": "065",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Loški Potok Municipality",
      "state_code": "066",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Lovrenc na Pohorju Municipality",
      "state_code": "167",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Luče Municipality",
      "state_code": "067",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Lukovica Municipality",
      "state_code": "068",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Majšperk Municipality",
      "state_code": "069",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Makole Municipality",
      "state_code": "198",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Maribor City Municipality",
      "state_code": "070",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Markovci Municipality",
      "state_code": "168",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Medvode Municipality",
      "state_code": "071",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Mengeš Municipality",
      "state_code": "072",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Metlika Municipality",
      "state_code": "073",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Mežica Municipality",
      "state_code": "074",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Miklavž na Dravskem Polju Municipality",
      "state_code": "169",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Miren–Kostanjevica Municipality",
      "state_code": "075",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Mirna Municipality",
      "state_code": "212",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Mirna Peč Municipality",
      "state_code": "170",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Mislinja Municipality",
      "state_code": "076",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Mokronog–Trebelno Municipality",
      "state_code": "199",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Moravče Municipality",
      "state_code": "077",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Moravske Toplice Municipality",
      "state_code": "078",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Mozirje Municipality",
      "state_code": "079",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Municipality of Apače",
      "state_code": "195",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Municipality of Cirkulane",
      "state_code": "196",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Municipality of Ilirska Bistrica",
      "state_code": "038",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Municipality of Krško",
      "state_code": "054",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Municipality of Škofljica",
      "state_code": "123",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Murska Sobota City Municipality",
      "state_code": "080",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Muta Municipality",
      "state_code": "081",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Naklo Municipality",
      "state_code": "082",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Nazarje Municipality",
      "state_code": "083",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Nova Gorica City Municipality",
      "state_code": "084",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Odranci Municipality",
      "state_code": "086",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Oplotnica",
      "state_code": "171",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Ormož Municipality",
      "state_code": "087",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Osilnica Municipality",
      "state_code": "088",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Pesnica Municipality",
      "state_code": "089",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Piran Municipality",
      "state_code": "090",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Pivka Municipality",
      "state_code": "091",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Podčetrtek Municipality",
      "state_code": "092",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Podlehnik Municipality",
      "state_code": "172",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Podvelka Municipality",
      "state_code": "093",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Poljčane Municipality",
      "state_code": "200",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Polzela Municipality",
      "state_code": "173",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Postojna Municipality",
      "state_code": "094",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Prebold Municipality",
      "state_code": "174",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Preddvor Municipality",
      "state_code": "095",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Prevalje Municipality",
      "state_code": "175",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Ptuj City Municipality",
      "state_code": "096",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Puconci Municipality",
      "state_code": "097",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Rače–Fram Municipality",
      "state_code": "098",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Radeče Municipality",
      "state_code": "099",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Radenci Municipality",
      "state_code": "100",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Radlje ob Dravi Municipality",
      "state_code": "101",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Radovljica Municipality",
      "state_code": "102",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Ravne na Koroškem Municipality",
      "state_code": "103",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Razkrižje Municipality",
      "state_code": "176",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Rečica ob Savinji Municipality",
      "state_code": "209",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Renče–Vogrsko Municipality",
      "state_code": "201",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Ribnica Municipality",
      "state_code": "104",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Ribnica na Pohorju Municipality",
      "state_code": "177",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Rogaška Slatina Municipality",
      "state_code": "106",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Rogašovci Municipality",
      "state_code": "105",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Rogatec Municipality",
      "state_code": "107",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Ruše Municipality",
      "state_code": "108",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Šalovci Municipality",
      "state_code": "033",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Selnica ob Dravi Municipality",
      "state_code": "178",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Semič Municipality",
      "state_code": "109",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Šempeter–Vrtojba Municipality",
      "state_code": "183",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Šenčur Municipality",
      "state_code": "117",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Šentilj Municipality",
      "state_code": "118",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Šentjernej Municipality",
      "state_code": "119",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Šentjur Municipality",
      "state_code": "120",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Šentrupert Municipality",
      "state_code": "211",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Sevnica Municipality",
      "state_code": "110",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Sežana Municipality",
      "state_code": "111",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Škocjan Municipality",
      "state_code": "121",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Škofja Loka Municipality",
      "state_code": "122",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Slovenj Gradec City Municipality",
      "state_code": "112",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Slovenska Bistrica Municipality",
      "state_code": "113",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Slovenske Konjice Municipality",
      "state_code": "114",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Šmarje pri Jelšah Municipality",
      "state_code": "124",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Šmarješke Toplice Municipality",
      "state_code": "206",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Šmartno ob Paki Municipality",
      "state_code": "125",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Šmartno pri Litiji Municipality",
      "state_code": "194",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Sodražica Municipality",
      "state_code": "179",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Solčava Municipality",
      "state_code": "180",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Šoštanj Municipality",
      "state_code": "126",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Središče ob Dravi",
      "state_code": "202",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Starše Municipality",
      "state_code": "115",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Štore Municipality",
      "state_code": "127",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Straža Municipality",
      "state_code": "203",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Sveta Ana Municipality",
      "state_code": "181",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Sveta Trojica v Slovenskih Goricah Municipality",
      "state_code": "204",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Sveti Andraž v Slovenskih Goricah Municipality",
      "state_code": "182",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Sveti Jurij ob Ščavnici Municipality",
      "state_code": "116",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Sveti Jurij v Slovenskih Goricah Municipality",
      "state_code": "210",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Sveti Tomaž Municipality",
      "state_code": "205",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Tabor Municipality",
      "state_code": "184",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Tišina Municipality",
      "state_code": "010",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Tolmin Municipality",
      "state_code": "128",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Trbovlje Municipality",
      "state_code": "129",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Trebnje Municipality",
      "state_code": "130",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Trnovska Vas Municipality",
      "state_code": "185",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Tržič Municipality",
      "state_code": "131",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Trzin Municipality",
      "state_code": "186",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Turnišče Municipality",
      "state_code": "132",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Velika Polana Municipality",
      "state_code": "187",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Velike Lašče Municipality",
      "state_code": "134",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Veržej Municipality",
      "state_code": "188",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Videm Municipality",
      "state_code": "135",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Vipava Municipality",
      "state_code": "136",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Vitanje Municipality",
      "state_code": "137",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Vodice Municipality",
      "state_code": "138",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Vojnik Municipality",
      "state_code": "139",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Vransko Municipality",
      "state_code": "189",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Vrhnika Municipality",
      "state_code": "140",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Vuzenica Municipality",
      "state_code": "141",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Zagorje ob Savi Municipality",
      "state_code": "142",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Žalec Municipality",
      "state_code": "190",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Zavrč Municipality",
      "state_code": "143",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Železniki Municipality",
      "state_code": "146",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Žetale Municipality",
      "state_code": "191",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Žiri Municipality",
      "state_code": "147",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Žirovnica Municipality",
      "state_code": "192",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Zreče Municipality",
      "state_code": "144",
      "country_id": 201
    },
    {
      "country_code": "SI",
      "country_name": "Slovenia",
      "name": "Žužemberk Municipality",
      "state_code": "193",
      "country_id": 201
    },
    {
      "country_code": "SB",
      "country_name": "Solomon Islands",
      "name": "Central Province",
      "state_code": "CE",
      "country_id": 202
    },
    {
      "country_code": "SB",
      "country_name": "Solomon Islands",
      "name": "Choiseul Province",
      "state_code": "CH",
      "country_id": 202
    },
    {
      "country_code": "SB",
      "country_name": "Solomon Islands",
      "name": "Guadalcanal Province",
      "state_code": "GU",
      "country_id": 202
    },
    {
      "country_code": "SB",
      "country_name": "Solomon Islands",
      "name": "Honiara",
      "state_code": "CT",
      "country_id": 202
    },
    {
      "country_code": "SB",
      "country_name": "Solomon Islands",
      "name": "Isabel Province",
      "state_code": "IS",
      "country_id": 202
    },
    {
      "country_code": "SB",
      "country_name": "Solomon Islands",
      "name": "Makira-Ulawa Province",
      "state_code": "MK",
      "country_id": 202
    },
    {
      "country_code": "SB",
      "country_name": "Solomon Islands",
      "name": "Malaita Province",
      "state_code": "ML",
      "country_id": 202
    },
    {
      "country_code": "SB",
      "country_name": "Solomon Islands",
      "name": "Rennell and Bellona Province",
      "state_code": "RB",
      "country_id": 202
    },
    {
      "country_code": "SB",
      "country_name": "Solomon Islands",
      "name": "Temotu Province",
      "state_code": "TE",
      "country_id": 202
    },
    {
      "country_code": "SB",
      "country_name": "Solomon Islands",
      "name": "Western Province",
      "state_code": "WE",
      "country_id": 202
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Awdal Region",
      "state_code": "AW",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Bakool",
      "state_code": "BK",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Banaadir",
      "state_code": "BN",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Bari",
      "state_code": "BR",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Bay",
      "state_code": "BY",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Galguduud",
      "state_code": "GA",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Gedo",
      "state_code": "GE",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Hiran",
      "state_code": "HI",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Lower Juba",
      "state_code": "JH",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Lower Shebelle",
      "state_code": "SH",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Middle Juba",
      "state_code": "JD",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Middle Shebelle",
      "state_code": "SD",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Mudug",
      "state_code": "MU",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Nugal",
      "state_code": "NU",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Sanaag Region",
      "state_code": "SA",
      "country_id": 203
    },
    {
      "country_code": "SO",
      "country_name": "Somalia",
      "name": "Togdheer Region",
      "state_code": "TO",
      "country_id": 203
    },
    {
      "country_code": "ZA",
      "country_name": "South Africa",
      "name": "Eastern Cape",
      "state_code": "EC",
      "country_id": 204
    },
    {
      "country_code": "ZA",
      "country_name": "South Africa",
      "name": "Free State",
      "state_code": "FS",
      "country_id": 204
    },
    {
      "country_code": "ZA",
      "country_name": "South Africa",
      "name": "Gauteng",
      "state_code": "GP",
      "country_id": 204
    },
    {
      "country_code": "ZA",
      "country_name": "South Africa",
      "name": "KwaZulu-Natal",
      "state_code": "KZN",
      "country_id": 204
    },
    {
      "country_code": "ZA",
      "country_name": "South Africa",
      "name": "Limpopo",
      "state_code": "LP",
      "country_id": 204
    },
    {
      "country_code": "ZA",
      "country_name": "South Africa",
      "name": "Mpumalanga",
      "state_code": "MP",
      "country_id": 204
    },
    {
      "country_code": "ZA",
      "country_name": "South Africa",
      "name": "North West",
      "state_code": "NW",
      "country_id": 204
    },
    {
      "country_code": "ZA",
      "country_name": "South Africa",
      "name": "Northern Cape",
      "state_code": "NC",
      "country_id": 204
    },
    {
      "country_code": "ZA",
      "country_name": "South Africa",
      "name": "Western Cape",
      "state_code": "WC",
      "country_id": 204
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "Busan",
      "state_code": "26",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "Daegu",
      "state_code": "27",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "Daejeon",
      "state_code": "30",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "Gangwon Province",
      "state_code": "42",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "Gwangju",
      "state_code": "29",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "Gyeonggi Province",
      "state_code": "41",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "Incheon",
      "state_code": "28",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "Jeju",
      "state_code": "49",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "North Chungcheong Province",
      "state_code": "43",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "North Gyeongsang Province",
      "state_code": "47",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "North Jeolla Province",
      "state_code": "45",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "Sejong City",
      "state_code": "50",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "Seoul",
      "state_code": "11",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "South Chungcheong Province",
      "state_code": "44",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "South Gyeongsang Province",
      "state_code": "48",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "South Jeolla Province",
      "state_code": "46",
      "country_id": 116
    },
    {
      "country_code": "KR",
      "country_name": "South Korea",
      "name": "Ulsan",
      "state_code": "31",
      "country_id": 116
    },
    {
      "country_code": "SS",
      "country_name": "South Sudan",
      "name": "Central Equatoria",
      "state_code": "EC",
      "country_id": 206
    },
    {
      "country_code": "SS",
      "country_name": "South Sudan",
      "name": "Eastern Equatoria",
      "state_code": "EE",
      "country_id": 206
    },
    {
      "country_code": "SS",
      "country_name": "South Sudan",
      "name": "Jonglei State",
      "state_code": "JG",
      "country_id": 206
    },
    {
      "country_code": "SS",
      "country_name": "South Sudan",
      "name": "Lakes",
      "state_code": "LK",
      "country_id": 206
    },
    {
      "country_code": "SS",
      "country_name": "South Sudan",
      "name": "Northern Bahr el Ghazal",
      "state_code": "BN",
      "country_id": 206
    },
    {
      "country_code": "SS",
      "country_name": "South Sudan",
      "name": "Unity",
      "state_code": "UY",
      "country_id": 206
    },
    {
      "country_code": "SS",
      "country_name": "South Sudan",
      "name": "Upper Nile",
      "state_code": "NU",
      "country_id": 206
    },
    {
      "country_code": "SS",
      "country_name": "South Sudan",
      "name": "Warrap",
      "state_code": "WR",
      "country_id": 206
    },
    {
      "country_code": "SS",
      "country_name": "South Sudan",
      "name": "Western Bahr el Ghazal",
      "state_code": "BW",
      "country_id": 206
    },
    {
      "country_code": "SS",
      "country_name": "South Sudan",
      "name": "Western Equatoria",
      "state_code": "EW",
      "country_id": 206
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "A Coruña",
      "state_code": "C",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Albacete",
      "state_code": "AB",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Alicante",
      "state_code": "A",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Almeria",
      "state_code": "AL",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Araba",
      "state_code": "VI",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Asturias",
      "state_code": "O",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Ávila",
      "state_code": "AV",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Badajoz",
      "state_code": "BA",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Barcelona",
      "state_code": "B",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Bizkaia",
      "state_code": "BI",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Burgos",
      "state_code": "BU",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Caceres",
      "state_code": "CC",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Cádiz",
      "state_code": "CA",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Cantabria",
      "state_code": "S",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Castellón",
      "state_code": "CS",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Ciudad Real",
      "state_code": "CR",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Córdoba",
      "state_code": "CO",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Cuenca",
      "state_code": "CU",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Gipuzkoa",
      "state_code": "SS",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Girona",
      "state_code": "GI",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Granada",
      "state_code": "GR",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Guadalajara",
      "state_code": "GU",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Huelva",
      "state_code": "H",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Huesca",
      "state_code": "HU",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Islas Baleares",
      "state_code": "PM",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Jaén",
      "state_code": "J",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "La Rioja",
      "state_code": "LO",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Las Palmas",
      "state_code": "GC",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Léon",
      "state_code": "LE",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Lleida",
      "state_code": "L",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Lugo",
      "state_code": "LU",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Madrid",
      "state_code": "M",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Málaga",
      "state_code": "MA",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Murcia",
      "state_code": "MU",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Navarra",
      "state_code": "NA",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Ourense",
      "state_code": "OR",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Palencia",
      "state_code": "P",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Pontevedra",
      "state_code": "PO",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Salamanca",
      "state_code": "SA",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Santa Cruz de Tenerife",
      "state_code": "TF",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Segovia",
      "state_code": "SG",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Sevilla",
      "state_code": "SE",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Soria",
      "state_code": "SO",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Tarragona",
      "state_code": "T",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Teruel",
      "state_code": "TE",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Toledo",
      "state_code": "TO",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Valencia",
      "state_code": "V",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Valladolid",
      "state_code": "VA",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Zamora",
      "state_code": "ZA",
      "country_id": 207
    },
    {
      "country_code": "ES",
      "country_name": "Spain",
      "name": "Zaragoza",
      "state_code": "Z",
      "country_id": 207
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Ampara District",
      "state_code": "52",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Anuradhapura District",
      "state_code": "71",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Badulla District",
      "state_code": "81",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Batticaloa District",
      "state_code": "51",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Central Province",
      "state_code": "2",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Colombo District",
      "state_code": "11",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Eastern Province",
      "state_code": "5",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Galle District",
      "state_code": "31",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Gampaha District",
      "state_code": "12",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Hambantota District",
      "state_code": "33",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Jaffna District",
      "state_code": "41",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Kalutara District",
      "state_code": "13",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Kandy District",
      "state_code": "21",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Kegalle District",
      "state_code": "92",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Kilinochchi District",
      "state_code": "42",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Mannar District",
      "state_code": "43",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Matale District",
      "state_code": "22",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Matara District",
      "state_code": "32",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Monaragala District",
      "state_code": "82",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Mullaitivu District",
      "state_code": "45",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "North Central Province",
      "state_code": "7",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "North Western Province",
      "state_code": "6",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Northern Province",
      "state_code": "4",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Nuwara Eliya District",
      "state_code": "23",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Polonnaruwa District",
      "state_code": "72",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Puttalam District",
      "state_code": "62",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Ratnapura district",
      "state_code": "91",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Sabaragamuwa Province",
      "state_code": "9",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Southern Province",
      "state_code": "3",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Trincomalee District",
      "state_code": "53",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Uva Province",
      "state_code": "8",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Vavuniya District",
      "state_code": "44",
      "country_id": 208
    },
    {
      "country_code": "LK",
      "country_name": "Sri Lanka",
      "name": "Western Province",
      "state_code": "1",
      "country_id": 208
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "Al Jazirah",
      "state_code": "GZ",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "Al Qadarif",
      "state_code": "GD",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "Blue Nile",
      "state_code": "NB",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "Central Darfur",
      "state_code": "DC",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "East Darfur",
      "state_code": "DE",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "Kassala",
      "state_code": "KA",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "Khartoum",
      "state_code": "KH",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "North Darfur",
      "state_code": "DN",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "North Kordofan",
      "state_code": "KN",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "Northern",
      "state_code": "NO",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "Red Sea",
      "state_code": "RS",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "River Nile",
      "state_code": "NR",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "Sennar",
      "state_code": "SI",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "South Darfur",
      "state_code": "DS",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "South Kordofan",
      "state_code": "KS",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "West Darfur",
      "state_code": "DW",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "West Kordofan",
      "state_code": "GK",
      "country_id": 209
    },
    {
      "country_code": "SD",
      "country_name": "Sudan",
      "name": "White Nile",
      "state_code": "NW",
      "country_id": 209
    },
    {
      "country_code": "SR",
      "country_name": "Suriname",
      "name": "Brokopondo District",
      "state_code": "BR",
      "country_id": 210
    },
    {
      "country_code": "SR",
      "country_name": "Suriname",
      "name": "Commewijne District",
      "state_code": "CM",
      "country_id": 210
    },
    {
      "country_code": "SR",
      "country_name": "Suriname",
      "name": "Coronie District",
      "state_code": "CR",
      "country_id": 210
    },
    {
      "country_code": "SR",
      "country_name": "Suriname",
      "name": "Marowijne District",
      "state_code": "MA",
      "country_id": 210
    },
    {
      "country_code": "SR",
      "country_name": "Suriname",
      "name": "Nickerie District",
      "state_code": "NI",
      "country_id": 210
    },
    {
      "country_code": "SR",
      "country_name": "Suriname",
      "name": "Para District",
      "state_code": "PR",
      "country_id": 210
    },
    {
      "country_code": "SR",
      "country_name": "Suriname",
      "name": "Paramaribo District",
      "state_code": "PM",
      "country_id": 210
    },
    {
      "country_code": "SR",
      "country_name": "Suriname",
      "name": "Saramacca District",
      "state_code": "SA",
      "country_id": 210
    },
    {
      "country_code": "SR",
      "country_name": "Suriname",
      "name": "Sipaliwini District",
      "state_code": "SI",
      "country_id": 210
    },
    {
      "country_code": "SR",
      "country_name": "Suriname",
      "name": "Wanica District",
      "state_code": "WA",
      "country_id": 210
    },
    {
      "country_code": "SZ",
      "country_name": "Swaziland",
      "name": "Hhohho District",
      "state_code": "HH",
      "country_id": 212
    },
    {
      "country_code": "SZ",
      "country_name": "Swaziland",
      "name": "Lubombo District",
      "state_code": "LU",
      "country_id": 212
    },
    {
      "country_code": "SZ",
      "country_name": "Swaziland",
      "name": "Manzini District",
      "state_code": "MA",
      "country_id": 212
    },
    {
      "country_code": "SZ",
      "country_name": "Swaziland",
      "name": "Shiselweni District",
      "state_code": "SH",
      "country_id": 212
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Blekinge",
      "state_code": "K",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Dalarna County",
      "state_code": "W",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Gävleborg County",
      "state_code": "X",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Gotland County",
      "state_code": "I",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Halland County",
      "state_code": "N",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Jönköping County",
      "state_code": "F",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Kalmar County",
      "state_code": "H",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Kronoberg County",
      "state_code": "G",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Norrbotten County",
      "state_code": "BD",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Örebro County",
      "state_code": "T",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Östergötland County",
      "state_code": "E",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Skåne County",
      "state_code": "M",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Södermanland County",
      "state_code": "D",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Stockholm County",
      "state_code": "AB",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Uppsala County",
      "state_code": "C",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Värmland County",
      "state_code": "S",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Västerbotten County",
      "state_code": "AC",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Västernorrland County",
      "state_code": "Y",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Västmanland County",
      "state_code": "U",
      "country_id": 213
    },
    {
      "country_code": "SE",
      "country_name": "Sweden",
      "name": "Västra Götaland County",
      "state_code": "O",
      "country_id": 213
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Aargau",
      "state_code": "AG",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Appenzell Ausserrhoden",
      "state_code": "AR",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Appenzell Innerrhoden",
      "state_code": "AI",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Basel-Land",
      "state_code": "BL",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Basel-Stadt",
      "state_code": "BS",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Bern",
      "state_code": "BE",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Fribourg",
      "state_code": "FR",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Geneva",
      "state_code": "GE",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Glarus",
      "state_code": "GL",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Graubünden",
      "state_code": "GR",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Jura",
      "state_code": "JU",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Lucerne",
      "state_code": "LU",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Neuchâtel",
      "state_code": "NE",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Nidwalden",
      "state_code": "NW",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Obwalden",
      "state_code": "OW",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Schaffhausen",
      "state_code": "SH",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Schwyz",
      "state_code": "SZ",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Solothurn",
      "state_code": "SO",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "St. Gallen",
      "state_code": "SG",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Thurgau",
      "state_code": "TG",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Ticino",
      "state_code": "TI",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Uri",
      "state_code": "UR",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Valais",
      "state_code": "VS",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Vaud",
      "state_code": "VD",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Zug",
      "state_code": "ZG",
      "country_id": 214
    },
    {
      "country_code": "CH",
      "country_name": "Switzerland",
      "name": "Zürich",
      "state_code": "ZH",
      "country_id": 214
    },
    {
      "country_code": "SY",
      "country_name": "Syria",
      "name": "Al-Hasakah",
      "state_code": "HA",
      "country_id": 215
    },
    {
      "country_code": "SY",
      "country_name": "Syria",
      "name": "Al-Raqqah",
      "state_code": "RA",
      "country_id": 215
    },
    {
      "country_code": "SY",
      "country_name": "Syria",
      "name": "Aleppo",
      "state_code": "HL",
      "country_id": 215
    },
    {
      "country_code": "SY",
      "country_name": "Syria",
      "name": "As-Suwayda",
      "state_code": "SU",
      "country_id": 215
    },
    {
      "country_code": "SY",
      "country_name": "Syria",
      "name": "Damascus",
      "state_code": "DI",
      "country_id": 215
    },
    {
      "country_code": "SY",
      "country_name": "Syria",
      "name": "Daraa",
      "state_code": "DR",
      "country_id": 215
    },
    {
      "country_code": "SY",
      "country_name": "Syria",
      "name": "Deir ez-Zor",
      "state_code": "DY",
      "country_id": 215
    },
    {
      "country_code": "SY",
      "country_name": "Syria",
      "name": "Hama",
      "state_code": "HM",
      "country_id": 215
    },
    {
      "country_code": "SY",
      "country_name": "Syria",
      "name": "Homs",
      "state_code": "HI",
      "country_id": 215
    },
    {
      "country_code": "SY",
      "country_name": "Syria",
      "name": "Idlib",
      "state_code": "ID",
      "country_id": 215
    },
    {
      "country_code": "SY",
      "country_name": "Syria",
      "name": "Latakia",
      "state_code": "LA",
      "country_id": 215
    },
    {
      "country_code": "SY",
      "country_name": "Syria",
      "name": "Quneitra",
      "state_code": "QU",
      "country_id": 215
    },
    {
      "country_code": "SY",
      "country_name": "Syria",
      "name": "Rif Dimashq",
      "state_code": "RD",
      "country_id": 215
    },
    {
      "country_code": "SY",
      "country_name": "Syria",
      "name": "Tartus",
      "state_code": "TA",
      "country_id": 215
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Changhua",
      "state_code": "CHA",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Chiayi",
      "state_code": "CYI",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Chiayi",
      "state_code": "CYQ",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Hsinchu",
      "state_code": "HSQ",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Hsinchu",
      "state_code": "HSZ",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Hualien",
      "state_code": "HUA",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Kaohsiung",
      "state_code": "KHH",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Keelung",
      "state_code": "KEE",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Kinmen",
      "state_code": "KIN",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Lienchiang",
      "state_code": "LIE",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Miaoli",
      "state_code": "MIA",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Nantou",
      "state_code": "NAN",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "New Taipei",
      "state_code": "NWT",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Penghu",
      "state_code": "PEN",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Pingtung",
      "state_code": "PIF",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Taichung",
      "state_code": "TXG",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Tainan",
      "state_code": "TNN",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Taipei",
      "state_code": "TPE",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Taitung",
      "state_code": "TTT",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Taoyuan",
      "state_code": "TAO",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Yilan",
      "state_code": "ILA",
      "country_id": 216
    },
    {
      "country_code": "TW",
      "country_name": "Taiwan",
      "name": "Yunlin",
      "state_code": "YUN",
      "country_id": 216
    },
    {
      "country_code": "TJ",
      "country_name": "Tajikistan",
      "name": "districts of Republican Subordination",
      "state_code": "RA",
      "country_id": 217
    },
    {
      "country_code": "TJ",
      "country_name": "Tajikistan",
      "name": "Gorno-Badakhshan Autonomous Province",
      "state_code": "GB",
      "country_id": 217
    },
    {
      "country_code": "TJ",
      "country_name": "Tajikistan",
      "name": "Khatlon Province",
      "state_code": "KT",
      "country_id": 217
    },
    {
      "country_code": "TJ",
      "country_name": "Tajikistan",
      "name": "Sughd Province",
      "state_code": "SU",
      "country_id": 217
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Arusha",
      "state_code": "01",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Dar es Salaam",
      "state_code": "02",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Dodoma",
      "state_code": "03",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Geita",
      "state_code": "27",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Iringa",
      "state_code": "04",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Kagera",
      "state_code": "05",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Katavi",
      "state_code": "28",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Kigoma",
      "state_code": "08",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Kilimanjaro",
      "state_code": "09",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Lindi",
      "state_code": "12",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Manyara",
      "state_code": "26",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Mara",
      "state_code": "13",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Mbeya",
      "state_code": "14",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Morogoro",
      "state_code": "16",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Mtwara",
      "state_code": "17",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Mwanza",
      "state_code": "18",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Njombe",
      "state_code": "29",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Pemba North",
      "state_code": "06",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Pemba South",
      "state_code": "10",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Pwani",
      "state_code": "19",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Rukwa",
      "state_code": "20",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Ruvuma",
      "state_code": "21",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Shinyanga",
      "state_code": "22",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Simiyu",
      "state_code": "30",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Singida",
      "state_code": "23",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Songwe",
      "state_code": "31",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Tabora",
      "state_code": "24",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Tanga",
      "state_code": "25",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Zanzibar North",
      "state_code": "07",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Zanzibar South",
      "state_code": "11",
      "country_id": 218
    },
    {
      "country_code": "TZ",
      "country_name": "Tanzania",
      "name": "Zanzibar West",
      "state_code": "15",
      "country_id": 218
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Amnat Charoen",
      "state_code": "37",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Ang Thong",
      "state_code": "15",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Bangkok",
      "state_code": "10",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Bueng Kan",
      "state_code": "38",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Buri Ram",
      "state_code": "31",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Chachoengsao",
      "state_code": "24",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Chai Nat",
      "state_code": "18",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Chaiyaphum",
      "state_code": "36",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Chanthaburi",
      "state_code": "22",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Chiang Mai",
      "state_code": "50",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Chiang Rai",
      "state_code": "57",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Chon Buri",
      "state_code": "20",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Chumphon",
      "state_code": "86",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Kalasin",
      "state_code": "46",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Kamphaeng Phet",
      "state_code": "62",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Kanchanaburi",
      "state_code": "71",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Khon Kaen",
      "state_code": "40",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Krabi",
      "state_code": "81",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Lampang",
      "state_code": "52",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Lamphun",
      "state_code": "51",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Loei",
      "state_code": "42",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Lop Buri",
      "state_code": "16",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Mae Hong Son",
      "state_code": "58",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Maha Sarakham",
      "state_code": "44",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Mukdahan",
      "state_code": "49",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Nakhon Nayok",
      "state_code": "26",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Nakhon Pathom",
      "state_code": "73",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Nakhon Phanom",
      "state_code": "48",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Nakhon Ratchasima",
      "state_code": "30",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Nakhon Sawan",
      "state_code": "60",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Nakhon Si Thammarat",
      "state_code": "80",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Nan",
      "state_code": "55",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Narathiwat",
      "state_code": "96",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Nong Bua Lam Phu",
      "state_code": "39",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Nong Khai",
      "state_code": "43",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Nonthaburi",
      "state_code": "12",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Pathum Thani",
      "state_code": "13",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Pattani",
      "state_code": "94",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Pattaya",
      "state_code": "S",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Phangnga",
      "state_code": "82",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Phatthalung",
      "state_code": "93",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Phayao",
      "state_code": "56",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Phetchabun",
      "state_code": "67",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Phetchaburi",
      "state_code": "76",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Phichit",
      "state_code": "66",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Phitsanulok",
      "state_code": "65",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Phra Nakhon Si Ayutthaya",
      "state_code": "14",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Phrae",
      "state_code": "54",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Phuket",
      "state_code": "83",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Prachin Buri",
      "state_code": "25",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Prachuap Khiri Khan",
      "state_code": "77",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Ranong",
      "state_code": "85",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Ratchaburi",
      "state_code": "70",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Rayong",
      "state_code": "21",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Roi Et",
      "state_code": "45",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Sa Kaeo",
      "state_code": "27",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Sakon Nakhon",
      "state_code": "47",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Samut Prakan",
      "state_code": "11",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Samut Sakhon",
      "state_code": "74",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Samut Songkhram",
      "state_code": "75",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Saraburi",
      "state_code": "19",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Satun",
      "state_code": "91",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Si Sa Ket",
      "state_code": "33",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Sing Buri",
      "state_code": "17",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Songkhla",
      "state_code": "90",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Sukhothai",
      "state_code": "64",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Suphan Buri",
      "state_code": "72",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Surat Thani",
      "state_code": "84",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Surin",
      "state_code": "32",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Tak",
      "state_code": "63",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Trang",
      "state_code": "92",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Trat",
      "state_code": "23",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Ubon Ratchathani",
      "state_code": "34",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Udon Thani",
      "state_code": "41",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Uthai Thani",
      "state_code": "61",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Uttaradit",
      "state_code": "53",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Yala",
      "state_code": "95",
      "country_id": 219
    },
    {
      "country_code": "TH",
      "country_name": "Thailand",
      "name": "Yasothon",
      "state_code": "35",
      "country_id": 219
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Acklins",
      "state_code": "AK",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Acklins and Crooked Islands",
      "state_code": "AC",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Berry Islands",
      "state_code": "BY",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Bimini",
      "state_code": "BI",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Black Point",
      "state_code": "BP",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Cat Island",
      "state_code": "CI",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Central Abaco",
      "state_code": "CO",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Central Andros",
      "state_code": "CS",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Central Eleuthera",
      "state_code": "CE",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Crooked Island",
      "state_code": "CK",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "East Grand Bahama",
      "state_code": "EG",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Exuma",
      "state_code": "EX",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Freeport",
      "state_code": "FP",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Fresh Creek",
      "state_code": "FC",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Governor's Harbour",
      "state_code": "GH",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Grand Cay",
      "state_code": "GC",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Green Turtle Cay",
      "state_code": "GT",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Harbour Island",
      "state_code": "HI",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "High Rock",
      "state_code": "HR",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Hope Town",
      "state_code": "HT",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Inagua",
      "state_code": "IN",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Kemps Bay",
      "state_code": "KB",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Long Island",
      "state_code": "LI",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Mangrove Cay",
      "state_code": "MC",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Marsh Harbour",
      "state_code": "MH",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Mayaguana District",
      "state_code": "MG",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "New Providence",
      "state_code": "NP",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Nichollstown and Berry Islands",
      "state_code": "NB",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "North Abaco",
      "state_code": "NO",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "North Andros",
      "state_code": "NS",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "North Eleuthera",
      "state_code": "NE",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Ragged Island",
      "state_code": "RI",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Rock Sound",
      "state_code": "RS",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Rum Cay District",
      "state_code": "RC",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "San Salvador and Rum Cay",
      "state_code": "SR",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "San Salvador Island",
      "state_code": "SS",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Sandy Point",
      "state_code": "SP",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "South Abaco",
      "state_code": "SO",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "South Andros",
      "state_code": "SA",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "South Eleuthera",
      "state_code": "SE",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "Spanish Wells",
      "state_code": "SW",
      "country_id": 17
    },
    {
      "country_code": "BS",
      "country_name": "The Bahamas",
      "name": "West Grand Bahama",
      "state_code": "WG",
      "country_id": 17
    },
    {
      "country_code": "TG",
      "country_name": "Togo",
      "name": "Centrale Region",
      "state_code": "C",
      "country_id": 220
    },
    {
      "country_code": "TG",
      "country_name": "Togo",
      "name": "Kara Region",
      "state_code": "K",
      "country_id": 220
    },
    {
      "country_code": "TG",
      "country_name": "Togo",
      "name": "Maritime",
      "state_code": "M",
      "country_id": 220
    },
    {
      "country_code": "TG",
      "country_name": "Togo",
      "name": "Plateaux Region",
      "state_code": "P",
      "country_id": 220
    },
    {
      "country_code": "TG",
      "country_name": "Togo",
      "name": "Savanes Region",
      "state_code": "S",
      "country_id": 220
    },
    {
      "country_code": "TO",
      "country_name": "Tonga",
      "name": "Haʻapai",
      "state_code": "02",
      "country_id": 222
    },
    {
      "country_code": "TO",
      "country_name": "Tonga",
      "name": "ʻEua",
      "state_code": "01",
      "country_id": 222
    },
    {
      "country_code": "TO",
      "country_name": "Tonga",
      "name": "Niuas",
      "state_code": "03",
      "country_id": 222
    },
    {
      "country_code": "TO",
      "country_name": "Tonga",
      "name": "Tongatapu",
      "state_code": "04",
      "country_id": 222
    },
    {
      "country_code": "TO",
      "country_name": "Tonga",
      "name": "Vavaʻu",
      "state_code": "05",
      "country_id": 222
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "Arima",
      "state_code": "ARI",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "Chaguanas",
      "state_code": "CHA",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "Couva-Tabaquite-Talparo Regional Corporation",
      "state_code": "CTT",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "Diego Martin Regional Corporation",
      "state_code": "DMN",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "Eastern Tobago",
      "state_code": "ETO",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "Penal-Debe Regional Corporation",
      "state_code": "PED",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "Point Fortin",
      "state_code": "PTF",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "Port of Spain",
      "state_code": "POS",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "Princes Town Regional Corporation",
      "state_code": "PRT",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "Rio Claro-Mayaro Regional Corporation",
      "state_code": "MRC",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "San Fernando",
      "state_code": "SFO",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "San Juan-Laventille Regional Corporation",
      "state_code": "SJL",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "Sangre Grande Regional Corporation",
      "state_code": "SGE",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "Siparia Regional Corporation",
      "state_code": "SIP",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "Tunapuna-Piarco Regional Corporation",
      "state_code": "TUP",
      "country_id": 223
    },
    {
      "country_code": "TT",
      "country_name": "Trinidad And Tobago",
      "name": "Western Tobago",
      "state_code": "WTO",
      "country_id": 223
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Ariana",
      "state_code": "12",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Ben Arous",
      "state_code": "13",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Bizerte",
      "state_code": "23",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Gabès",
      "state_code": "81",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Gafsa",
      "state_code": "71",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Jendouba",
      "state_code": "32",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Kairouan",
      "state_code": "41",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Kasserine",
      "state_code": "42",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Kassrine",
      "state_code": "31",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Kebili",
      "state_code": "73",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Kef",
      "state_code": "33",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Mahdia",
      "state_code": "53",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Manouba",
      "state_code": "14",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Medenine",
      "state_code": "82",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Monastir",
      "state_code": "52",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Nabeul",
      "state_code": "21",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Sfax",
      "state_code": "61",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Sidi Bouzid",
      "state_code": "43",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Siliana",
      "state_code": "34",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Sousse",
      "state_code": "51",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Tataouine",
      "state_code": "83",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Tozeur",
      "state_code": "72",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Tunis",
      "state_code": "11",
      "country_id": 224
    },
    {
      "country_code": "TN",
      "country_name": "Tunisia",
      "name": "Zaghouan",
      "state_code": "22",
      "country_id": 224
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Adana",
      "state_code": "01",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Adıyaman",
      "state_code": "02",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Afyonkarahisar",
      "state_code": "03",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Ağrı",
      "state_code": "04",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Aksaray",
      "state_code": "68",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Amasya",
      "state_code": "05",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Ankara",
      "state_code": "06",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Antalya",
      "state_code": "07",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Ardahan",
      "state_code": "75",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Artvin",
      "state_code": "08",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Aydın",
      "state_code": "09",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Balıkesir",
      "state_code": "10",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Bartın",
      "state_code": "74",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Batman",
      "state_code": "72",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Bayburt",
      "state_code": "69",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Bilecik",
      "state_code": "11",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Bingöl",
      "state_code": "12",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Bitlis",
      "state_code": "13",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Bolu",
      "state_code": "14",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Burdur",
      "state_code": "15",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Bursa",
      "state_code": "16",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Çanakkale",
      "state_code": "17",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Çankırı",
      "state_code": "18",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Çorum",
      "state_code": "19",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Denizli",
      "state_code": "20",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Diyarbakır",
      "state_code": "21",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Düzce",
      "state_code": "81",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Edirne",
      "state_code": "22",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Elazığ",
      "state_code": "23",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Erzincan",
      "state_code": "24",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Erzurum",
      "state_code": "25",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Eskişehir",
      "state_code": "26",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Gaziantep",
      "state_code": "27",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Giresun",
      "state_code": "28",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Gümüşhane",
      "state_code": "29",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Hakkâri",
      "state_code": "30",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Hatay",
      "state_code": "31",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Iğdır",
      "state_code": "76",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Isparta",
      "state_code": "32",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "İstanbul",
      "state_code": "34",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "İzmir",
      "state_code": "35",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Kahramanmaraş",
      "state_code": "46",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Karabük",
      "state_code": "78",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Karaman",
      "state_code": "70",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Kars",
      "state_code": "36",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Kastamonu",
      "state_code": "37",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Kayseri",
      "state_code": "38",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Kilis",
      "state_code": "79",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Kırıkkale",
      "state_code": "71",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Kırklareli",
      "state_code": "39",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Kırşehir",
      "state_code": "40",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Kocaeli",
      "state_code": "41",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Konya",
      "state_code": "42",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Kütahya",
      "state_code": "43",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Malatya",
      "state_code": "44",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Manisa",
      "state_code": "45",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Mardin",
      "state_code": "47",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Mersin",
      "state_code": "33",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Muğla",
      "state_code": "48",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Muş",
      "state_code": "49",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Nevşehir",
      "state_code": "50",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Niğde",
      "state_code": "51",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Ordu",
      "state_code": "52",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Osmaniye",
      "state_code": "80",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Rize",
      "state_code": "53",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Sakarya",
      "state_code": "54",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Samsun",
      "state_code": "55",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Şanlıurfa",
      "state_code": "63",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Siirt",
      "state_code": "56",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Sinop",
      "state_code": "57",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Sivas",
      "state_code": "58",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Şırnak",
      "state_code": "73",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Tekirdağ",
      "state_code": "59",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Tokat",
      "state_code": "60",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Trabzon",
      "state_code": "61",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Tunceli",
      "state_code": "62",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Uşak",
      "state_code": "64",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Van",
      "state_code": "65",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Yalova",
      "state_code": "77",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Yozgat",
      "state_code": "66",
      "country_id": 225
    },
    {
      "country_code": "TR",
      "country_name": "Turkey",
      "name": "Zonguldak",
      "state_code": "67",
      "country_id": 225
    },
    {
      "country_code": "TM",
      "country_name": "Turkmenistan",
      "name": "Ahal Region",
      "state_code": "A",
      "country_id": 226
    },
    {
      "country_code": "TM",
      "country_name": "Turkmenistan",
      "name": "Ashgabat",
      "state_code": "S",
      "country_id": 226
    },
    {
      "country_code": "TM",
      "country_name": "Turkmenistan",
      "name": "Balkan Region",
      "state_code": "B",
      "country_id": 226
    },
    {
      "country_code": "TM",
      "country_name": "Turkmenistan",
      "name": "Daşoguz Region",
      "state_code": "D",
      "country_id": 226
    },
    {
      "country_code": "TM",
      "country_name": "Turkmenistan",
      "name": "Lebap Region",
      "state_code": "L",
      "country_id": 226
    },
    {
      "country_code": "TM",
      "country_name": "Turkmenistan",
      "name": "Mary Region",
      "state_code": "M",
      "country_id": 226
    },
    {
      "country_code": "TV",
      "country_name": "Tuvalu",
      "name": "Funafuti",
      "state_code": "FUN",
      "country_id": 228
    },
    {
      "country_code": "TV",
      "country_name": "Tuvalu",
      "name": "Nanumanga",
      "state_code": "NMG",
      "country_id": 228
    },
    {
      "country_code": "TV",
      "country_name": "Tuvalu",
      "name": "Nanumea",
      "state_code": "NMA",
      "country_id": 228
    },
    {
      "country_code": "TV",
      "country_name": "Tuvalu",
      "name": "Niutao Island Council",
      "state_code": "NIT",
      "country_id": 228
    },
    {
      "country_code": "TV",
      "country_name": "Tuvalu",
      "name": "Nui",
      "state_code": "NUI",
      "country_id": 228
    },
    {
      "country_code": "TV",
      "country_name": "Tuvalu",
      "name": "Nukufetau",
      "state_code": "NKF",
      "country_id": 228
    },
    {
      "country_code": "TV",
      "country_name": "Tuvalu",
      "name": "Nukulaelae",
      "state_code": "NKL",
      "country_id": 228
    },
    {
      "country_code": "TV",
      "country_name": "Tuvalu",
      "name": "Vaitupu",
      "state_code": "VAI",
      "country_id": 228
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Abim District",
      "state_code": "314",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Adjumani District",
      "state_code": "301",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Agago District",
      "state_code": "322",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Alebtong District",
      "state_code": "323",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Amolatar District",
      "state_code": "315",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Amudat District",
      "state_code": "324",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Amuria District",
      "state_code": "216",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Amuru District",
      "state_code": "316",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Apac District",
      "state_code": "302",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Arua District",
      "state_code": "303",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Budaka District",
      "state_code": "217",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Bududa District",
      "state_code": "218",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Bugiri District",
      "state_code": "201",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Buhweju District",
      "state_code": "420",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Buikwe District",
      "state_code": "117",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Bukedea District",
      "state_code": "219",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Bukomansimbi District",
      "state_code": "118",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Bukwo District",
      "state_code": "220",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Bulambuli District",
      "state_code": "225",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Buliisa District",
      "state_code": "416",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Bundibugyo District",
      "state_code": "401",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Bunyangabu District",
      "state_code": "430",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Bushenyi District",
      "state_code": "402",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Busia District",
      "state_code": "202",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Butaleja District",
      "state_code": "221",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Butambala District",
      "state_code": "119",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Butebo District",
      "state_code": "233",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Buvuma District",
      "state_code": "120",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Buyende District",
      "state_code": "226",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Central Region",
      "state_code": "C",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Dokolo District",
      "state_code": "317",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Eastern Region",
      "state_code": "E",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Gomba District",
      "state_code": "121",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Gulu District",
      "state_code": "304",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Ibanda District",
      "state_code": "417",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Iganga District",
      "state_code": "203",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Isingiro District",
      "state_code": "418",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Jinja District",
      "state_code": "204",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kaabong District",
      "state_code": "318",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kabale District",
      "state_code": "404",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kabarole District",
      "state_code": "405",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kaberamaido District",
      "state_code": "213",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kagadi District",
      "state_code": "427",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kakumiro District",
      "state_code": "428",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kalangala District",
      "state_code": "101",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kaliro District",
      "state_code": "222",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kalungu District",
      "state_code": "122",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kampala District",
      "state_code": "102",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kamuli District",
      "state_code": "205",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kamwenge District",
      "state_code": "413",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kanungu District",
      "state_code": "414",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kapchorwa District",
      "state_code": "206",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kasese District",
      "state_code": "406",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Katakwi District",
      "state_code": "207",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kayunga District",
      "state_code": "112",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kibaale District",
      "state_code": "407",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kiboga District",
      "state_code": "103",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kibuku District",
      "state_code": "227",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kiruhura District",
      "state_code": "419",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kiryandongo District",
      "state_code": "421",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kisoro District",
      "state_code": "408",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kitgum District",
      "state_code": "305",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Koboko District",
      "state_code": "319",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kole District",
      "state_code": "325",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kotido District",
      "state_code": "306",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kumi District",
      "state_code": "208",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kween District",
      "state_code": "228",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kyankwanzi District",
      "state_code": "123",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kyegegwa District",
      "state_code": "422",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kyenjojo District",
      "state_code": "415",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Kyotera District",
      "state_code": "125",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Lamwo District",
      "state_code": "326",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Lira District",
      "state_code": "307",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Luuka District",
      "state_code": "229",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Luwero District",
      "state_code": "104",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Lwengo District",
      "state_code": "124",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Lyantonde District",
      "state_code": "114",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Manafwa District",
      "state_code": "223",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Maracha District",
      "state_code": "320",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Masaka District",
      "state_code": "105",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Masindi District",
      "state_code": "409",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Mayuge District",
      "state_code": "214",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Mbale District",
      "state_code": "209",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Mbarara District",
      "state_code": "410",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Mitooma District",
      "state_code": "423",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Mityana District",
      "state_code": "115",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Moroto District",
      "state_code": "308",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Moyo District",
      "state_code": "309",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Mpigi District",
      "state_code": "106",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Mubende District",
      "state_code": "107",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Mukono District",
      "state_code": "108",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Nakapiripirit District",
      "state_code": "311",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Nakaseke District",
      "state_code": "116",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Nakasongola District",
      "state_code": "109",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Namayingo District",
      "state_code": "230",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Namisindwa District",
      "state_code": "234",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Namutumba District",
      "state_code": "224",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Napak District",
      "state_code": "327",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Nebbi District",
      "state_code": "310",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Ngora District",
      "state_code": "231",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Northern Region",
      "state_code": "N",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Ntoroko District",
      "state_code": "424",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Ntungamo District",
      "state_code": "411",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Nwoya District",
      "state_code": "328",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Omoro District",
      "state_code": "331",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Otuke District",
      "state_code": "329",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Oyam District",
      "state_code": "321",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Pader District",
      "state_code": "312",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Pakwach District",
      "state_code": "332",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Pallisa District",
      "state_code": "210",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Rakai District",
      "state_code": "110",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Rubanda District",
      "state_code": "429",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Rubirizi District",
      "state_code": "425",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Rukiga District",
      "state_code": "431",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Rukungiri District",
      "state_code": "412",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Sembabule District",
      "state_code": "111",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Serere District",
      "state_code": "232",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Sheema District",
      "state_code": "426",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Sironko District",
      "state_code": "215",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Soroti District",
      "state_code": "211",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Tororo District",
      "state_code": "212",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Wakiso District",
      "state_code": "113",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Western Region",
      "state_code": "W",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Yumbe District",
      "state_code": "313",
      "country_id": 229
    },
    {
      "country_code": "UG",
      "country_name": "Uganda",
      "name": "Zombo District",
      "state_code": "330",
      "country_id": 229
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Autonomous Republic of Crimea",
      "state_code": "43",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Cherkaska oblast",
      "state_code": "71",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Chernihivska oblast",
      "state_code": "74",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Chernivetska oblast",
      "state_code": "77",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Dnipropetrovska oblast",
      "state_code": "12",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Donetska oblast",
      "state_code": "14",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Ivano-Frankivska oblast",
      "state_code": "26",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Kharkivska oblast",
      "state_code": "63",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Khersonska oblast",
      "state_code": "65",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Khmelnytska oblast",
      "state_code": "68",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Kirovohradska oblast",
      "state_code": "35",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Kyiv",
      "state_code": "30",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Kyivska oblast",
      "state_code": "32",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Luhanska oblast",
      "state_code": "09",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Lvivska oblast",
      "state_code": "46",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Mykolaivska oblast",
      "state_code": "48",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Odeska oblast",
      "state_code": "51",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Poltavska oblast",
      "state_code": "53",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Rivnenska oblast",
      "state_code": "56",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Sumska oblast",
      "state_code": "59",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Ternopilska oblast",
      "state_code": "61",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Vinnytska oblast",
      "state_code": "05",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Volynska oblast",
      "state_code": "07",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Zakarpatska Oblast",
      "state_code": "21",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Zaporizka oblast",
      "state_code": "23",
      "country_id": 230
    },
    {
      "country_code": "UA",
      "country_name": "Ukraine",
      "name": "Zhytomyrska oblast",
      "state_code": "18",
      "country_id": 230
    },
    {
      "country_code": "AE",
      "country_name": "United Arab Emirates",
      "name": "Abu Dhabi Emirate",
      "state_code": "AZ",
      "country_id": 231
    },
    {
      "country_code": "AE",
      "country_name": "United Arab Emirates",
      "name": "Ajman Emirate",
      "state_code": "AJ",
      "country_id": 231
    },
    {
      "country_code": "AE",
      "country_name": "United Arab Emirates",
      "name": "Dubai",
      "state_code": "DU",
      "country_id": 231
    },
    {
      "country_code": "AE",
      "country_name": "United Arab Emirates",
      "name": "Fujairah",
      "state_code": "FU",
      "country_id": 231
    },
    {
      "country_code": "AE",
      "country_name": "United Arab Emirates",
      "name": "Ras al-Khaimah",
      "state_code": "RK",
      "country_id": 231
    },
    {
      "country_code": "AE",
      "country_name": "United Arab Emirates",
      "name": "Sharjah Emirate",
      "state_code": "SH",
      "country_id": 231
    },
    {
      "country_code": "AE",
      "country_name": "United Arab Emirates",
      "name": "Umm al-Quwain",
      "state_code": "UQ",
      "country_id": 231
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Aberdeen",
      "state_code": "ABE",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Aberdeenshire",
      "state_code": "ABD",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Angus",
      "state_code": "ANS",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Antrim",
      "state_code": "ANT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Antrim and Newtownabbey",
      "state_code": "ANN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Ards",
      "state_code": "ARD",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Ards and North Down",
      "state_code": "AND",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Argyll and Bute",
      "state_code": "AGB",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Armagh City and District Council",
      "state_code": "ARM",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Armagh, Banbridge and Craigavon",
      "state_code": "ABC",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Ascension Island",
      "state_code": "SH-AC",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Ballymena Borough",
      "state_code": "BLA",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Ballymoney",
      "state_code": "BLY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Banbridge",
      "state_code": "BNB",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Barnsley",
      "state_code": "BNS",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Bath and North East Somerset",
      "state_code": "BAS",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Bedford",
      "state_code": "BDF",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Belfast district",
      "state_code": "BFS",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Birmingham",
      "state_code": "BIR",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Blackburn with Darwen",
      "state_code": "BBD",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Blackpool",
      "state_code": "BPL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Blaenau Gwent County Borough",
      "state_code": "BGW",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Bolton",
      "state_code": "BOL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Bournemouth",
      "state_code": "BMH",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Bracknell Forest",
      "state_code": "BRC",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Bradford",
      "state_code": "BRD",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Bridgend County Borough",
      "state_code": "BGE",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Brighton and Hove",
      "state_code": "BNH",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Buckinghamshire",
      "state_code": "BKM",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Bury",
      "state_code": "BUR",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Caerphilly County Borough",
      "state_code": "CAY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Calderdale",
      "state_code": "CLD",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Cambridgeshire",
      "state_code": "CAM",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Carmarthenshire",
      "state_code": "CMN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Carrickfergus Borough Council",
      "state_code": "CKF",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Castlereagh",
      "state_code": "CSR",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Causeway Coast and Glens",
      "state_code": "CCG",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Central Bedfordshire",
      "state_code": "CBF",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Ceredigion",
      "state_code": "CGN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Cheshire East",
      "state_code": "CHE",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Cheshire West and Chester",
      "state_code": "CHW",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City and County of Cardiff",
      "state_code": "CRF",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City and County of Swansea",
      "state_code": "SWA",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of Bristol",
      "state_code": "BST",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of Derby",
      "state_code": "DER",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of Kingston upon Hull",
      "state_code": "KHL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of Leicester",
      "state_code": "LCE",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of London",
      "state_code": "LND",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of Nottingham",
      "state_code": "NGM",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of Peterborough",
      "state_code": "PTE",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of Plymouth",
      "state_code": "PLY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of Portsmouth",
      "state_code": "POR",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of Southampton",
      "state_code": "STH",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of Stoke-on-Trent",
      "state_code": "STE",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of Sunderland",
      "state_code": "SND",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of Westminster",
      "state_code": "WSM",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of Wolverhampton",
      "state_code": "WLV",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "City of York",
      "state_code": "YOR",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Clackmannanshire",
      "state_code": "CLK",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Coleraine Borough Council",
      "state_code": "CLR",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Conwy County Borough",
      "state_code": "CWY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Cookstown District Council",
      "state_code": "CKT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Cornwall",
      "state_code": "CON",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "County Durham",
      "state_code": "DUR",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Coventry",
      "state_code": "COV",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Craigavon Borough Council",
      "state_code": "CGV",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Cumbria",
      "state_code": "CMA",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Darlington",
      "state_code": "DAL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Denbighshire",
      "state_code": "DEN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Derbyshire",
      "state_code": "DBY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Derry City and Strabane",
      "state_code": "DRS",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Derry City Council",
      "state_code": "DRY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Devon",
      "state_code": "DEV",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Doncaster",
      "state_code": "DNC",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Dorset",
      "state_code": "DOR",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Down District Council",
      "state_code": "DOW",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Dudley",
      "state_code": "DUD",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Dumfries and Galloway",
      "state_code": "DGY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Dundee",
      "state_code": "DND",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Dungannon and South Tyrone Borough Council",
      "state_code": "DGN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "East Ayrshire",
      "state_code": "EAY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "East Dunbartonshire",
      "state_code": "EDU",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "East Lothian",
      "state_code": "ELN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "East Renfrewshire",
      "state_code": "ERW",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "East Riding of Yorkshire",
      "state_code": "ERY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "East Sussex",
      "state_code": "ESX",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Edinburgh",
      "state_code": "EDH",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "England",
      "state_code": "ENG",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Essex",
      "state_code": "ESS",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Falkirk",
      "state_code": "FAL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Fermanagh and Omagh",
      "state_code": "FMO",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Fermanagh District Council",
      "state_code": "FER",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Fife",
      "state_code": "FIF",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Flintshire",
      "state_code": "FLN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Gateshead",
      "state_code": "GAT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Glasgow",
      "state_code": "GLG",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Gloucestershire",
      "state_code": "GLS",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Gwynedd",
      "state_code": "GWN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Halton",
      "state_code": "HAL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Hampshire",
      "state_code": "HAM",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Hartlepool",
      "state_code": "HPL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Herefordshire",
      "state_code": "HEF",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Hertfordshire",
      "state_code": "HRT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Highland",
      "state_code": "HLD",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Inverclyde",
      "state_code": "IVC",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Isle of Wight",
      "state_code": "IOW",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Isles of Scilly",
      "state_code": "IOS",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Kent",
      "state_code": "KEN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Kirklees",
      "state_code": "KIR",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Knowsley",
      "state_code": "KWL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Lancashire",
      "state_code": "LAN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Larne Borough Council",
      "state_code": "LRN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Leeds",
      "state_code": "LDS",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Leicestershire",
      "state_code": "LEC",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Limavady Borough Council",
      "state_code": "LMV",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Lincolnshire",
      "state_code": "LIN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Lisburn and Castlereagh",
      "state_code": "LBC",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Lisburn City Council",
      "state_code": "LSB",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Liverpool",
      "state_code": "LIV",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Barking and Dagenham",
      "state_code": "BDG",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Barnet",
      "state_code": "BNE",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Bexley",
      "state_code": "BEX",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Brent",
      "state_code": "BEN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Bromley",
      "state_code": "BRY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Camden",
      "state_code": "CMD",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Croydon",
      "state_code": "CRY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Ealing",
      "state_code": "EAL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Enfield",
      "state_code": "ENF",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Hackney",
      "state_code": "HCK",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Hammersmith and Fulham",
      "state_code": "HMF",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Haringey",
      "state_code": "HRY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Harrow",
      "state_code": "HRW",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Havering",
      "state_code": "HAV",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Hillingdon",
      "state_code": "HIL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Hounslow",
      "state_code": "HNS",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Islington",
      "state_code": "ISL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Lambeth",
      "state_code": "LBH",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Lewisham",
      "state_code": "LEW",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Merton",
      "state_code": "MRT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Newham",
      "state_code": "NWM",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Redbridge",
      "state_code": "RDB",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Richmond upon Thames",
      "state_code": "RIC",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Southwark",
      "state_code": "SWK",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Sutton",
      "state_code": "STN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Tower Hamlets",
      "state_code": "TWH",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Waltham Forest",
      "state_code": "WFT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "London Borough of Wandsworth",
      "state_code": "WND",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Magherafelt District Council",
      "state_code": "MFT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Manchester",
      "state_code": "MAN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Medway",
      "state_code": "MDW",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Merthyr Tydfil County Borough",
      "state_code": "MTY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Metropolitan Borough of Wigan",
      "state_code": "WGN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Mid and East Antrim",
      "state_code": "MEA",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Mid Ulster",
      "state_code": "MUL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Middlesbrough",
      "state_code": "MDB",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Midlothian",
      "state_code": "MLN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Milton Keynes",
      "state_code": "MIK",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Monmouthshire",
      "state_code": "MON",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Moray",
      "state_code": "MRY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Moyle District Council",
      "state_code": "MYL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Neath Port Talbot County Borough",
      "state_code": "NTL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Newcastle upon Tyne",
      "state_code": "NET",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Newport",
      "state_code": "NWP",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Newry and Mourne District Council",
      "state_code": "NYM",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Newry, Mourne and Down",
      "state_code": "NMD",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Newtownabbey Borough Council",
      "state_code": "NTA",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Norfolk",
      "state_code": "NFK",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "North Ayrshire",
      "state_code": "NAY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "North Down Borough Council",
      "state_code": "NDN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "North East Lincolnshire",
      "state_code": "NEL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "North Lanarkshire",
      "state_code": "NLK",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "North Lincolnshire",
      "state_code": "NLN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "North Somerset",
      "state_code": "NSM",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "North Tyneside",
      "state_code": "NTY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "North Yorkshire",
      "state_code": "NYK",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Northamptonshire",
      "state_code": "NTH",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Northern Ireland",
      "state_code": "NIR",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Northumberland",
      "state_code": "NBL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Nottinghamshire",
      "state_code": "NTT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Oldham",
      "state_code": "OLD",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Omagh District Council",
      "state_code": "OMH",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Orkney Islands",
      "state_code": "ORK",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Outer Hebrides",
      "state_code": "ELS",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Oxfordshire",
      "state_code": "OXF",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Pembrokeshire",
      "state_code": "PEM",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Perth and Kinross",
      "state_code": "PKN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Poole",
      "state_code": "POL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Powys",
      "state_code": "POW",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Reading",
      "state_code": "RDG",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Redcar and Cleveland",
      "state_code": "RCC",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Renfrewshire",
      "state_code": "RFW",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Rhondda Cynon Taf",
      "state_code": "RCT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Rochdale",
      "state_code": "RCH",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Rotherham",
      "state_code": "ROT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Royal Borough of Greenwich",
      "state_code": "GRE",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Royal Borough of Kensington and Chelsea",
      "state_code": "KEC",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Royal Borough of Kingston upon Thames",
      "state_code": "KTT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Rutland",
      "state_code": "RUT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Saint Helena",
      "state_code": "SH-HL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Salford",
      "state_code": "SLF",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Sandwell",
      "state_code": "SAW",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Scotland",
      "state_code": "SCT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Scottish Borders",
      "state_code": "SCB",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Sefton",
      "state_code": "SFT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Sheffield",
      "state_code": "SHF",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Shetland Islands",
      "state_code": "ZET",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Shropshire",
      "state_code": "SHR",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Slough",
      "state_code": "SLG",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Solihull",
      "state_code": "SOL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Somerset",
      "state_code": "SOM",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "South Ayrshire",
      "state_code": "SAY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "South Gloucestershire",
      "state_code": "SGC",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "South Lanarkshire",
      "state_code": "SLK",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "South Tyneside",
      "state_code": "STY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Southend-on-Sea",
      "state_code": "SOS",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "St Helens",
      "state_code": "SHN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Staffordshire",
      "state_code": "STS",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Stirling",
      "state_code": "STG",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Stockport",
      "state_code": "SKP",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Stockton-on-Tees",
      "state_code": "STT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Strabane District Council",
      "state_code": "STB",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Suffolk",
      "state_code": "SFK",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Surrey",
      "state_code": "SRY",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Swindon",
      "state_code": "SWD",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Tameside",
      "state_code": "TAM",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Telford and Wrekin",
      "state_code": "TFW",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Thurrock",
      "state_code": "THR",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Torbay",
      "state_code": "TOB",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Torfaen",
      "state_code": "TOF",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Trafford",
      "state_code": "TRF",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "United Kingdom",
      "state_code": "UKM",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Vale of Glamorgan",
      "state_code": "VGL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Wakefield",
      "state_code": "WKF",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Wales",
      "state_code": "WLS",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Walsall",
      "state_code": "WLL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Warrington",
      "state_code": "WRT",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Warwickshire",
      "state_code": "WAR",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "West Berkshire",
      "state_code": "WBK",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "West Dunbartonshire",
      "state_code": "WDU",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "West Lothian",
      "state_code": "WLN",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "West Sussex",
      "state_code": "WSX",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Wiltshire",
      "state_code": "WIL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Windsor and Maidenhead",
      "state_code": "WNM",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Wirral",
      "state_code": "WRL",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Wokingham",
      "state_code": "WOK",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Worcestershire",
      "state_code": "WOR",
      "country_id": 232
    },
    {
      "country_code": "GB",
      "country_name": "United Kingdom",
      "name": "Wrexham County Borough",
      "state_code": "WRX",
      "country_id": 232
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Alabama",
      "state_code": "AL",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Alaska",
      "state_code": "AK",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "American Samoa",
      "state_code": "AS",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Arizona",
      "state_code": "AZ",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Arkansas",
      "state_code": "AR",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Baker Island",
      "state_code": "UM-81",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "California",
      "state_code": "CA",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Colorado",
      "state_code": "CO",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Connecticut",
      "state_code": "CT",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Delaware",
      "state_code": "DE",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "District of Columbia",
      "state_code": "DC",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Florida",
      "state_code": "FL",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Georgia",
      "state_code": "GA",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Guam",
      "state_code": "GU",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Hawaii",
      "state_code": "HI",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Howland Island",
      "state_code": "UM-84",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Idaho",
      "state_code": "ID",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Illinois",
      "state_code": "IL",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Indiana",
      "state_code": "IN",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Iowa",
      "state_code": "IA",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Jarvis Island",
      "state_code": "UM-86",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Johnston Atoll",
      "state_code": "UM-67",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Kansas",
      "state_code": "KS",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Kentucky",
      "state_code": "KY",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Kingman Reef",
      "state_code": "UM-89",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Louisiana",
      "state_code": "LA",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Maine",
      "state_code": "ME",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Maryland",
      "state_code": "MD",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Massachusetts",
      "state_code": "MA",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Michigan",
      "state_code": "MI",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Midway Atoll",
      "state_code": "UM-71",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Minnesota",
      "state_code": "MN",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Mississippi",
      "state_code": "MS",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Missouri",
      "state_code": "MO",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Montana",
      "state_code": "MT",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Navassa Island",
      "state_code": "UM-76",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Nebraska",
      "state_code": "NE",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Nevada",
      "state_code": "NV",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "New Hampshire",
      "state_code": "NH",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "New Jersey",
      "state_code": "NJ",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "New Mexico",
      "state_code": "NM",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "New York",
      "state_code": "NY",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "North Carolina",
      "state_code": "NC",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "North Dakota",
      "state_code": "ND",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Northern Mariana Islands",
      "state_code": "MP",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Ohio",
      "state_code": "OH",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Oklahoma",
      "state_code": "OK",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Oregon",
      "state_code": "OR",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Palmyra Atoll",
      "state_code": "UM-95",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Pennsylvania",
      "state_code": "PA",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Puerto Rico",
      "state_code": "PR",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Rhode Island",
      "state_code": "RI",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "South Carolina",
      "state_code": "SC",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "South Dakota",
      "state_code": "SD",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Tennessee",
      "state_code": "TN",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Texas",
      "state_code": "TX",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "United States Minor Outlying Islands",
      "state_code": "UM",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "United States Virgin Islands",
      "state_code": "VI",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Utah",
      "state_code": "UT",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Vermont",
      "state_code": "VT",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Virginia",
      "state_code": "VA",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Wake Island",
      "state_code": "UM-79",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Washington",
      "state_code": "WA",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "West Virginia",
      "state_code": "WV",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Wisconsin",
      "state_code": "WI",
      "country_id": 233
    },
    {
      "country_code": "US",
      "country_name": "United States",
      "name": "Wyoming",
      "state_code": "WY",
      "country_id": 233
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Artigas Department",
      "state_code": "AR",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Canelones Department",
      "state_code": "CA",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Cerro Largo Department",
      "state_code": "CL",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Colonia Department",
      "state_code": "CO",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Durazno Department",
      "state_code": "DU",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Flores Department",
      "state_code": "FS",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Florida Department",
      "state_code": "FD",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Lavalleja Department",
      "state_code": "LA",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Maldonado Department",
      "state_code": "MA",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Montevideo Department",
      "state_code": "MO",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Paysandú Department",
      "state_code": "PA",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Río Negro Department",
      "state_code": "RN",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Rivera Department",
      "state_code": "RV",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Rocha Department",
      "state_code": "RO",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Salto Department",
      "state_code": "SA",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "San José Department",
      "state_code": "SJ",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Soriano Department",
      "state_code": "SO",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Tacuarembó Department",
      "state_code": "TA",
      "country_id": 235
    },
    {
      "country_code": "UY",
      "country_name": "Uruguay",
      "name": "Treinta y Tres Department",
      "state_code": "TT",
      "country_id": 235
    },
    {
      "country_code": "UZ",
      "country_name": "Uzbekistan",
      "name": "Andijan Region",
      "state_code": "AN",
      "country_id": 236
    },
    {
      "country_code": "UZ",
      "country_name": "Uzbekistan",
      "name": "Bukhara Region",
      "state_code": "BU",
      "country_id": 236
    },
    {
      "country_code": "UZ",
      "country_name": "Uzbekistan",
      "name": "Fergana Region",
      "state_code": "FA",
      "country_id": 236
    },
    {
      "country_code": "UZ",
      "country_name": "Uzbekistan",
      "name": "Jizzakh Region",
      "state_code": "JI",
      "country_id": 236
    },
    {
      "country_code": "UZ",
      "country_name": "Uzbekistan",
      "name": "Karakalpakstan",
      "state_code": "QR",
      "country_id": 236
    },
    {
      "country_code": "UZ",
      "country_name": "Uzbekistan",
      "name": "Namangan Region",
      "state_code": "NG",
      "country_id": 236
    },
    {
      "country_code": "UZ",
      "country_name": "Uzbekistan",
      "name": "Navoiy Region",
      "state_code": "NW",
      "country_id": 236
    },
    {
      "country_code": "UZ",
      "country_name": "Uzbekistan",
      "name": "Qashqadaryo Region",
      "state_code": "QA",
      "country_id": 236
    },
    {
      "country_code": "UZ",
      "country_name": "Uzbekistan",
      "name": "Samarqand Region",
      "state_code": "SA",
      "country_id": 236
    },
    {
      "country_code": "UZ",
      "country_name": "Uzbekistan",
      "name": "Sirdaryo Region",
      "state_code": "SI",
      "country_id": 236
    },
    {
      "country_code": "UZ",
      "country_name": "Uzbekistan",
      "name": "Surxondaryo Region",
      "state_code": "SU",
      "country_id": 236
    },
    {
      "country_code": "UZ",
      "country_name": "Uzbekistan",
      "name": "Tashkent",
      "state_code": "TK",
      "country_id": 236
    },
    {
      "country_code": "UZ",
      "country_name": "Uzbekistan",
      "name": "Tashkent Region",
      "state_code": "TO",
      "country_id": 236
    },
    {
      "country_code": "UZ",
      "country_name": "Uzbekistan",
      "name": "Xorazm Region",
      "state_code": "XO",
      "country_id": 236
    },
    {
      "country_code": "VU",
      "country_name": "Vanuatu",
      "name": "Malampa",
      "state_code": "MAP",
      "country_id": 237
    },
    {
      "country_code": "VU",
      "country_name": "Vanuatu",
      "name": "Penama",
      "state_code": "PAM",
      "country_id": 237
    },
    {
      "country_code": "VU",
      "country_name": "Vanuatu",
      "name": "Sanma",
      "state_code": "SAM",
      "country_id": 237
    },
    {
      "country_code": "VU",
      "country_name": "Vanuatu",
      "name": "Shefa",
      "state_code": "SEE",
      "country_id": 237
    },
    {
      "country_code": "VU",
      "country_name": "Vanuatu",
      "name": "Tafea",
      "state_code": "TAE",
      "country_id": 237
    },
    {
      "country_code": "VU",
      "country_name": "Vanuatu",
      "name": "Torba",
      "state_code": "TOB",
      "country_id": 237
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Amazonas",
      "state_code": "Z",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Anzoátegui",
      "state_code": "B",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Apure",
      "state_code": "C",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Aragua",
      "state_code": "D",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Barinas",
      "state_code": "E",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Bolívar",
      "state_code": "F",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Carabobo",
      "state_code": "G",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Cojedes",
      "state_code": "H",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Delta Amacuro",
      "state_code": "Y",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Distrito Capital",
      "state_code": "A",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Falcón",
      "state_code": "I",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Federal Dependencies of Venezuela",
      "state_code": "W",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Guárico",
      "state_code": "J",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "La Guaira",
      "state_code": "X",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Lara",
      "state_code": "K",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Mérida",
      "state_code": "L",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Miranda",
      "state_code": "M",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Monagas",
      "state_code": "N",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Nueva Esparta",
      "state_code": "O",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Portuguesa",
      "state_code": "P",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Sucre",
      "state_code": "R",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Táchira",
      "state_code": "S",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Trujillo",
      "state_code": "T",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Yaracuy",
      "state_code": "U",
      "country_id": 239
    },
    {
      "country_code": "VE",
      "country_name": "Venezuela",
      "name": "Zulia",
      "state_code": "V",
      "country_id": 239
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "An Giang",
      "state_code": "44",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Bà Rịa-Vũng Tàu",
      "state_code": "43",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Bắc Giang",
      "state_code": "54",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Bắc Kạn",
      "state_code": "53",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Bạc Liêu",
      "state_code": "55",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Bắc Ninh",
      "state_code": "56",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Bến Tre",
      "state_code": "50",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Bình Dương",
      "state_code": "57",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Bình Định",
      "state_code": "31",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Bình Phước",
      "state_code": "58",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Bình Thuận",
      "state_code": "40",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Cà Mau",
      "state_code": "59",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Cần Thơ",
      "state_code": "CT",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Cao Bằng",
      "state_code": "04",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Đà Nẵng",
      "state_code": "DN",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Đắk Lắk",
      "state_code": "33",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Đắk Nông",
      "state_code": "72",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Điện Biên",
      "state_code": "71",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Đồng Nai",
      "state_code": "39",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Đồng Tháp",
      "state_code": "45",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Gia Lai",
      "state_code": "30",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Hà Giang",
      "state_code": "03",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Hà Nam",
      "state_code": "63",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Hà Nội",
      "state_code": "HN",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Hà Tĩnh",
      "state_code": "23",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Hải Dương",
      "state_code": "61",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Hải Phòng",
      "state_code": "HP",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Hậu Giang",
      "state_code": "73",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Hồ Chí Minh",
      "state_code": "SG",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Hòa Bình",
      "state_code": "14",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Hưng Yên",
      "state_code": "66",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Khánh Hòa",
      "state_code": "34",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Kiên Giang",
      "state_code": "47",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Kon Tum",
      "state_code": "28",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Lai Châu",
      "state_code": "01",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Lâm Đồng",
      "state_code": "35",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Lạng Sơn",
      "state_code": "09",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Lào Cai",
      "state_code": "02",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Long An",
      "state_code": "41",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Nam Định",
      "state_code": "67",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Nghệ An",
      "state_code": "22",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Ninh Bình",
      "state_code": "18",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Ninh Thuận",
      "state_code": "36",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Phú Thọ",
      "state_code": "68",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Phú Yên",
      "state_code": "32",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Quảng Bình",
      "state_code": "24",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Quảng Nam",
      "state_code": "27",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Quảng Ngãi",
      "state_code": "29",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Quảng Ninh",
      "state_code": "13",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Quảng Trị",
      "state_code": "25",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Sóc Trăng",
      "state_code": "52",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Sơn La",
      "state_code": "05",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Tây Ninh",
      "state_code": "37",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Thái Bình",
      "state_code": "20",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Thái Nguyên",
      "state_code": "69",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Thanh Hóa",
      "state_code": "21",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Thừa Thiên-Huế",
      "state_code": "26",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Tiền Giang",
      "state_code": "46",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Trà Vinh",
      "state_code": "51",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Tuyên Quang",
      "state_code": "07",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Vĩnh Long",
      "state_code": "49",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Vĩnh Phúc",
      "state_code": "70",
      "country_id": 240
    },
    {
      "country_code": "VN",
      "country_name": "Vietnam",
      "name": "Yên Bái",
      "state_code": "06",
      "country_id": 240
    },
    {
      "country_code": "VI",
      "country_name": "Virgin Islands (US)",
      "name": "Saint Croix",
      "state_code": "SC",
      "country_id": 242
    },
    {
      "country_code": "VI",
      "country_name": "Virgin Islands (US)",
      "name": "Saint John",
      "state_code": "SJ",
      "country_id": 242
    },
    {
      "country_code": "VI",
      "country_name": "Virgin Islands (US)",
      "name": "Saint Thomas",
      "state_code": "ST",
      "country_id": 242
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "'Adan",
      "state_code": "AD",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "'Amran",
      "state_code": "AM",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Abyan",
      "state_code": "AB",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Al Bayda'",
      "state_code": "BA",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Al Hudaydah",
      "state_code": "HU",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Al Jawf",
      "state_code": "JA",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Al Mahrah",
      "state_code": "MR",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Al Mahwit",
      "state_code": "MW",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Dhamar",
      "state_code": "DH",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Hadhramaut",
      "state_code": "HD",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Hajjah",
      "state_code": "HJ",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Ibb",
      "state_code": "IB",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Lahij",
      "state_code": "LA",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Ma'rib",
      "state_code": "MA",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Raymah",
      "state_code": "RA",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Saada",
      "state_code": "SD",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Sana'a",
      "state_code": "SN",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Sana'a",
      "state_code": "SA",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Shabwah",
      "state_code": "SH",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Socotra",
      "state_code": "SU",
      "country_id": 245
    },
    {
      "country_code": "YE",
      "country_name": "Yemen",
      "name": "Ta'izz",
      "state_code": "TA",
      "country_id": 245
    },
    {
      "country_code": "ZM",
      "country_name": "Zambia",
      "name": "Central Province",
      "state_code": "02",
      "country_id": 246
    },
    {
      "country_code": "ZM",
      "country_name": "Zambia",
      "name": "Copperbelt Province",
      "state_code": "08",
      "country_id": 246
    },
    {
      "country_code": "ZM",
      "country_name": "Zambia",
      "name": "Eastern Province",
      "state_code": "03",
      "country_id": 246
    },
    {
      "country_code": "ZM",
      "country_name": "Zambia",
      "name": "Luapula Province",
      "state_code": "04",
      "country_id": 246
    },
    {
      "country_code": "ZM",
      "country_name": "Zambia",
      "name": "Lusaka Province",
      "state_code": "09",
      "country_id": 246
    },
    {
      "country_code": "ZM",
      "country_name": "Zambia",
      "name": "Muchinga Province",
      "state_code": "10",
      "country_id": 246
    },
    {
      "country_code": "ZM",
      "country_name": "Zambia",
      "name": "Northern Province",
      "state_code": "05",
      "country_id": 246
    },
    {
      "country_code": "ZM",
      "country_name": "Zambia",
      "name": "Northwestern Province",
      "state_code": "06",
      "country_id": 246
    },
    {
      "country_code": "ZM",
      "country_name": "Zambia",
      "name": "Southern Province",
      "state_code": "07",
      "country_id": 246
    },
    {
      "country_code": "ZM",
      "country_name": "Zambia",
      "name": "Western Province",
      "state_code": "01",
      "country_id": 246
    },
    {
      "country_code": "ZW",
      "country_name": "Zimbabwe",
      "name": "Bulawayo Province",
      "state_code": "BU",
      "country_id": 247
    },
    {
      "country_code": "ZW",
      "country_name": "Zimbabwe",
      "name": "Harare Province",
      "state_code": "HA",
      "country_id": 247
    },
    {
      "country_code": "ZW",
      "country_name": "Zimbabwe",
      "name": "Manicaland",
      "state_code": "MA",
      "country_id": 247
    },
    {
      "country_code": "ZW",
      "country_name": "Zimbabwe",
      "name": "Mashonaland Central Province",
      "state_code": "MC",
      "country_id": 247
    },
    {
      "country_code": "ZW",
      "country_name": "Zimbabwe",
      "name": "Mashonaland East Province",
      "state_code": "ME",
      "country_id": 247
    },
    {
      "country_code": "ZW",
      "country_name": "Zimbabwe",
      "name": "Mashonaland West Province",
      "state_code": "MW",
      "country_id": 247
    },
    {
      "country_code": "ZW",
      "country_name": "Zimbabwe",
      "name": "Masvingo Province",
      "state_code": "MV",
      "country_id": 247
    },
    {
      "country_code": "ZW",
      "country_name": "Zimbabwe",
      "name": "Matabeleland North Province",
      "state_code": "MN",
      "country_id": 247
    },
    {
      "country_code": "ZW",
      "country_name": "Zimbabwe",
      "name": "Matabeleland South Province",
      "state_code": "MS",
      "country_id": 247
    },
    {
      "country_code": "ZW",
      "country_name": "Zimbabwe",
      "name": "Midlands Province",
      "state_code": "MI",
      "country_id": 247
    }
  ];
